// Manager portal translations
// Auto-extracted from LanguageContext.tsx

export const managerTranslations = {
  fr: {
  'manager.dashboard.welcome': 'Bonjour, {name} !',
  'manager.dashboard.subtitle': "Vue d'ensemble de l'activité de la pourvoirie.",
  'manager.dashboard.totalReservations': 'Réservations totales',
  'manager.dashboard.occupancyRate': "Taux d'occupation",
  'manager.dashboard.monthlyRevenue': 'Revenus ce mois',
  'manager.dashboard.upcomingArrivals': 'Arrivées à venir',
  'manager.dashboard.recentReservations': 'Réservations récentes',
  'manager.dashboard.viewAll': 'Voir tout',
  'manager.dashboard.maintenanceAlerts': 'Alertes maintenance',
  'manager.dashboard.quickActions': 'Actions rapides',
  'manager.dashboard.newReservation': 'Nouvelle réservation',
  'manager.dashboard.manageAccommodations': 'Gérer les hébergements',
  'manager.dashboard.viewReports': 'Voir les rapports',
  'manager.dashboard.occupancyOverview': "Vue d'occupation",
  'manager.dashboard.noReservationsYet': 'Aucune réservation',
  'manager.dashboard.noPendingReservations': 'Aucune réservation en attente',
  'manager.dashboard.noAccommodationsConfigured': 'Aucun hébergement configuré',
  'manager.dashboard.confirmed': 'Confirmée',
  'manager.dashboard.pending': 'En attente',
  'manager.dashboard.pendingSidebarTitle': 'En attente',
  'manager.dashboard.cancelled': 'Annulée',
  'manager.dashboard.urgent': 'Urgent',
  'manager.dashboard.medium': 'Moyen',
  'manager.dashboard.low': 'Faible',
  'manager.dashboard.available': 'Disponible',
  'manager.dashboard.occupied': 'Occupé',
  'manager.dashboard.selectStayProduct': 'Séjour',
  'manager.dashboard.calendarViewAllTypes': 'Tous les types',
  'manager.dashboard.calendarViewSingleStay': 'Par séjour',
  'manager.dashboard.filterStayType': 'Type de séjour',
  'manager.dashboard.filterAllTypes': 'Tous les types',
  'manager.dashboard.filterProduct': 'Produit',
  'manager.dashboard.filterAllProducts': 'Tous les produits',
  'manager.dashboard.filterProductHint': 'Choisissez un type pour afficher les séjours.',
  'manager.dashboard.calendarCreateOrderHint':
    'Cliquez une date pour voir les séjours disponibles, puis utilisez « Nouvelle commande » pour réserver.',
  'manager.dashboard.calendarExpandHint':
    'Cliquez une date pour développer et voir tous les séjours disponibles. Cliquez à nouveau pour réduire.',
  'manager.dashboard.calendarClickToSeeAll': 'Cliquez pour tout voir',
  'manager.dashboard.calendarProductFlowHint':
    '1) Cliquez une date pour développer · 2) Survolez un séjour pour les détails · 3) Cliquez le séjour pour créer une commande.',
  'manager.dashboard.calendarTypeFlowHint':
    '1) Cliquez une date pour développer · 2) Survolez un type · 3) Cliquez le type pour ouvrir son calendrier.',
  'manager.dashboard.calendarTypeClickHint': 'Cliquez pour voir ce type',
  'manager.dashboard.calendarCollapseHint': 'Cliquez pour réduire',
  'manager.dashboard.calendarMoreProducts': 'autres',
  'manager.dashboard.calendarProductClickHint': 'Cliquez pour créer une commande',
  'manager.dashboard.calendarConfirmNewOrderTitle': 'Créer une nouvelle commande ?',
  'manager.dashboard.calendarConfirmNewOrderBody':
    'Ouvrir une nouvelle commande pour « {name} » le {date} ?',
  'manager.dashboard.calendarConfirmYes': 'Oui',
  'manager.dashboard.calendarConfirmNo': 'Non',
  'manager.dashboard.calendarNewOrder': 'Nouvelle commande',
  'manager.dashboard.calendarLegendAvailable': 'Disponible',
  'manager.dashboard.calendarLegendBooked': 'Réservé',
  'manager.dashboard.calendarLegendLocked': 'Réservation temporaire',
  'manager.dashboard.calendarSameAsWebsite': 'Même calendrier que sur le site public (stays.availability).',
  'manager.dashboard.manageSelectedStay': 'Gérer ce séjour',
  'manager.dashboard.bookForClient': 'Réserver pour un client',
  'manager.dashboard.bookForClientSuccess': 'Réservation enregistrée.',
  'manager.dashboard.bookForClientPaymentLinkSuccess':
    'Réservation créée — lien de paiement envoyé au client par courriel.',
  'manager.accommodations.title': 'Gestion des hébergements',
  'manager.accommodations.subtitle': 'Gérez tous vos hébergements et leurs disponibilités',
  'manager.accommodations.addNew': 'Ajouter un hébergement',
  'manager.accommodations.totalAccommodations': 'Total hébergements',
  'manager.accommodations.averagePrice': 'Prix moyen',
  'manager.accommodations.edit': 'Modifier',
  'manager.accommodations.delete': 'Supprimer',
  'manager.accommodations.viewCalendar': 'Voir le calendrier',
  'manager.accommodations.status': 'Statut',
  'manager.accommodations.price': 'Prix',
  'manager.accommodations.capacity': 'Capacité',
  'manager.accommodations.location': 'Emplacement',
  'manager.accommodations.amenities': 'Équipements',
  'manager.accommodations.actions': 'Actions',
  'manager.accommodations.search': 'Rechercher un hébergement...',
  'manager.accommodations.filterByType': 'Filtrer par type',
  'manager.accommodations.filterByStatus': 'Filtrer par statut',
  'manager.accommodations.allTypes': 'Tous les types',
  'manager.accommodations.allStatus': 'Tous les statuts',
  'manager.accommodations.chalet': 'Chalet',
  'manager.accommodations.yourte': 'Yourte',
  'manager.accommodations.cabane': 'Cabane',
  'manager.accommodations.tente': 'Tente',
  'manager.accommodations.available': 'Disponible',
  'manager.accommodations.occupied': 'Occupé',
  'manager.accommodations.maintenance': 'Maintenance',
  'manager.accommodations.units': 'Unités en rangée',
  'manager.accommodations.pricing': 'Tarification',
  'manager.accommodations.basePrice': 'Prix de base',
  'manager.accommodations.basePriceDesc': 'Prix par défaut si les prix semaine/fin de semaine ne sont pas définis',
  'manager.accommodations.weekdayPrice': 'Prix semaine',
  'manager.accommodations.weekdayPriceDesc': 'Prix pour les jours de semaine (lundi-vendredi)',
  'manager.accommodations.weekendPrice': 'Prix fin de semaine',
  'manager.accommodations.weekendPriceDesc': 'Prix pour les fins de semaine (samedi-dimanche)',
  'manager.accommodations.weekday': 'Semaine',
  'manager.accommodations.weekend': 'Fin de semaine',
  'manager.accommodations.amenitiesDesc': 'Sélectionnez les équipements disponibles dans cet hébergement (ex: foyer, quai, cuisine, etc.)',
  'manager.accommodations.images': 'Images',
  'manager.accommodations.uploadImages': 'Télécharger des images',
  'manager.accommodations.noAccommodations': 'Aucun hébergement trouvé',
  'manager.accommodations.customizeColumns': 'Colonnes',
  'manager.accommodations.customizeColumnsDesc': 'Choisissez les colonnes à afficher et leur ordre',
  'manager.accommodations.dragToReorder': 'Glissez pour réorganiser les colonnes',
  'manager.accommodations.showColumn': 'Afficher la colonne',
  'manager.accommodations.hideColumn': 'Masquer la colonne',
  'manager.accommodations.resetToDefault': 'Réinitialiser',
  'manager.reservations.title': 'Gestion des réservations',
  'manager.reservations.subtitle': 'Gérez toutes les réservations et suivez leur statut',
  'manager.reservations.totalReservations': 'Total réservations',
  'manager.reservations.confirmed': 'Confirmées',
  'manager.reservations.pending': 'En attente',
  'manager.reservations.cancelled': 'Annulées',
  'manager.reservations.completed': 'Terminées',
  'manager.reservations.totalRevenue': 'Revenus totaux',
  'manager.reservations.search': 'Rechercher une réservation...',
  'manager.reservations.filterByStatus': 'Filtrer par statut',
  'manager.reservations.filterByDate': 'Filtrer par date',
  'manager.reservations.allStatus': 'Tous les statuts',
  'manager.reservations.guestName': 'Nom du client',
  'manager.reservations.accommodation': 'Hébergement',
  'manager.reservations.checkIn': 'Arrivée',
  'manager.reservations.checkOut': 'Départ',
  'manager.reservations.dates': 'Dates',
  'manager.reservations.guests': 'Personnes',
  'manager.reservations.payment': 'Paiement',
  'manager.reservations.totalPrice': 'Prix total',
  'manager.reservations.status': 'Statut',
  'manager.reservations.actions': 'Actions',
  'manager.reservations.confirm': 'Confirmer',
  'manager.reservations.cancel': 'Annuler',
  'manager.reservations.viewDetails': 'Voir les détails',
  'manager.reservations.editReservation': 'Modifier la réservation',
  'manager.reports.title': 'Rapports et analyses',
  'manager.reports.subtitle': 'Analysez les performances et générez des rapports',
  'manager.reports.revenueReport': 'Rapport de revenus',
  'manager.reports.guestReport': 'Rapport des clients',
  'manager.reports.monthlyReport': 'Rapport mensuel',
  'manager.reports.yearlyReport': 'Rapport annuel',
  'manager.reports.exportData': 'Exporter les données',
  'manager.reports.generateReport': 'Générer le rapport',
  'manager.reports.selectPeriod': 'Sélectionner la période',
  'manager.reports.fromDate': 'Date de début',
  'manager.reports.toDate': 'Date de fin',
  'manager.reports.reportType': 'Type de rapport',
  'manager.reports.occupancy': 'Occupation',
  'manager.reports.revenue': 'Revenus',
  'manager.reports.guests': 'Clients',
  'manager.reports.activities': 'Activités',
  'manager.crm.title': 'Gestion des clients',
  'manager.crm.subtitle': 'Gérez votre base de données clients et leurs préférences',
  'manager.crm.totalClients': 'Total clients',
  'manager.crm.newClients': 'Nouveaux clients',
  'manager.crm.returningClients': 'Clients récurrents',
  'manager.crm.vipClients': 'Clients VIP',
  'manager.crm.search': 'Rechercher un client...',
  'manager.crm.filterByType': 'Filtrer par type',
  'manager.crm.allTypes': 'Tous les types',
  'manager.crm.new': 'Nouveau',
  'manager.crm.returning': 'Récurrent',
  'manager.crm.vip': 'VIP',
  'manager.crm.clientName': 'Nom du client',
  'manager.crm.email': 'Email',
  'manager.crm.phone': 'Téléphone',
  'manager.crm.lastVisit': 'Dernière visite',
  'manager.crm.totalBookings': 'Total réservations',
  'manager.crm.totalSpent': 'Total dépensé',
  'manager.crm.status': 'Statut',
  'manager.crm.actions': 'Actions',
  'manager.crm.viewProfile': 'Voir le profil',
  'manager.crm.editClient': 'Modifier le client',
  'manager.crm.sendEmail': 'Envoyer un email',
  'manager.crm.addNote': 'Ajouter une note',
  'manager.crm.clientDetails': 'Détails du client',
  'manager.crm.bookingHistory': 'Historique des réservations',
  'manager.crm.preferences': 'Préférences',
  'manager.crm.notes': 'Notes',
  'manager.marketing.title': 'Marketing et promotions',
  'manager.marketing.subtitle': 'Gérez vos campagnes marketing et promotions',
  'manager.marketing.maintenanceTitle': 'Section en mise à jour',
  'manager.marketing.maintenanceBody':
    'La page Marketing est en cours de refonte. Les anciens écrans de démonstration (campagnes / promotions) sont archivés et ne sont plus affichés ici.',
  'manager.marketing.maintenanceBundlesHint':
    'Pour gérer les forfaits et le catalogue (repas et produits liés aux bundles), utilisez la section Forfaits.',
  'manager.marketing.maintenanceBundlesLink': 'Ouvrir la gestion des forfaits',
  'manager.marketing.legacyIntroTitle': 'Marketing — démonstration (hors VUM)',
  'manager.marketing.legacyIntroBody':
    'Ci-dessous : l’ancienne interface de démo (campagnes et codes promotionnels fictifs, non liés à promovalidation.com). Pour les forfaits et le catalogue, utilisez Forfaits ; pour les codes de remise du site, Remises. Les codes VUM se gèrent sous Opérations → Codes VUM.',
  'manager.marketing.search': 'Rechercher…',
  'manager.marketing.allTypes': 'Tous les types',
  'manager.marketing.activeCampaigns': 'Campagnes actives',
  'manager.marketing.totalCampaigns': 'Total campagnes',
  'manager.marketing.emailCampaigns': 'Campagnes email',
  'manager.marketing.socialMedia': 'Réseaux sociaux',
  'manager.marketing.promotions': 'Promotions',
  'manager.marketing.createCampaign': 'Créer une campagne',
  'manager.marketing.createPromotion': 'Créer une promotion',
  'manager.marketing.campaignName': 'Nom de la campagne',
  'manager.marketing.campaignType': 'Type de campagne',
  'manager.marketing.startDate': 'Date de début',
  'manager.marketing.endDate': 'Date de fin',
  'manager.marketing.status': 'Statut',
  'manager.marketing.actions': 'Actions',
  'manager.marketing.email': 'Email',
  'manager.marketing.social': 'Social',
  'manager.marketing.discount': 'Remise',
  'manager.marketing.specialOffer': 'Offre spéciale',
  'manager.marketing.active': 'Active',
  'manager.marketing.paused': 'En pause',
  'manager.marketing.completed': 'Terminée',
  'manager.marketing.editCampaign': 'Modifier la campagne',
  'manager.marketing.deleteCampaign': 'Supprimer la campagne',
  'manager.marketing.viewStats': 'Voir les statistiques',
  'manager.marketing.promotionCode': 'Code promotion',
  'manager.marketing.discountPercentage': 'Pourcentage de remise',
  'manager.marketing.minimumStay': 'Séjour minimum',
  'manager.marketing.validFrom': 'Valide du',
  'manager.marketing.usedCount': 'Utilisé',
  'manager.marketing.remainingUses': 'Restant',
  'manager.sections.operations': 'Gestion des opérations',
  'manager.sections.people': 'Gestion des personnes',
  'manager.sections.financial': 'Finances',
  'manager.sections.system': 'Gestion du système',
  'manager.sections.archived': 'Archivé (pour plus tard)',
  'manager.operations.vumCodesNav': 'Codes VUM',
  'manager.stays.title': 'Gestion des séjours',
  'manager.stays.navLabel': 'Séjours',
  'manager.stays.subtitle': 'Gérez tous vos hébergements et leurs disponibilités',
  'manager.stays.listLoading': 'Chargement des hébergements…',
  'manager.stays.loadedFromConvex': 'Hébergements dans la base Convex actuelle : {count}',
  'manager.stays.convexDeploymentProd': 'Déploiement Convex (production) : {url}',
  'manager.stays.seasonFilterNotice':
    'Filtre saison : {shown} sur {total} hébergements. Utilisez l\'onglet « Toute l\'année » pour tout afficher.',
  'manager.stays.addStay': 'Ajouter un séjour',
  'manager.stays.totalStays': 'Total séjours',
  'manager.stays.available': 'Disponibles',
  'manager.stays.unavailable': 'Indisponibles',
  'manager.stays.averagePrice': 'Prix moyen',
  'manager.stays.name': 'Nom',
  'manager.stays.type': 'Type',
  'manager.stays.location': 'Emplacement',
  'manager.stays.capacity': 'Capacité',
  'manager.stays.price': 'Prix',
  'manager.stays.priceBeforeTax': 'Prix (avant taxes)',
  'manager.stays.tpsColumn': 'TPS (5 %)',
  'manager.stays.tvqColumn': 'TVQ (9,975 %)',
  'manager.stays.taxeHebergementColumn': 'Tx héb. (3,50 $ / nuit)',
  'manager.stays.pricingTaxSection': 'Tarification et taxes',
  'manager.stays.taxeHebergementToggle':
    'Taxe d\'hébergement (3,50 $ par nuit, forfaitaire)',
  'manager.stays.taxeHebergementHint':
    'Si cette case est cochée, 3,50 $ par nuit est ajouté (indépendamment du tarif) ; la TPS et la TVQ s\'appliquent chacune sur (tarif + taxe d\'hébergement), sans que la TVQ porte sur la TPS.',
  'manager.stays.clientTotalColumn': 'Total client',
  'manager.stays.cadBeforeTax': 'CAD (avant taxes)',
  'manager.stays.cadSuffix': 'CAD',
  'manager.stays.pricingTaxFootnote':
    'Affichage indicatif : taxe d\'hébergement 3,50 $ par nuit (forfaitaire) si activée ; TPS 5 % et TVQ 9,975 % chacune sur (tarif + taxe d\'hébergement), sans que la TVQ s\'applique sur la TPS. Arrondi au centime à chaque étape.',
  'manager.stays.pricePerNight': 'Prix par nuit par personne',
  'manager.stays.pricePerNightHint': 'Tarif avant taxes, par personne et par nuit. Les clients ne le voient que si la réservation en ligne est autorisée.',
  'manager.stays.allowReservation': 'Autoriser la réservation en ligne',
  'manager.stays.allowReservationHint':
    'Si cette case est cochée, les clients voient le prix et peuvent réserver ce séjour. Sinon, le séjour est affiché à titre informatif seulement.',
  'manager.stays.allowReservationColumn': 'Réservation en ligne',
  'manager.stays.availability': 'Disponibilité',
  'manager.stays.closingDates': 'Jours de fermeture',
  'manager.stays.closingDatesDesc': 'Définissez les plages de dates pendant lesquelles ce séjour est fermé (non réservable). Les jours non assignés sont disponibles par défaut.',
  'manager.stays.stored': 'Enregistré',
  'manager.stays.status': 'Statut',
  'manager.stays.sales': 'Ventes',
  'manager.stays.marketingLabels': 'Labels marketing',
  'manager.stays.editInDetails': 'Modifier en détail',
  'manager.stays.clickToEdit': 'Cliquer pour modifier',
  'manager.stays.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cet hébergement ?',
  'manager.stays.seasons': 'saisons',
  'manager.stays.noPeriods': 'Aucune période',
  'manager.stays.fullYearAvailable': 'Disponible toute l\'année',
  'manager.stays.noLabels': 'Aucun label',
  'manager.stays.seasonName': 'Nom de la saison',
  'manager.stays.addPeriod': 'Ajouter une période',
  'manager.stays.marketingLabel.couple': 'Couple',
  'manager.stays.marketingLabel.family': 'Famille',
  'manager.stays.marketingLabel.corporate': 'Entreprise',
  'manager.stays.predefinedLabels': 'Labels prédéfinis',
  'manager.stays.customLabels': 'Labels personnalisés',
  'manager.stays.addCustomLabel': 'Ajouter un label personnalisé',
  'manager.stays.basicInformation': 'Informations de base',
  'manager.stays.descriptionSection': 'Description',
  'manager.stays.pageDescription': 'Description sur la page',
  'manager.stays.pageDescriptionPlaceholder': 'Description détaillée à afficher sur la page publique',
  'manager.stays.zoneInMap': 'Zone sur la carte',
  'manager.stays.zoneInMapLabel': 'Zone',
  'manager.stays.zoneInMapPlaceholder': 'Ex: Zone A, Secteur Nord, etc.',
  'manager.stays.zoneNumberLabel': 'Numéro de zone',
  'manager.stays.zoneNumberPlaceholder': 'Ex: 12, A-3, etc.',
  'manager.stays.indoorChecklist': 'Checklist intérieur',
  'manager.stays.outdoorChecklist': 'Checklist extérieur',
  'manager.stays.kitchenEquipments': 'Équipements de cuisine',
  'manager.stays.addEquipment': 'Ajouter un équipement',
  'manager.stays.bathroomSetup': 'Configuration de la salle de bain',
  'manager.stays.addBathroomItem': 'Ajouter un élément',
  'manager.stays.beds': 'Lits',
  'manager.stays.bedType': 'Type de lit (ex: Queen, Double)',
  'manager.stays.bedCount': 'Nombre',
  'manager.stays.petFriendly': 'Animaux acceptés',
  'manager.stays.bbq': 'Barbecue',
  'manager.stays.gardenTable': 'Table de jardin',
  'manager.stays.numberOfChairs': 'Nombre de chaises',
  'manager.stays.privateDockForBoat': 'Quai privé pour bateau',
  'manager.stays.images': 'Images',
  'manager.stays.addImageUrl': 'Entrez l\'URL de l\'image...',
  'manager.stays.image': 'Image',
  'manager.stays.noImages': 'Aucune image ajoutée',
  'manager.stays.uploadFile': 'Télécharger fichier',
  'manager.stays.enterUrl': 'Entrer URL',
  'manager.stays.clickToUpload': 'Cliquez pour télécharger',
  'manager.stays.orDragDrop': 'ou glisser-déposer',
  'manager.stays.urlHint': 'Astuce: Les liens Google Drive sont automatiquement convertis en URLs d\'image directes',
  'manager.stays.seasonTabs.all': 'Toute l\'année',
  'manager.stays.seasonTabs.summer': 'Été',
  'manager.stays.seasonTabs.winter': 'Hiver',
  'manager.stays.seasonSettings': 'Paramètres de saison',
  'manager.stays.maintenancePeriods': 'Périodes de maintenance',
  'manager.stays.maintenancePeriodsDesc': 'Pendant ces périodes, l\'entreprise est fermée et rien n\'est disponible',
  'manager.stays.maintenanceStartDate': 'Date de début',
  'manager.stays.maintenanceEndDate': 'Date de fin',
  'manager.stays.maintenanceDescription': 'Description',
  'manager.stays.maintenanceDescriptionPlaceholder': 'Ex: Fermeture annuelle, Rénovations, etc.',
  'manager.stays.addMaintenancePeriod': 'Ajouter une période de maintenance',
  'manager.stays.seasonStartDate': 'Date de début',
  'manager.stays.seasonEndDate': 'Date de fin',
  'manager.stays.seasonFilter.all': 'Toutes les saisons',
  'manager.stays.seasonFilter.summer': 'Été',
  'manager.stays.seasonFilter.winter': 'Hiver',
  'manager.stays.copyPeriod': 'Copier la période',
  'manager.stays.pastePeriod': 'Coller la période',
  'manager.stays.removePeriod': 'Supprimer la période',
  'manager.stays.autoDetected': 'Détection automatique',
  'manager.stays.noPeriodCopied': 'Aucune période copiée',
  'manager.stays.unavailableDatesDesc': 'Définissez les plages de dates pendant lesquelles ce séjour n\'est pas réservable. Les jours non assignés sont disponibles par défaut.',
  'manager.stays.addUnavailableRange': 'Ajouter une plage indisponible',
  'manager.stays.allDaysAvailable': 'Tous les jours disponibles',
  'manager.stays.scheduleMoreCount': '+{{count}} de plus',
  'manager.stays.archivedOpeningPeriodsTitle': 'Archives — périodes d\'ouverture',
  'manager.stays.archivedOpeningPeriodsDesc':
    'Les périodes d\'ouverture sont gérées ici (hors tableau principal), comme les éléments archivés dans la barre latérale.',
  'manager.stays.scheduleSaveFailed':
    'Enregistrement impossible. Vérifiez les dates et réessayez. Si le problème persiste, ouvrez la console (F12) pour le détail.',
  'manager.activities.title': 'Gestion des activités',
  'manager.activities.navLabel': 'Activités',
  'manager.activities.subtitle': 'Gérez toutes vos activités et leurs disponibilités',
  'manager.activities.crossLinksHint': 'Liens rapides : catalogue web et forfaits.',
  'manager.activities.publicCatalogLink': 'Catalogue public (site)',
  'manager.activities.bundlesLink': 'Gestion des forfaits',
  'manager.food.publicForfaitsLink': 'Forfaits sur le site web',
  'manager.activities.addActivity': 'Ajouter une activité',
  'manager.activities.totalActivities': 'Total activités',
  'manager.activities.available': 'Disponibles',
  'manager.activities.unavailable': 'Indisponibles',
  'manager.activities.totalCapacity': 'Capacité totale',
  'manager.activities.averagePrice': 'Prix moyen',
  'manager.activities.averagePriceBeforeTax': 'Prix moyen (avant taxes)',
  'manager.activities.pricingTaxFootnote':
    'Le prix affiché est hors taxes. TPS 5 % et TVQ 9,975 % s’appliquent chacune sur ce prix (la TVQ ne s’applique pas sur la TPS). Aucune taxe d’hébergement sur les activités.',
  'manager.activities.priceBeforeTaxLabel': 'Prix (avant taxes) *',
  'manager.activities.name': 'Nom',
  'manager.activities.type': 'Type',
  'manager.activities.duration': 'Durée',
  'manager.activities.capacity': 'Capacité',
  'manager.activities.price': 'Prix',
  'manager.activities.availability': 'Disponibilité',
  'manager.activities.status': 'Statut',
  'manager.activities.sales': 'Ventes',
  'manager.activities.marketingLabels': 'Étiquettes marketing',
  'manager.activities.archivedOpeningPeriodsTitle': 'Archives — périodes d\'ouverture (activités)',
  'manager.activities.archivedOpeningPeriodsDesc':
    'Les périodes d\'ouverture des activités sont gérées ici, hors tableau principal (comme pour les séjours).',
  'manager.activities.editInDetails': 'Modifier en détail',
  'manager.activities.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cette activité ?',
  'manager.activities.clickToEdit': 'Cliquez pour modifier',
  'manager.activities.seasons': 'saisons',
  'manager.activities.noPeriods': 'Aucune période',
  'manager.activities.noLabels': 'Aucune étiquette',
  'manager.activities.seasonName': 'Nom de la saison',
  'manager.activities.addPeriod': 'Ajouter une période',
  'manager.activities.predefinedLabels': 'Étiquettes prédéfinies',
  'manager.activities.customLabels': 'Étiquettes personnalisées',
  'manager.activities.addCustomLabel': 'Ajouter une étiquette personnalisée',
  'manager.activities.marketingLabel.couple': 'Couple',
  'manager.activities.marketingLabel.family': 'Famille',
  'manager.activities.marketingLabel.corporate': 'Entreprise',
  'manager.activities.basicInformation': 'Informations de base',
  'manager.activities.descriptionSection': 'Description',
  'manager.activities.pageDescription': 'Description sur la page',
  'manager.activities.zoneInMap': 'Zone sur la carte',
  'manager.activities.zoneInMapLabel': 'Zone sur la carte',
  'manager.activities.zoneInMapPlaceholder': 'Entrez la zone sur la carte',
  'manager.activities.equipment': 'Équipement',
  'manager.activities.addEquipment': 'Ajouter un équipement',
  'manager.activities.indoorChecklist': 'Liste de vérification intérieure',
  'manager.activities.kitchenEquipments': 'Équipements de cuisine',
  'manager.activities.bathroomSetup': 'Configuration de la salle de bain',
  'manager.activities.beds': 'Lits',
  'manager.activities.bedType': 'Type de lit',
  'manager.activities.bedCount': 'Nombre',
  'manager.activities.petFriendly': 'Animaux acceptés',
  'manager.activities.outdoorChecklist': 'Liste de vérification extérieure',
  'manager.activities.bbq': 'Barbecue',
  'manager.activities.gardenTable': 'Table de jardin',
  'manager.activities.numberOfChairs': 'Nombre de chaises',
  'manager.activities.privateDockForBoat': 'Quai privé pour bateau',
  'manager.activities.addBathroomItem': 'Ajouter un élément',
  'manager.activities.typeSummer': 'Été',
  'manager.activities.typeWinter': 'Hiver',
  'manager.activities.typeFall': 'Automne',
  'manager.activities.durationPlaceholder': 'Ex: 4 heures, journée complète',
  'manager.activities.seasonTabs.all': 'Toute l\'année',
  'manager.activities.seasonTabs.summer': 'Été',
  'manager.activities.seasonTabs.winter': 'Hiver',
  'manager.activities.seasonSettings': 'Paramètres de saison',
  'manager.activities.seasonStartDate': 'Date de début',
  'manager.activities.seasonEndDate': 'Date de fin',
  'manager.activities.seasonFilter.all': 'Toutes les saisons',
  'manager.activities.seasonFilter.summer': 'Été',
  'manager.activities.seasonFilter.winter': 'Hiver',
  'manager.activities.copyPeriod': 'Copier la période',
  'manager.activities.pastePeriod': 'Coller la période',
  'manager.activities.removePeriod': 'Supprimer la période',
  'manager.activities.autoDetected': 'Détection automatique',
  'manager.activities.noPeriodCopied': 'Aucune période copiée',
  'manager.activities.pricingRules': 'Règles de tarification',
  'manager.activities.minAge': 'Âge minimum',
  'manager.activities.maxAge': 'Âge maximum',
  'manager.activities.yearsOld': 'ans',
  'manager.activities.discount': 'Réduction',
  'manager.activities.descriptionOptional': 'Description (optionnelle)',
  'manager.activities.addFreeGroup': 'Ajouter un groupe gratuit',
  'manager.activities.addDiscountGroup': 'Ajouter un groupe avec réduction',
  'manager.activities.includedServices': 'Services inclus',
  'manager.activities.nonIncludedServices': 'Services non inclus',
  'manager.activities.optionalPaidServices': 'Services payants optionnels',
  'manager.activities.clientTypes': 'Types de clients',
  'manager.activities.lodging': 'Clients avec hébergement',
  'manager.activities.nonLodging': 'Clients sans hébergement',
  'manager.activities.addIncludedService': 'Ajouter un service inclus',
  'manager.activities.addNonIncludedService': 'Ajouter un service non inclus',
  'manager.activities.addOptionalPaidService': 'Ajouter un service payant optionnel',
  'manager.food.title': 'Gestion de la restauration',
  'manager.food.navLabel': 'Restauration',
  'manager.food.subtitle': 'Gérez vos menus et articles alimentaires',
  'manager.food.devBannerTitle': 'Fonctionnalité en développement — démonstration',
  'manager.food.devBannerBody':
    'La gestion restauration centralisée n’est pas encore activée. Le tableau ci-dessous est une prévisualisation des produits repas issus des forfaits ; les boutons d’action restent désactivés. Pour configurer des repas, utilisez la gestion des forfaits.',
  'manager.food.devActionDisabled': 'Non disponible tant que la fonctionnalité n’est pas activée',
  'manager.food.devMockDataNote': 'Aperçu indicatif à partir des forfaits — données non finalisées.',
  'manager.food.addItem': 'Ajouter un article',
  'manager.food.totalItems': 'Total articles',
  'manager.food.available': 'Disponibles',
  'manager.food.totalStock': 'Stock total',
  'manager.food.averagePrice': 'Prix moyen',
  'manager.food.averagePriceBeforeTax': 'Prix moyen (avant taxes)',
  'manager.food.pricingTaxFootnote':
    'Le prix affiché est hors taxes. TPS 5 % et TVQ 9,975 % s’appliquent chacune sur ce prix (la TVQ ne s’applique pas sur la TPS). Aucune taxe d’hébergement sur la restauration au même titre que les autres biens taxables.',
  'manager.food.name': 'Nom',
  'manager.food.category': 'Catégorie',
  'manager.food.price': 'Prix',
  'manager.food.stock': 'Stock',
  'manager.food.availability': 'Disponibilité',
  'manager.food.loading': 'Chargement…',
  'manager.food.dataSourceTitle': 'Données synchronisées avec les forfaits',
  'manager.food.dataSourceBody':
    'Les articles « nourriture » proviennent des produits de type repas configurés dans vos forfaits (bundles). Pour ajouter ou modifier, ouvrez la gestion des forfaits.',
  'manager.food.openBundles': 'Ouvrir la gestion des forfaits',
  'manager.food.editInBundles': 'Modifier dans les forfaits',
  'manager.food.empty': 'Aucun produit alimentaire dans les forfaits pour le moment.',
  'manager.bundles.title': 'Gestion des forfaits',
  'manager.bundles.navLabel': 'Forfaits',
  'manager.bundles.subtitle': 'Gérez vos forfaits et promotions',
  'manager.bundles.addBundle': 'Ajouter un forfait',
  'manager.bundles.totalBundles': 'Total forfaits',
  'manager.bundles.popular': 'Populaires',
  'manager.bundles.averagePrice': 'Prix moyen',
  'manager.bundles.totalCapacity': 'Capacité totale',
  'manager.bundles.name': 'Nom',
  'manager.bundles.description': 'Description',
  'manager.bundles.price': 'Prix',
  'manager.bundles.maxGuests': 'Invités max',
  'manager.bundles.editBundle': 'Modifier le forfait',
  'manager.bundles.basicInformation': 'Informations de base',
  'manager.bundles.duration': 'Durée',
  'manager.bundles.days': 'jours',
  'manager.bundles.available': 'Disponible',
  'manager.bundles.products': 'Produits',
  'manager.bundles.productType': 'Type de produit',
  'manager.bundles.stays': 'Hébergements',
  'manager.bundles.activities': 'Activités',
  'manager.bundles.food': 'Nourriture',
  'manager.bundles.selectProduct': 'Sélectionner un produit',
  'manager.bundles.pricingType': 'Type de tarification',
  'manager.bundles.free': 'Gratuit',
  'manager.bundles.discount': 'Réduction',
  'manager.bundles.discountAmount': 'Montant de réduction',
  'manager.bundles.customPrice': 'Prix personnalisé',
  'manager.bundles.discountPercentage': 'Pourcentage de réduction',
  'manager.bundles.addProduct': 'Ajouter un produit',
  'manager.bundles.productAlreadyAdded': 'Ce produit a déjà été ajouté',
  'manager.bundles.noProducts': 'Aucun produit ajouté',
  'manager.bundles.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ce forfait ?',
  'manager.bundles.addNewProduct': 'Ajouter un nouveau produit',
  'manager.bundles.addNew': 'Nouveau',
  'manager.bundles.addNewStay': 'Ajouter un nouvel hébergement',
  'manager.bundles.addNewActivity': 'Ajouter une nouvelle activité',
  'manager.bundles.addNewFood': 'Ajouter un nouvel aliment',
  'manager.bundles.createAndSelect': 'Créer et sélectionner',
  'manager.bundles.openingPeriodsDescription': 'Définissez les périodes pendant lesquelles ce forfait est disponible',
  'manager.bundles.periodOfActivationDescription': 'Définissez la plage de validité de ce forfait créé',
  'manager.bundles.autoCalculated': 'Calculé automatiquement',
  'manager.bundles.priceCalculationNote': 'Le prix est calculé automatiquement en fonction des produits ajoutés et de leurs types de tarification',
  'manager.bundles.originalPrice': 'Prix original',
  'manager.bundles.youSave': 'Vous économisez',
  'manager.bundles.savingsPercentage': 'Économie de {{percentage}}%',
  'manager.bundles.numberOfPasses': 'Nombre de passes',
  'manager.bundles.numberOfConsumers': 'Nombre de consommateurs',
  'manager.bundles.passes': 'passes',
  'manager.bundles.consumers': 'consommateurs',
  'manager.bundles.matchClientGroupSize': 'Correspondre à la taille du groupe de clients',
  'manager.bundles.minimumClients': 'Nombre minimum de clients',
  'manager.bundles.minimumClientsPlaceholder': 'Ex: 2',
  'manager.bundles.discountTiers': 'Niveaux de remise',
  'manager.bundles.addDiscountTier': 'Ajouter un niveau de remise',
  'manager.bundles.minClients': 'Min',
  'manager.bundles.maxClients': 'Max',
  'manager.bundles.clients': 'clients',
  'manager.bundles.percentage': 'Pourcentage',
  'manager.bundles.amount': 'Montant',
  'manager.bundles.matchesClientGroup': 'Correspond au groupe',
  'manager.bundles.optional': 'Optionnel',
  'manager.bundles.packages': 'Forfaits',
  'manager.bundles.calendar': 'Calendrier des campagnes',
  'manager.bundle.calendar': 'Calendrier des forfaits',
  'manager.bundle.description': 'Planifiez et gérez vos campagnes de forfaits',
  'manager.bundle.createNew': 'Créer un forfait',
  'manager.bundle.editBundle': 'Modifier le forfait',
  'manager.bundle.bundleName': 'Nom du forfait',
  'manager.bundle.namePlaceholder': 'Ex : Forfait Aventure Été',
  'manager.bundle.color': 'Couleur',
  'manager.bundle.activeBundles': 'Forfaits actifs',
  'manager.bundle.noBundles': 'Aucun forfait créé',
  'manager.bundle.fillAllFields': 'Veuillez remplir tous les champs',
  'manager.bundle.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ce forfait ?',
  'manager.loyalty.pageTitle': 'Programme de fidélité',
  'manager.loyalty.pageSubtitle':
    'Configurez le ratio de points et les jalons affichés aux clients dans leur tableau de bord.',
  'manager.loyalty.settingsCardSubtitle': 'Ratio de points et jalons affichés aux clients',
  'manager.loyalty.ratioSectionTitle': 'Ratio de points',
  'manager.loyalty.pointsPerDollarLabel': 'Points accordés par dollar dépensé (avant taxes)',
  'manager.loyalty.pointsPerDollarHint': 'Ex. : 1 = 1 point par dollar, 2 = 2 points par dollar',
  'manager.loyalty.pointValueLabel': 'Valeur d\'un point en dollars (affiché au client)',
  'manager.loyalty.pointValueHint': 'Ex. : 0,10 = 1 point vaut 0,10 $',
  'manager.loyalty.unitPtPerDollar': 'pt / $',
  'manager.loyalty.unitCadPerPt': 'CAD / pt',
  'manager.loyalty.previewLine':
    'Aperçu : une réservation de 100 $ (avant taxes) rapporte {points} points, soit une valeur de {value} $ pour le client.',
  'manager.loyalty.milestonesTitle': 'Jalons (niveaux de fidélité)',
  'manager.loyalty.milestonesShortTitle': 'Jalons (milestones)',
  'manager.loyalty.addMilestone': 'Ajouter un jalon',
  'manager.loyalty.emptyMilestones':
    'Aucun jalon — cliquez « Ajouter un jalon » pour en créer.',
  'manager.loyalty.emptyMilestonesSettings': 'Aucun jalon — cliquez « Ajouter » pour en créer.',
  'manager.loyalty.thresholdPlaceholder': 'Points',
  'manager.loyalty.ptsArrow': 'pts →',
  'manager.loyalty.levelPlaceholder': 'Nom du niveau (ex. Bronze)',
  'manager.loyalty.milestonesSortHint':
    'Les jalons sont triés automatiquement par nombre de points croissant lors de la sauvegarde.',
  'manager.loyalty.saveSettings': 'Enregistrer les paramètres',
  'manager.loyalty.savedSettings': 'Enregistré ✓',
  'manager.loyalty.saveError': 'Erreur',
  'manager.discount.title': 'Gestion des remises',
  'manager.discount.navLabel': 'Remises',
  'manager.discount.archivedIntroTitle': 'Remises (démonstration archivée)',
  'manager.discount.archivedIntroBody':
    'Module historique : codes fictifs, remises conditionnelles et calendrier de campagne. Les données ne sont pas enregistrées dans Convex et ne s’appliquent pas au paiement. Pour les forfaits et tarifs catalogue, utilisez Forfaits ; pour les codes VUM, Codes VUM.',
  'manager.discount.subtitle': 'Gérez vos codes de réduction et promotions',
  'manager.discount.addDiscount': 'Ajouter une remise',
  'manager.discount.totalDiscounts': 'Total remises',
  'manager.discount.active': 'Actives',
  'manager.discount.percentage': 'Pourcentage',
  'manager.discount.fixed': 'Montant fixe',
  'manager.discount.name': 'Nom',
  'manager.discount.code': 'Code',
  'manager.discount.type': 'Type',
  'manager.discount.value': 'Valeur',
  'manager.discount.validFrom': 'Valide du',
  'manager.discount.status': 'Statut',
  'manager.discount.status.active': 'Active',
  'manager.discount.status.inactive': 'Inactive',
  'manager.discount.status.expired': 'Expirée',
  'manager.discount.editDiscount': 'Modifier la remise',
  'manager.discount.basicInfo': 'Informations de base',
  'manager.discount.conditions': 'Conditions',
  'manager.discount.validityPeriod': 'Période de validité',
  'manager.discount.minPurchase': 'Achat minimum',
  'manager.discount.maxDiscount': 'Remise maximale',
  'manager.discount.optional': 'Optionnel',
  'manager.discount.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cette remise ?',
  'manager.discount.codeManagement': 'Gestion des codes de réduction',
  'manager.discount.codeManagementDescription': 'Générez et gérez les codes de réduction pour vos promotions',
  'manager.discount.selectDiscount': 'Sélectionner une remise',
  'manager.discount.generateCodes': 'Générer des codes',
  'manager.discount.discountName': 'Nom de la remise',
  'manager.discount.generatedAt': 'Généré le',
  'manager.discount.usedAt': 'Utilisé le',
  'manager.discount.copyCode': 'Copier le code',
  'manager.discount.codeStatus.active': 'Actif',
  'manager.discount.codeStatus.used': 'Utilisé',
  'manager.discount.codeStatus.expired': 'Expiré',
  'manager.discount.confirmDeleteCode': 'Êtes-vous sûr de vouloir supprimer ce code ?',
  'manager.discount.volumeDiscount': 'Remise volumique/Conditionnelle',
  'manager.discount.conditionalDiscount': 'Remise conditionnelle',
  'manager.discount.addVolumeDiscount': 'Ajouter une remise volumique',
  'manager.discount.generalDiscount': 'Remise générale',
  'manager.discount.discountType': 'Type de remise',
  'manager.discount.discountValue': 'Valeur de la remise',
  'manager.discount.confirmDeleteVolumeDiscount': 'Êtes-vous sûr de vouloir supprimer cette remise volumique ?',
  'manager.discount.regularDiscounts': 'Remises régulières',
  'manager.discount.seasonTabs.summer': 'Été',
  'manager.discount.seasonTabs.winter': 'Hiver',
  'manager.discount.seasonSettings': 'Paramètres de saison',
  'manager.discount.effectiveProducts': 'Produits concernés',
  'manager.discount.effectiveProductsDescription': 'Sélectionnez les produits qui déclenchent cette remise conditionnelle',
  'manager.bookings.title': 'Réservations (commandes)',
  'manager.bookings.navLabel': 'Réservations',
  'manager.bookings.subtitle': 'Réservations hébergements. Modifiez le statut payé ci-dessous.',
  'manager.bookings.totalBookings': 'Total réservations',
  'manager.bookings.paidBookings': 'Payées',
  'manager.bookings.confirmed': 'Confirmées',
  'manager.bookings.guest': 'Client',
  'manager.bookings.accommodation': 'Hébergement',
  'manager.bookings.checkIn': 'Arrivée',
  'manager.bookings.checkOut': 'Départ',
  'manager.bookings.guests': 'Voyageurs',
  'manager.bookings.total': 'Total',
  'manager.bookings.paid': 'Payé',
  'manager.bookings.status': 'Statut',
  'manager.bookings.noBookings': 'Aucune réservation.',
  'manager.bookings.markPaid': 'Marquer payé',
  'manager.bookings.markUnpaid': 'Marquer non payé',
  'manager.orders.viewGuestProfile': 'Fiche client',
  'manager.orders.title': 'Gestion des commandes',
  'manager.orders.navLabel': 'Commandes',
  'manager.orders.subtitle': 'Gérez les commandes des clients, modifiez ou annulez des produits',
  'manager.orders.addOrder': 'Nouvelle commande',
  'manager.orders.addReservation': 'Nouvelle commande',
  'manager.orders.backFromNewOrder': 'Retour aux commandes',
  'manager.orders.backFromNewReservation': 'Retour aux commandes',
  'manager.orders.newOrderPageTitle': 'Nouvelle commande',
  'manager.orders.newOrderPageSubtitle':
    'Composez une commande pour un client : ajoutez hébergements, activités et forfaits, puis encaissez ou enregistrez sans paiement en ligne.',
  'manager.orders.newReservationPageTitle': 'Nouvelle commande',
  'manager.orders.newReservationPageSubtitle':
    'Composez une commande pour un client : ajoutez hébergements, activités et forfaits, puis encaissez ou enregistrez sans paiement en ligne.',
  'manager.orders.sectionProducts': 'Produits',
  'manager.orders.sectionStayDates': 'Dates et voyageurs',
  'manager.orders.stepBasicInfo': 'Informations',
  'manager.orders.stepProducts': 'Produits',
  'manager.orders.stepPayment': 'Paiement',
  'manager.orders.nextStep': 'Suivant',
  'manager.orders.backStep': 'Retour',
  'manager.orders.productTabStay': 'Hébergements',
  'manager.orders.productTabActivity': 'Activités',
  'manager.orders.productTabBundle': 'Forfaits',
  'manager.orders.productTabFood': 'Nourriture',
  'manager.orders.stayCalendarHint':
    'Sélectionnez un hébergement, puis utilisez le calendrier pour choisir une date disponible. Le bouton ajoute le séjour et préremplit l’arrivée.',
  'manager.orders.productType': 'Type de produit',
  'manager.orders.productTypeStay': 'Hébergement',
  'manager.orders.productTypeActivity': 'Activité',
  'manager.orders.productTypePackage': 'Forfait',
  'manager.orders.selectProduct': 'Choisir un produit…',
  'manager.orders.productQuantity': 'Quantité',
  'manager.orders.addProduct': 'Ajouter au panier',
  'manager.orders.removeProduct': 'Retirer',
  'manager.orders.noProductsYet': 'Aucun produit — ajoutez des articles pour composer la commande.',
  'manager.orders.beforeTaxShort': 'avant taxes',
  'manager.orders.newOrderCustomPreTaxHint':
    'Ajuste le sous-total avant taxes de la commande. TPS, TVQ et taxe d’hébergement sont recalculées selon les règles en vigueur.',
  'manager.orders.newOrderErrNeedProduct': 'Ajoutez au moins un produit à la commande.',
  'manager.orders.newOrderErrNeedStay': 'Ajoutez au moins un hébergement — requis pour enregistrer la commande.',
  'manager.orders.newOrderErrDuplicateStay': 'Cet hébergement est déjà dans la commande.',
  'manager.orders.newOrderBundledItems': 'Articles de la commande',
  'manager.orders.submitWithoutCardOrder': 'Créer la commande (sans paiement en ligne)',
  'manager.orders.paymentCardNeedOrderFirstTitle': 'Montant et carte non disponibles pour l’instant',
  'manager.orders.paymentCardNeedOrderFirstBody':
    'Ajoutez des produits et, si la commande inclut un hébergement, indiquez des dates d’arrivée et de départ valides pour afficher le montant et le formulaire de paiement.',
  'manager.orders.prefilledFromDashboardCalendar':
    'Hébergement et dates préremplis depuis le calendrier. Complétez les informations du client, puis confirmez ou encaissez.',
  'manager.orders.sectionGuest': 'Client',
  'manager.orders.sectionStay': 'Séjour',
  'manager.orders.sectionPayment': 'Paiement',
  'manager.orders.fieldFirstName': 'Prénom',
  'manager.orders.fieldLastName': 'Nom',
  'manager.orders.fieldEmail': 'Courriel',
  'manager.orders.fieldPhone': 'Téléphone',
  'manager.orders.fieldAccommodation': 'Hébergement',
  'manager.orders.selectAccommodation': 'Choisir un hébergement…',
  'manager.orders.fieldCheckIn': 'Arrivée',
  'manager.orders.fieldCheckOut': 'Départ',
  'manager.orders.fieldAdults': 'Adultes',
  'manager.orders.fieldChildren': 'Enfants',
  'manager.orders.decrementAdults': 'Diminuer le nombre d’adultes',
  'manager.orders.incrementAdults': 'Augmenter le nombre d’adultes',
  'manager.orders.decrementChildren': 'Diminuer le nombre d’enfants',
  'manager.orders.incrementChildren': 'Augmenter le nombre d’enfants',
  'manager.orders.guestCountCapacityHint': 'Capacité maximale de l’hébergement : {count} personnes.',
  'manager.orders.customizePreTaxPrice': 'Personnaliser le montant avant taxes',
  'manager.orders.customPreTaxPriceLabel': 'Montant avant taxes (CAD)',
  'manager.orders.customPreTaxPriceHint':
    'Ajuste uniquement le sous-total hébergement. TPS, TVQ et taxe d’hébergement sont recalculées selon les règles en vigueur.',
  'manager.orders.customPreTaxPriceInvalid': 'Entrez un montant avant taxes valide (0 ou plus).',
  'manager.orders.customPreTaxPriceApplied': 'Prix avant taxes personnalisé — taxes recalculées automatiquement.',
  'manager.orders.fieldSpecialRequests': 'Demandes particulières',
  'manager.orders.summaryNights': 'Nuits',
  'manager.orders.summaryTotalTTC': 'Total TTC (estimatif)',
  'manager.orders.summaryDepositNote':
    'Un acompte de 30 % sera pré-autorisé ou débité selon les réglages Clover ; le solde reste à l’arrivée.',
  'manager.orders.paymentOptionFull': 'Carte — paiement du montant total (TPS/TVQ/taxe hébergement inclus)',
  'manager.orders.paymentOptionLink':
    'Envoyer un lien de paiement — le client paie sur son appareil (Clover)',
  'manager.orders.paymentLinkIntro':
    'Une réservation en attente sera créée et un courriel sécurisé sera envoyé au client avec un lien Clover valide 7 jours.',
  'manager.orders.sendPaymentLink': 'Créer et envoyer le lien de paiement',
  'manager.orders.newOrderPaymentLinkSuccess':
    'Commande créée — lien de paiement envoyé au client par courriel.',
  'manager.orders.paymentOptionLater': 'Sans paiement en ligne — réservation en attente de confirmation',
  'manager.orders.submitWithoutCard': 'Créer la réservation (sans paiement en ligne)',
  'manager.orders.paymentCardNeedStayFirstTitle': 'Montant et carte non disponibles pour l’instant',
  'manager.orders.paymentCardNeedStayFirstBody':
    'Pour afficher le montant, les champs de carte et le bouton de paiement, complétez d’abord la section « Séjour » : choisissez un hébergement, puis des dates d’arrivée et de départ (le départ doit être après l’arrivée).',
  'manager.orders.paymentCardFormIntro':
    'Saisissez la carte ci-dessous, puis utilisez le bouton « Payer … » pour enregistrer la réservation et encaisser.',
  'manager.orders.newReservationErrGuestName': 'Indiquez le prénom et le nom du client.',
  'manager.orders.newReservationErrEmail': 'Le courriel du client est requis.',
  'manager.orders.newReservationErrStay': 'Choisissez un hébergement.',
  'manager.orders.newReservationErrDates': 'Indiquez les dates d’arrivée et de départ.',
  'manager.orders.newReservationErrDatesOrder': 'La date de départ doit être après la date d’arrivée.',
  'manager.orders.newReservationErrTotals': 'Impossible de calculer le montant — vérifiez les dates et l’hébergement.',
  'manager.orders.newReservationErrGuests': 'Indiquez au moins une personne.',
  'manager.orders.newReservationErrCapacity': 'Le nombre de personnes dépasse la capacité de l’hébergement.',
  'manager.orders.totalOrders': 'Total commandes',
  'manager.orders.paidOrders': 'Commandes payées',
  'manager.orders.confirmedOrders': 'Commandes confirmées',
  'manager.orders.cancelledOrders': 'Commandes annulées',
  'manager.orders.orderNumber': 'Numéro de commande',
  'manager.orders.customer': 'Client',
  'manager.orders.items': 'Articles',
  'manager.orders.totalAmount': 'Montant total',
  'manager.orders.unitPriceBeforeTax': 'Prix unitaire (avant taxes)',
  'manager.orders.filterDateField': 'Filtrer par',
  'manager.orders.filterByStayDates': 'Dates de séjour',
  'manager.orders.filterByCreatedAt': 'Date de création',
  'manager.orders.listingViewLabel': 'Affichage',
  'manager.orders.listingViewCreatedAt': 'Création de la réservation',
  'manager.orders.listingViewStayDates': 'Dates du séjour',
  'manager.orders.listingViewCreatedAtHint':
    'Tri : plus récentes d’abord. Le filtre de dates s’applique à la date de création.',
  'manager.orders.listingViewStayDatesHint':
    'Tri : aujourd’hui → futur, puis passés. Le filtre de dates s’applique aux dates du séjour.',
  'manager.orders.filterDateFrom': 'Du',
  'manager.orders.filterDateTo': 'Au',
  'manager.orders.filterDateClear': 'Effacer les dates',
  'manager.orders.filterDateResultCount': '{count} commande(s)',
  'manager.orders.filterByStayDatesHint':
    'Affiche les commandes dont le séjour chevauche la période (arrivée / départ).',
  'manager.orders.filterByCreatedAtHint': 'Affiche les commandes créées dans la période sélectionnée.',
  'manager.orders.pricingFootnote':
    'TPS, TVQ et taxe d’hébergement : montants enregistrés à la réservation lorsqu’ils sont cohérents avec le total ; sinon répartition estimée (même logique que le panier : taxe d’hébergement sur la base hébergement le cas échéant, puis TPS et TVQ chacune sur le montant imposable — la TVQ ne s’applique pas sur la TPS). Le total client est le montant facturé (taxes incluses).',
  'manager.orders.colPreTax': 'Prix net',
  'manager.orders.colQst': 'TVQ',
  'manager.orders.colGst': 'TPS',
  'manager.orders.colLodging': 'Tx héb.',
  'manager.orders.colTotal': 'Total TTC',
  'manager.orders.colBalance': 'Solde à payer',
  'manager.orders.colHearAboutUs': 'Source',
  'manager.orders.colGuest': 'Type',
  'manager.orders.colClientId': 'Client ID',
  'manager.orders.guestLabel': 'Invité',
  'manager.orders.memberLabel': 'Membre',
  'manager.orders.subtotalLinesBeforeTax': 'Sous-total (avant taxes)',
  'manager.orders.status': 'Statut',
  'manager.orders.status.pending': 'En attente',
  'manager.orders.status.paid': 'Payé',
  'manager.orders.status.confirmed': 'Confirmé',
  'manager.orders.status.cancelled': 'Annulé',
  'manager.orders.paymentStatus': 'Statut de paiement',
  'manager.orders.paymentStatus.unpaid': 'Non payé',
  'manager.orders.paymentStatus.paid': 'Payé',
  'manager.orders.paymentStatus.refunded': 'Remboursé',
  'manager.orders.createdAt': 'Créé le',
  'manager.orders.editOrder': 'Modifier la commande',
  'manager.orders.confirmOrder': 'Confirmer la commande',
  'manager.orders.markAsPaid': 'Marquer comme payé',
  'manager.orders.notifyEmployees': 'Notifier les employés',
    'manager.orders.confirmCancel': 'Êtes-vous sûr de vouloir annuler cette commande ?',
    'manager.orders.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cette commande? Cette action est irréversible.',
    'manager.orders.delete': 'Supprimer',
  'manager.orders.orderItems': 'Articles de la commande',
  'manager.orders.productName': 'Nom du produit',
  'manager.orders.quantity': 'Quantité',
  'manager.orders.price': 'Prix',
  'manager.orders.total': 'Total',
  'manager.orders.sendNotification': 'Envoyer la notification',
  'manager.orders.notificationSent': 'Notification envoyée avec succès aux employés',
  'manager.orders.tabs.waiting': 'En attente',
  'manager.orders.tabs.confirmed': 'Confirmées',
  'manager.orders.tabs.completed': 'Terminées',
  'manager.orders.tabs.passed': 'Passées',
  'manager.orders.tabs.paid': 'Payées',
  'manager.orders.modifyDates': 'Modifier les dates',
  'manager.orders.updateStatus': 'Mettre à jour le statut',
  'manager.orders.confirmByStaff': 'Confirmer (traitée par employé/admin)',
  'manager.orders.confirmStaffEmailQueued':
    'Réservation confirmée. Un courriel « réservation confirmée » sera envoyé au client sous peu.',
  'manager.orders.confirmStaffNoGuestEmail':
    'Réservation confirmée, mais aucun courriel n’est disponible pour ce client — aucun message automatique envoyé. Ajoutez le courriel sur la fiche client ou contactez le client.',
  'manager.orders.confirmStaffNoResendKey':
    'Réservation confirmée, mais la clé API Resend (RESEND_API_KEY) n’est pas configurée sur Convex — aucun courriel envoyé. Configurez-la dans les variables d’environnement du déploiement.',
  'manager.orders.noCustomerEmailHint': 'Aucun courriel — confirmation par courriel impossible',
  'manager.orders.cancel': 'Annuler',
  'manager.orders.startDate': 'Date de début',
  'manager.orders.endDate': 'Date de fin',
  'manager.orders.bookingDates': 'Dates de réservation',
  'manager.orders.cancelOrder': 'Annuler la commande',
  'manager.orders.duration': 'Durée',
  'manager.orders.groups': 'Groupes',
  'manager.orders.group': 'Groupe',
  'manager.orders.cancelWarning': 'Cette action annulera la commande. Veuillez sélectionner le type de remboursement.',
  'manager.orders.refundType': 'Type de remboursement',
  'manager.orders.refund': 'Remboursement',
  'manager.orders.refundDescription': 'Rembourser le montant au client',
  'manager.orders.refundAsCredit': 'Remboursement en crédit',
  'manager.orders.refundAsCreditDescription': 'Convertir le montant en crédit pour le client',
  'manager.orders.refundAmount': 'Montant du remboursement',
  'manager.orders.paymentStatus.downpayment': 'Acompte (30%)',
  'manager.orders.paymentStatus.refundedAsCredit': 'Remboursé en crédit',
  'manager.orders.status.completed': 'Terminée',
  'manager.orders.status.passed': 'Passée',
  'manager.orders.remainingAmount': 'Montant restant',
  'manager.orders.selectInformation': 'Sélectionner les informations à inclure',
  'manager.orders.customMessage': 'Message personnalisé',
  'manager.orders.customMessagePlaceholder': 'Ajoutez un message personnalisé pour les employés...',
  'manager.orders.preview': 'Aperçu',
  'manager.orders.message': 'Message',
  'manager.orders.customerEmail': 'Email du client',
  'manager.orders.optional': 'Optionnel',
  'manager.orders.tabs.all': 'Tout',
  'manager.orders.tabs.emailTemplates': 'Modèles d\'email',
  'manager.orders.emailTemplates.title': 'Modèles d\'email',
  'manager.orders.emailTemplates.description': 'Personnalisez les deux modèles envoyés aux clients via Resend. Utilisez les variables pour insérer les données de réservation.',
  'manager.orders.emailTemplates.bookingConfirmationDesc': 'Envoyé automatiquement lorsqu\'un client soumet une réservation.',
  'manager.orders.emailTemplates.bookingConfirmedDesc': 'Envoyé lorsqu\'un employé ou un administrateur confirme la réservation.',
  'manager.orders.emailTemplates.confirmedName': 'Réservation confirmée par l\'équipe',
  'manager.orders.emailTemplates.placedDesc': 'Réservation reçue',
  'manager.orders.emailTemplates.customized': 'Personnalisé',
  'manager.orders.emailTemplates.default': 'Par défaut',
  'manager.orders.emailTemplates.variables': 'Variables',
  'manager.orders.emailTemplates.editTemplate': 'Modifier le modèle',
  'manager.orders.emailTemplates.templateName': 'Nom du modèle',
  'manager.orders.emailTemplates.subject': 'Objet',
  'manager.orders.emailTemplates.htmlBody': 'Corps HTML',
  'manager.orders.emailTemplates.textBody': 'Corps texte brut',
  'manager.orders.emailTemplates.sendTest': 'Envoyer un test',
  'manager.orders.emailTemplates.testTitle': 'Envoyer un email de test',
  'manager.orders.emailTemplates.testDescription': 'Envoie un email avec des données fictives à l\'adresse ci-dessous (via Resend). Sauvegardez d\'abord le modèle.',
  'manager.orders.emailTemplates.testTemplate': 'Modèle à tester',
  'manager.orders.emailTemplates.testTo': 'Envoyer à',
  'manager.orders.emailTemplates.sending': 'Envoi en cours…',
  'manager.orders.emailTemplates.testSent': 'Email de test envoyé. Vérifiez votre boîte de réception.',
  'manager.orders.emailTemplates.saveFirst': 'Sauvegardez le modèle (Modifier puis Sauvegarder) avant d\'envoyer un test.',
  'manager.orders.emailTemplates.greeting': 'Salutation',
  'manager.orders.emailTemplates.intro': 'Introduction',
  'manager.orders.emailTemplates.footer': 'Pied de page',
  'manager.orders.emailTemplates.save': 'Sauvegarder',
  'manager.orders.emailTemplates.cancel': 'Annuler',
  'manager.orders.emailTemplates.preview': 'Aperçu',
  'manager.orders.notifyClient': 'Notifier le client',
  'manager.orders.clientNotificationSent': 'Notification envoyée au client avec succès',
  'manager.orders.communicationTemplates': 'Modèles de communication',
  'manager.orders.communicationTemplatesDescription': 'Créez et gérez des modèles de messages pour communiquer avec les clients',
  'manager.orders.createTemplate': 'Créer un modèle',
  'manager.orders.editTemplate': 'Modifier le modèle',
  'manager.orders.templateName': 'Nom du modèle',
  'manager.orders.communicationMethod': 'Méthode de communication',
  'manager.orders.method.email': 'Email',
  'manager.orders.method.sms': 'SMS',
  'manager.orders.method.both': 'Email et SMS',
  'manager.orders.trigger': 'Déclencheur',
  'manager.orders.trigger.onConfirmation': 'Lors de la confirmation',
  'manager.orders.trigger.onPayment': 'Lors du paiement',
  'manager.orders.trigger.onReminder': 'Rappel',
  'manager.orders.trigger.custom': 'Personnalisé',
  'manager.orders.subject': 'Sujet',
  'manager.orders.subjectPlaceholder': 'Sujet du message',
  'manager.orders.content': 'Contenu',
  'manager.orders.contentPlaceholder': 'Contenu du message...',
  'manager.orders.contentVariables': 'Variables disponibles',
  'manager.orders.recentCommunications': 'Communications récentes',
  'manager.orders.sendMessage': 'Envoyer le message',
  'manager.orders.selectTemplate': 'Sélectionner un modèle',
  'manager.orders.noTemplate': 'Aucun modèle',
  'manager.orders.messagePlaceholder': 'Votre message...',
  'manager.orders.messagePreview': 'Aperçu du message apparaîtra ici',
  'manager.orders.sendAsReminder': 'Envoyer comme rappel',
  'manager.orders.to': 'À',
  'manager.orders.templates.orderConfirmation': 'Confirmation de commande',
  'manager.orders.templates.confirmationSubject': 'Confirmation de votre commande {orderNumber}',
  'manager.orders.templates.paymentReminder': 'Rappel de paiement',
  'manager.orders.templates.reminderSubject': 'Rappel: Paiement pour la commande {orderNumber}',
  'manager.orders.templates.bookingReminder': 'Rappel de réservation',
  'manager.orders.templates.bookingReminderSubject': 'Rappel: Votre réservation approche',
  'manager.orders.templates.bookingReminderContent': 'Bonjour {customerName},\\n\\nNous vous rappelons votre réservation pour la commande {orderNumber}.\\n\\nNous avons hâte de vous accueillir!',
  'manager.orders.templates.newTemplate': 'Nouveau modèle',
  'manager.clients.navLabel': 'Clients',
  'manager.clients.title': 'Gestion des clients',
  'manager.clients.subtitle': 'Gérez vos clients invités et membres enregistrés',
  'manager.clients.guest': 'Invités',
  'manager.clients.member': 'Membres',
  'manager.clients.totalGuests': 'Total invités',
  'manager.clients.totalMembers': 'Total membres',
  'manager.clients.totalPurchases': 'Total achats',
  'manager.clients.totalRevenue': 'Revenus totaux',
  'manager.clients.vipMembers': 'Membres VIP',
  'manager.clients.name': 'Nom',
  'manager.clients.contact': 'Contact',
  'manager.clients.purchases': 'Achats',
  'manager.clients.totalSpent': 'Total dépensé',
  'manager.clients.lastPurchase': 'Dernier achat',
  'manager.clients.email': 'Email',
  'manager.clients.phone': 'Téléphone',
  'manager.clients.registeredAt': 'Inscrit le',
  'manager.clients.lastLogin': 'Dernière connexion',
  'manager.clients.totalBookings': 'Total réservations',
  'manager.clients.status': 'Statut',
  'manager.clients.status.active': 'Actif',
  'manager.clients.status.inactive': 'Inactif',
  'manager.clients.type.new': 'Nouveau',
  'manager.clients.type.returning': 'Récurrent',
  'manager.clients.type.vip': 'VIP',
  'manager.clients.purchaseStatus.completed': 'Terminé',
  'manager.clients.purchaseStatus.pending': 'En attente',
  'manager.clients.purchaseStatus.cancelled': 'Annulé',
  'manager.clients.noContact': 'Aucun contact',
  'manager.clients.search': 'Rechercher...',
  'manager.clients.guestList': 'Liste des invités',
  'manager.clients.memberList': 'Liste des membres',
  'manager.clients.addGuest': 'Ajouter un invité',
  'manager.employees.title': 'Gestion des employés',
  'manager.employees.navLabel': 'Employés',
  'manager.employees.subtitle': 'Gérez votre équipe et leurs informations',
  'manager.employees.addEmployee': 'Ajouter un employé',
  'manager.employees.totalEmployees': 'Total employés',
  'manager.employees.active': 'Actifs',
  'manager.employees.inactive': 'Inactifs',
  'manager.employees.departments': 'Départements',
  'manager.employees.name': 'Nom',
  'manager.employees.email': 'Email',
  'manager.employees.phone': 'Téléphone',
  'manager.employees.role': 'Rôle',
  'manager.employees.department': 'Département',
  'manager.employees.status': 'Statut',
  'manager.financial.title': 'Gestion financière',
  'manager.financial.navLabel': 'Finances',
  'manager.financial.subtitle': 'Suivez vos revenus et dépenses',
  'manager.financial.addTransaction': 'Ajouter une transaction',
  'manager.financial.export': 'Exporter',
  'manager.financial.totalIncome': 'Revenus totaux',
  'manager.financial.totalExpenses': 'Dépenses totales',
  'manager.financial.netProfit': 'Bénéfice net',
  'manager.financial.pendingTransactions': 'Transactions en attente',
  'manager.financial.date': 'Date',
  'manager.financial.type': 'Type',
  'manager.financial.category': 'Catégorie',
  'manager.financial.description': 'Description',
  'manager.financial.amount': 'Montant',
  'manager.financial.status': 'Statut',
  'manager.financial.income': 'Revenu',
  'manager.financial.expense': 'Dépense',
  'manager.financial.completed': 'Terminé',
  'manager.financial.pending': 'En attente',
  'manager.financial.viewDetails': 'Voir les détails',
  'manager.financial.download': 'Télécharger',
  'manager.financial.category.reservations': 'Réservations',
  'manager.financial.category.maintenance': 'Maintenance',
  'manager.financial.category.activities': 'Activités',
  'manager.financial.category.supplies': 'Fournitures',
  'manager.reports.navLabel': 'Rapports',
  'manager.reports.pageTitle': 'Rapports et analyses',
  'manager.reports.pageSubtitle': 'Suivez les performances de votre pourvoirie',
  'manager.reports.devBannerTitle': 'Fonctionnalité en développement — non activée',
  'manager.reports.devBannerBody':
    'Les rapports et exports ne sont pas encore activés. Ce qui s’affiche ci-dessous est une prévisualisation avec des données fictives ; les boutons et actions ne sont pas reliés à la production.',
  'manager.reports.devActionDisabled': 'Non disponible tant que la fonctionnalité n’est pas activée',
  'manager.reports.devMockDataNote': 'Données de démonstration uniquement.',
  'manager.reports.export': 'Exporter',
  'manager.reports.refresh': 'Actualiser',
  'manager.reports.periodLabel': 'Période :',
  'manager.reports.reportLabel': 'Rapport :',
  'manager.reports.period.week': 'Cette semaine',
  'manager.reports.period.month': 'Ce mois',
  'manager.reports.period.quarter': 'Ce trimestre',
  'manager.reports.period.year': 'Cette année',
  'manager.reports.type.revenue': 'Revenus',
  'manager.reports.type.occupancy': 'Occupation',
  'manager.reports.type.reservations': 'Réservations',
  'manager.reports.type.performance': 'Performance',
  'manager.reports.metric.revenue': 'Revenus',
  'manager.reports.metric.occupancyRate': "Taux d'occupation",
  'manager.reports.metric.reservations': 'Réservations',
  'manager.reports.metric.averageRate': 'Taux moyen',
  'manager.reports.vsLastMonth': 'vs mois dernier',
  'manager.reports.section.revenueTrend': 'Évolution des revenus',
  'manager.reports.legend.revenue': 'Revenus',
  'manager.reports.section.occupancyChart': "Taux d'occupation",
  'manager.reports.legend.occupancy': 'Occupation',
  'manager.reports.section.perAccommodation': 'Performance par hébergement',
  'manager.reports.viewAll': 'Voir tout',
  'manager.reports.col.accommodation': 'Hébergement',
  'manager.reports.col.revenue': 'Revenus',
  'manager.reports.col.occupancy': 'Occupation',
  'manager.reports.col.nights': 'Nuits',
  'manager.reports.col.performance': 'Performance',
  'manager.reports.performance.excellent': 'Excellent',
  'manager.reports.performance.good': 'Bon',
  'manager.reports.performance.needsImprovement': 'À améliorer',
  'manager.reports.exportTitle': 'Exporter vos rapports',
  'manager.reports.exportDesc':
    'Téléchargez vos données en format Excel ou PDF pour un suivi détaillé',
  'manager.reports.exportExcel': 'Exporter en Excel',
  'manager.reports.exportPdf': 'Exporter en PDF',
  'manager.reports.demoMonth.jan': 'Jan',
  'manager.reports.demoMonth.feb': 'Fév',
  'manager.reports.demoMonth.mar': 'Mar',
  'manager.reports.demoMonth.apr': 'Avr',
  'manager.reports.demoMonth.may': 'Mai',
  'manager.reports.demoMonth.jun': 'Jun',
  'manager.reminders.title': 'Gestion des rappels',
  'manager.reminders.navLabel': 'Rappels',
  'manager.reminders.subtitle': 'Gérez vos rappels et tâches',
  'manager.reminders.devBannerTitle': 'Fonctionnalité en développement — non activée',
  'manager.reminders.devBannerBody':
    'Les rappels automatiques ne sont pas encore activés. Ce qui s’affiche ci-dessous est une prévisualisation avec des données fictives ; les boutons et actions ne sont pas reliés à la production.',
  'manager.reminders.devActionDisabled': 'Non disponible tant que la fonctionnalité n’est pas activée',
  'manager.reminders.devMockDataNote': 'Données de démonstration uniquement.',
  'manager.reminders.addReminder': 'Ajouter un rappel',
  'manager.reminders.totalReminders': 'Total rappels',
  'manager.reminders.pending': 'En attente',
  'manager.reminders.completed': 'Terminés',
  'manager.reminders.highPriority': 'Priorité haute',
  'manager.reminders.type': 'Type',
  'manager.reminders.dueDate': 'Échéance',
  'manager.reminders.priority': 'Priorité',
  'manager.reminders.status': 'Statut',
  'manager.reminders.assignedTo': 'Assigné à',
  'manager.reminders.type.maintenance': 'Maintenance',
  'manager.reminders.type.payment': 'Paiement',
  'manager.reminders.type.reservation': 'Réservation',
  'manager.reminders.type.other': 'Autre',
  'manager.reminders.priority.high': 'Haute',
  'manager.reminders.priority.medium': 'Moyenne',
  'manager.reminders.priority.low': 'Basse',
  'manager.marketing.navLabel': 'Marketing',
  'manager.web.title': 'Gestion web',
  'manager.web.navLabel': 'Web',
  'manager.web.subtitle': 'Gérez le contenu de votre site web',
  'manager.web.bookingEmailsHint':
    'Les courriels automatiques de réservation (confirmation, rappels) se configurent dans Commandes → Modèles de courriel.',
  'manager.web.content': 'Contenu',
  'manager.web.contentDesc': 'Gérez les textes et descriptions',
  'manager.web.media': 'Médias',
  'manager.web.mediaDesc': 'Gérez les images et vidéos',
  'manager.web.settings': 'Paramètres',
  'manager.web.settingsDesc': 'Configurez les paramètres du site',
  'manager.media.navLabel': 'Photos',
  'manager.media.title': 'Photos',
  'manager.media.subtitle':
    'Téléversez des photos compressées pour la galerie du site, un séjour ou une activité.',
  'manager.media.uploadSection': 'Téléversement',
  'manager.media.placement': 'Lier à',
  'manager.media.placementGallery': 'Galerie du site',
  'manager.media.placementStay': 'Séjour',
  'manager.media.placementActivity': 'Activité',
  'manager.media.optionalTitle': 'Titre (optionnel)',
  'manager.media.titlePlaceholder': 'ex. Coucher de soleil sur le lac',
  'manager.media.compressLabel': 'Compresser avant envoi',
  'manager.media.compressHint':
    'Recommandé pour les photos téléphone (souvent 10–15 Mo). Réduit la taille pour le site tout en gardant une bonne qualité.',
  'manager.media.quality': 'Qualité',
  'manager.media.maxEdge': 'Taille max (px)',
  'manager.media.recommended': 'recommandé',
  'manager.media.dropHint': 'Déposez des photos ici ou cliquez pour parcourir',
  'manager.media.formats': 'JPEG, PNG, WebP (HEIC si le navigateur le permet)',
  'manager.media.uploading': 'Compression et envoi…',
  'manager.media.statusCompressing': 'compression',
  'manager.media.statusUploading': 'envoi',
  'manager.media.statusDone': 'terminé',
  'manager.media.statusError': 'erreur',
  'manager.media.library': 'Bibliothèque',
  'manager.media.empty': 'Aucune photo pour le moment.',
  'manager.media.untitled': 'Sans titre',
  'manager.media.changePlacement': 'Changer le lien',
  'manager.media.confirmDelete': 'Supprimer cette photo ?',
  'manager.media.selectStay': 'Sélectionnez d’abord un séjour.',
  'manager.media.selectActivity': 'Sélectionnez d’abord une activité.',
  'manager.media.imagesOnly': 'Veuillez choisir des fichiers image.',
  'manager.media.readyToUpload': 'Prêt à téléverser',
  'manager.media.confirmUpload': 'Confirmer le téléversement',
  'manager.media.clearSelection': 'Annuler la sélection',
  'manager.settings.title': 'Paramètres',
  'manager.settings.navLabel': 'Paramètres',
  'manager.settings.subtitle': 'Configurez les paramètres du système',
  'manager.settings.general': 'Général',
  'manager.settings.notifications': 'Notifications',
  'manager.settings.notificationsDesc': 'Configurez les notifications',
  'manager.settings.security': 'Sécurité',
  'manager.settings.securityDesc': 'Paramètres de sécurité et accès',
  'manager.settings.localization': 'Localisation',
  'manager.settings.localizationDesc': 'Langues et formats',
  'manager.settings.payment': 'Paiement',
  'manager.settings.paymentDesc': 'Configuration des paiements',
  'manager.settings.users': 'Utilisateurs',
  'manager.settings.usersDesc': 'Gestion des utilisateurs et permissions',
  'manager.settings.backup': 'Sauvegarde',
  'manager.settings.backupDesc': 'Sauvegardes et restauration'
},
  en: {
  'manager.dashboard.welcome': 'Hello, {name}!',
  'manager.dashboard.subtitle': 'Overview of your lodge activity at a glance.',
  'manager.dashboard.totalReservations': 'Total reservations',
  'manager.dashboard.occupancyRate': 'Occupancy rate',
  'manager.dashboard.monthlyRevenue': 'Monthly revenue',
  'manager.dashboard.upcomingArrivals': 'Upcoming arrivals',
  'manager.dashboard.recentReservations': 'Recent reservations',
  'manager.dashboard.viewAll': 'View all',
  'manager.dashboard.maintenanceAlerts': 'Maintenance alerts',
  'manager.dashboard.quickActions': 'Quick actions',
  'manager.dashboard.newReservation': 'New reservation',
  'manager.dashboard.manageAccommodations': 'Manage accommodations',
  'manager.dashboard.viewReports': 'View reports',
  'manager.dashboard.occupancyOverview': 'Occupancy overview',
  'manager.dashboard.noReservationsYet': 'No reservations yet',
  'manager.dashboard.noPendingReservations': 'No reservations awaiting action',
  'manager.dashboard.noAccommodationsConfigured': 'No accommodations configured',
  'manager.dashboard.confirmed': 'Confirmed',
  'manager.dashboard.pending': 'Pending',
  'manager.dashboard.pendingSidebarTitle': 'Pending',
  'manager.dashboard.cancelled': 'Cancelled',
  'manager.dashboard.urgent': 'Urgent',
  'manager.dashboard.medium': 'Medium',
  'manager.dashboard.low': 'Low',
  'manager.dashboard.available': 'Available',
  'manager.dashboard.occupied': 'Occupied',
  'manager.dashboard.selectStayProduct': 'Stay',
  'manager.dashboard.calendarViewAllTypes': 'All types',
  'manager.dashboard.calendarViewSingleStay': 'Per stay',
  'manager.dashboard.filterStayType': 'Stay type',
  'manager.dashboard.filterAllTypes': 'All types',
  'manager.dashboard.filterProduct': 'Product',
  'manager.dashboard.filterAllProducts': 'All products',
  'manager.dashboard.filterProductHint': 'Select a type to show stays.',
  'manager.dashboard.calendarCreateOrderHint':
    'Click a date to see available stays, then use “New order” to book.',
  'manager.dashboard.calendarExpandHint':
    'Click a date to expand and see all available stays. Click again to collapse.',
  'manager.dashboard.calendarClickToSeeAll': 'Click to see all',
  'manager.dashboard.calendarProductFlowHint':
    '1) Click a date to expand · 2) Hover a stay for details · 3) Click the stay to create an order.',
  'manager.dashboard.calendarTypeFlowHint':
    '1) Click a date to expand · 2) Hover a type · 3) Click the type to open its calendar.',
  'manager.dashboard.calendarTypeClickHint': 'Click to view this type',
  'manager.dashboard.calendarCollapseHint': 'Click to collapse',
  'manager.dashboard.calendarMoreProducts': 'more',
  'manager.dashboard.calendarProductClickHint': 'Click to create an order',
  'manager.dashboard.calendarConfirmNewOrderTitle': 'Create a new order?',
  'manager.dashboard.calendarConfirmNewOrderBody':
    'Open a new order for “{name}” on {date}?',
  'manager.dashboard.calendarConfirmYes': 'Yes',
  'manager.dashboard.calendarConfirmNo': 'No',
  'manager.dashboard.calendarNewOrder': 'New order',
  'manager.dashboard.calendarLegendAvailable': 'Available',
  'manager.dashboard.calendarLegendBooked': 'Booked',
  'manager.dashboard.calendarLegendLocked': 'Temporary hold',
  'manager.dashboard.calendarSameAsWebsite': 'Same calendar as the public site (stays.availability).',
  'manager.dashboard.manageSelectedStay': 'Manage this stay',
  'manager.dashboard.bookForClient': 'Book for a client',
  'manager.dashboard.bookForClientSuccess': 'Reservation saved.',
  'manager.dashboard.bookForClientPaymentLinkSuccess':
    'Reservation created — payment link emailed to the client.',
  'manager.accommodations.title': 'Accommodations Management',
  'manager.accommodations.subtitle': 'Manage all your accommodations and their availability',
  'manager.accommodations.addNew': 'Add Accommodation',
  'manager.accommodations.totalAccommodations': 'Total accommodations',
  'manager.accommodations.averagePrice': 'Average price',
  'manager.accommodations.edit': 'Edit',
  'manager.accommodations.delete': 'Delete',
  'manager.accommodations.viewCalendar': 'View Calendar',
  'manager.accommodations.status': 'Status',
  'manager.accommodations.price': 'Price',
  'manager.accommodations.capacity': 'Capacity',
  'manager.accommodations.location': 'Location',
  'manager.accommodations.amenities': 'Amenities',
  'manager.accommodations.actions': 'Actions',
  'manager.accommodations.search': 'Search accommodation...',
  'manager.accommodations.filterByType': 'Filter by type',
  'manager.accommodations.filterByStatus': 'Filter by status',
  'manager.accommodations.allTypes': 'All types',
  'manager.accommodations.allStatus': 'All status',
  'manager.accommodations.chalet': 'Chalet',
  'manager.accommodations.yourte': 'Yurt',
  'manager.accommodations.cabane': 'Cabin',
  'manager.accommodations.tente': 'Tent',
  'manager.accommodations.available': 'Available',
  'manager.accommodations.occupied': 'Occupied',
  'manager.accommodations.maintenance': 'Maintenance',
  'manager.accommodations.units': 'Row Units',
  'manager.accommodations.pricing': 'Pricing',
  'manager.accommodations.basePrice': 'Base Price',
  'manager.accommodations.basePriceDesc': 'Default price if weekday/weekend prices are not set',
  'manager.accommodations.weekdayPrice': 'Weekday Price',
  'manager.accommodations.weekdayPriceDesc': 'Price for weekdays (Monday-Friday)',
  'manager.accommodations.weekendPrice': 'Weekend Price',
  'manager.accommodations.weekendPriceDesc': 'Price for weekends (Saturday-Sunday)',
  'manager.accommodations.weekday': 'Weekday',
  'manager.accommodations.weekend': 'Weekend',
  'manager.accommodations.amenitiesDesc': 'Select the amenities available in this accommodation (e.g., fireplace, dock, kitchen, etc.)',
  'manager.accommodations.images': 'Images',
  'manager.accommodations.imagesDesc': 'Upload photos of the accommodation for clients',
  'manager.accommodations.uploadImages': 'Upload Images',
  'manager.accommodations.noAccommodations': 'No accommodations found',
  'manager.accommodations.customizeColumns': 'Columns',
  'manager.accommodations.customizeColumnsDesc': 'Choose which columns to display and their order',
  'manager.accommodations.dragToReorder': 'Drag to reorder columns',
  'manager.accommodations.toggleVisibility': 'Click the eye icon to show/hide',
  'manager.accommodations.showColumn': 'Show column',
  'manager.accommodations.hideColumn': 'Hide column',
  'manager.accommodations.resetToDefault': 'Reset to Default',
  'manager.reservations.title': 'Reservations Management',
  'manager.reservations.subtitle': 'Manage all reservations and track their status',
  'manager.reservations.totalReservations': 'Total reservations',
  'manager.reservations.confirmed': 'Confirmed',
  'manager.reservations.pending': 'Pending',
  'manager.reservations.cancelled': 'Cancelled',
  'manager.reservations.completed': 'Completed',
  'manager.reservations.totalRevenue': 'Total revenue',
  'manager.reservations.search': 'Search reservation...',
  'manager.reservations.filterByStatus': 'Filter by status',
  'manager.reservations.filterByDate': 'Filter by date',
  'manager.reservations.allStatus': 'All status',
  'manager.reservations.guestName': 'Guest name',
  'manager.reservations.accommodation': 'Accommodation',
  'manager.reservations.checkIn': 'Check-in',
  'manager.reservations.checkOut': 'Check-out',
  'manager.reservations.dates': 'Dates',
  'manager.reservations.guests': 'Guests',
  'manager.reservations.payment': 'Payment',
  'manager.reservations.totalPrice': 'Total price',
  'manager.reservations.status': 'Status',
  'manager.reservations.actions': 'Actions',
  'manager.reservations.confirm': 'Confirm',
  'manager.reservations.cancel': 'Cancel',
  'manager.reservations.viewDetails': 'View details',
  'manager.reservations.editReservation': 'Edit reservation',
  'manager.reports.title': 'Reports and Analytics',
  'manager.reports.subtitle': 'Analyze performance and generate reports',
  'manager.reports.occupancyReport': 'Occupancy report',
  'manager.reports.revenueReport': 'Revenue report',
  'manager.reports.guestReport': 'Guest report',
  'manager.reports.monthlyReport': 'Monthly report',
  'manager.reports.yearlyReport': 'Yearly report',
  'manager.reports.exportData': 'Export data',
  'manager.reports.generateReport': 'Generate report',
  'manager.reports.selectPeriod': 'Select period',
  'manager.reports.fromDate': 'From date',
  'manager.reports.toDate': 'To date',
  'manager.reports.reportType': 'Report type',
  'manager.reports.occupancy': 'Occupancy',
  'manager.reports.revenue': 'Revenue',
  'manager.reports.guests': 'Guests',
  'manager.reports.activities': 'Activities',
  'manager.crm.title': 'Client Management',
  'manager.crm.subtitle': 'Manage your client database and their preferences',
  'manager.crm.totalClients': 'Total clients',
  'manager.crm.newClients': 'New clients',
  'manager.crm.returningClients': 'Returning clients',
  'manager.crm.vipClients': 'VIP clients',
  'manager.crm.search': 'Search client...',
  'manager.crm.filterByType': 'Filter by type',
  'manager.crm.allTypes': 'All types',
  'manager.crm.new': 'New',
  'manager.crm.returning': 'Returning',
  'manager.crm.vip': 'VIP',
  'manager.crm.clientName': 'Client name',
  'manager.crm.email': 'Email',
  'manager.crm.phone': 'Phone',
  'manager.crm.lastVisit': 'Last visit',
  'manager.crm.totalBookings': 'Total bookings',
  'manager.crm.totalSpent': 'Total spent',
  'manager.crm.status': 'Status',
  'manager.crm.actions': 'Actions',
  'manager.crm.viewProfile': 'View profile',
  'manager.crm.editClient': 'Edit client',
  'manager.crm.sendEmail': 'Send email',
  'manager.crm.addNote': 'Add note',
  'manager.crm.clientDetails': 'Client details',
  'manager.crm.bookingHistory': 'Booking history',
  'manager.crm.preferences': 'Preferences',
  'manager.crm.notes': 'Notes',
  'manager.marketing.title': 'Marketing and Promotions',
  'manager.marketing.subtitle': 'Manage your marketing campaigns and promotions',
  'manager.marketing.maintenanceTitle': 'Section being updated',
  'manager.marketing.maintenanceBody':
    'The Marketing area is being rebuilt. The legacy demo screens (campaigns / promotions) are archived and no longer shown here.',
  'manager.marketing.maintenanceBundlesHint':
    'Manage packages and catalog content (including food and bundle-linked products) under Bundles.',
  'manager.marketing.maintenanceBundlesLink': 'Open bundle (forfait) management',
  'manager.marketing.legacyIntroTitle': 'Marketing — legacy demo (non-VUM)',
  'manager.marketing.legacyIntroBody':
    'Below: the archived demo UI (campaigns and fictitious promo codes, not tied to promovalidation.com). Use Bundles for packages and catalog; use Discounts for on-site promo codes. VUM codes are under Operations → VUM codes.',
  'manager.marketing.search': 'Search…',
  'manager.marketing.allTypes': 'All types',
  'manager.marketing.activeCampaigns': 'Active campaigns',
  'manager.marketing.totalCampaigns': 'Total campaigns',
  'manager.marketing.emailCampaigns': 'Email campaigns',
  'manager.marketing.socialMedia': 'Social media',
  'manager.marketing.promotions': 'Promotions',
  'manager.marketing.createCampaign': 'Create campaign',
  'manager.marketing.createPromotion': 'Create promotion',
  'manager.marketing.campaignName': 'Campaign name',
  'manager.marketing.campaignType': 'Campaign type',
  'manager.marketing.startDate': 'Start date',
  'manager.marketing.endDate': 'End date',
  'manager.marketing.status': 'Status',
  'manager.marketing.actions': 'Actions',
  'manager.marketing.email': 'Email',
  'manager.marketing.social': 'Social',
  'manager.marketing.discount': 'Discount',
  'manager.marketing.specialOffer': 'Special offer',
  'manager.marketing.active': 'Active',
  'manager.marketing.paused': 'Paused',
  'manager.marketing.completed': 'Completed',
  'manager.marketing.editCampaign': 'Edit campaign',
  'manager.marketing.deleteCampaign': 'Delete campaign',
  'manager.marketing.viewStats': 'View statistics',
  'manager.marketing.promotionCode': 'Promotion code',
  'manager.marketing.discountPercentage': 'Discount percentage',
  'manager.marketing.minimumStay': 'Minimum stay',
  'manager.marketing.validFrom': 'Valid from',
  'manager.marketing.validTo': 'Valid until',
  'manager.marketing.usageLimit': 'Usage limit',
  'manager.marketing.usedCount': 'Used',
  'manager.marketing.remainingUses': 'Remaining',
  'manager.sections.operations': 'Operations Management',
  'manager.sections.people': 'People Management',
  'manager.sections.financial': 'Financial',
  'manager.sections.system': 'System Management',
  'manager.sections.archived': 'Archived (for later)',
  'manager.operations.vumCodesNav': 'VUM codes',
  'manager.stays.title': 'Stays Management',
  'manager.stays.navLabel': 'Stays',
  'manager.stays.subtitle': 'Manage all your accommodations and their availability',
  'manager.stays.listLoading': 'Loading accommodations…',
  'manager.stays.loadedFromConvex': 'Accommodations in the current Convex database: {count}',
  'manager.stays.convexDeploymentProd': 'Convex deployment (production): {url}',
  'manager.stays.seasonFilterNotice': 'Season filter: {shown} of {total} stays. Use the "Entire year" tab to see all.',
  'manager.stays.addStay': 'Add Stay',
  'manager.stays.totalStays': 'Total Stays',
  'manager.stays.available': 'Available',
  'manager.stays.unavailable': 'Unavailable',
  'manager.stays.averagePrice': 'Average Price',
  'manager.stays.name': 'Name',
  'manager.stays.type': 'Type',
  'manager.stays.location': 'Location',
  'manager.stays.capacity': 'Capacity',
  'manager.stays.price': 'Price',
  'manager.stays.priceBeforeTax': 'Price (before tax)',
  'manager.stays.tpsColumn': 'GST (5%)',
  'manager.stays.tvqColumn': 'QST (9.975%)',
  'manager.stays.taxeHebergementColumn': 'Lodging tax ($3.50/night)',
  'manager.stays.pricingTaxSection': 'Pricing & taxes',
  'manager.stays.taxeHebergementToggle': 'Lodging tax ($3.50 per night, flat rate)',
  'manager.stays.taxeHebergementHint':
    'When enabled, $3.50 per night is added (regardless of nightly rate); GST and QST each apply to (rate + lodging tax); QST is not calculated on GST.',
  'manager.stays.clientTotalColumn': 'Client total',
  'manager.stays.cadBeforeTax': 'CAD (before tax)',
  'manager.stays.cadSuffix': 'CAD',
  'manager.stays.pricingTaxFootnote':
    'Indicative: when enabled, lodging tax is $3.50 per night (flat); GST 5% and QST 9.975% each apply to (nightly rate + lodging tax); QST is not calculated on GST. Rounded to the cent at each step.',
  'manager.stays.pricePerNight': 'Price per night per person',
  'manager.stays.pricePerNightHint': 'Pre-tax rate, per person per night. Guests only see it when online reservation is enabled.',
  'manager.stays.allowReservation': 'Allow online reservation',
  'manager.stays.allowReservationHint':
    'When checked, guests see the price and can book this stay. Otherwise the stay is information-only.',
  'manager.stays.allowReservationColumn': 'Online reservation',
  'manager.stays.availability': 'Availability',
  'manager.stays.closingDates': 'Closing dates',
  'manager.stays.closingDatesDesc': 'Assign date ranges when this stay is closed (not bookable). Unassigned days are available by default.',
  'manager.stays.stored': 'Stored',
  'manager.stays.status': 'Status',
  'manager.stays.openingPeriods': 'Opening Periods',
  'manager.stays.sales': 'Sales',
  'manager.stays.marketingLabels': 'Marketing Labels',
  'manager.stays.editInDetails': 'Edit In Details',
  'manager.stays.clickToEdit': 'Click to edit',
  'manager.stays.confirmDelete': 'Are you sure you want to delete this accommodation?',
  'manager.stays.seasons': 'seasons',
  'manager.stays.noPeriods': 'No periods',
  'manager.stays.fullYearAvailable': 'Available year-round',
  'manager.stays.noLabels': 'No labels',
  'manager.stays.seasonName': 'Season name',
  'manager.stays.addPeriod': 'Add period',
  'manager.stays.marketingLabel.couple': 'Couple',
  'manager.stays.marketingLabel.family': 'Family',
  'manager.stays.marketingLabel.corporate': 'Corporate',
  'manager.stays.predefinedLabels': 'Predefined Labels',
  'manager.stays.customLabels': 'Custom Labels',
  'manager.stays.addCustomLabel': 'Add custom label',
  'manager.stays.basicInformation': 'Basic Information',
  'manager.stays.descriptionSection': 'Description',
  'manager.stays.pageDescription': 'Page Description',
  'manager.stays.pageDescriptionPlaceholder': 'Detailed description to display on the public page',
  'manager.stays.zoneInMap': 'Zone in Map',
  'manager.stays.zoneInMapLabel': 'Zone',
  'manager.stays.zoneInMapPlaceholder': 'e.g., Zone A, North Sector, etc.',
  'manager.stays.zoneNumberLabel': 'Zone Number',
  'manager.stays.zoneNumberPlaceholder': 'e.g., 12, A-3, etc.',
  'manager.stays.indoorChecklist': 'Indoor Checklist',
  'manager.stays.outdoorChecklist': 'Outdoor Checklist',
  'manager.stays.kitchenEquipments': 'Kitchen Equipments',
  'manager.stays.addEquipment': 'Add equipment',
  'manager.stays.bathroomSetup': 'Bathroom Setup',
  'manager.stays.addBathroomItem': 'Add item',
  'manager.stays.beds': 'Beds',
  'manager.stays.bedType': 'Bed type (e.g., Queen, Double)',
  'manager.stays.bedCount': 'Count',
  'manager.stays.petFriendly': 'Pet Friendly',
  'manager.stays.bbq': 'BBQ',
  'manager.stays.gardenTable': 'Garden Table',
  'manager.stays.numberOfChairs': 'Number of Chairs',
  'manager.stays.privateDockForBoat': 'Private Dock for Boat',
  'manager.stays.images': 'Images',
  'manager.stays.addImageUrl': 'Enter image URL...',
  'manager.stays.image': 'Image',
  'manager.stays.noImages': 'No images added',
  'manager.stays.uploadFile': 'Upload File',
  'manager.stays.enterUrl': 'Enter URL',
  'manager.stays.clickToUpload': 'Click to upload',
  'manager.stays.orDragDrop': 'or drag and drop',
  'manager.stays.urlHint': 'Tip: Google Drive links are automatically converted to direct image URLs',
  'manager.stays.seasonTabs.all': 'Entire Year',
  'manager.stays.seasonTabs.summer': 'Summer',
  'manager.stays.seasonTabs.winter': 'Winter',
  'manager.stays.seasonSettings': 'Season Settings',
  'manager.stays.seasonStartDate': 'Start Date',
  'manager.stays.seasonEndDate': 'End Date',
  'manager.stays.winterCanSpanYears': 'Winter can span across two years',
  'manager.stays.seasonFilter.all': 'All Seasons',
  'manager.stays.seasonFilter.summer': 'Summer',
  'manager.stays.seasonFilter.winter': 'Winter',
  'manager.stays.copyPeriod': 'Copy Period',
  'manager.stays.pastePeriod': 'Paste Period',
  'manager.stays.removePeriod': 'Remove Period',
  'manager.stays.autoDetected': 'Auto-detected',
  'manager.stays.noPeriodCopied': 'No period copied',
  'manager.stays.unavailableDatesDesc': 'Assign date ranges when this stay is NOT bookable. Unassigned days are available by default.',
  'manager.stays.addUnavailableRange': 'Add unavailable range',
  'manager.stays.allDaysAvailable': 'All days available',
  'manager.stays.scheduleMoreCount': '+{{count}} more',
  'manager.stays.archivedOpeningPeriodsTitle': 'Archived — opening periods',
  'manager.stays.archivedOpeningPeriodsDesc':
    'Opening periods are edited here (outside the main table), similar to archived items in the manager sidebar.',
  'manager.stays.scheduleSaveFailed':
    'Could not save. Check your dates and try again. If it keeps failing, open the browser console (F12) for details.',
  'manager.activities.title': 'Activities Management',
  'manager.activities.navLabel': 'Activities',
  'manager.activities.subtitle': 'Manage all your activities and their availability',
  'manager.activities.crossLinksHint': 'Quick links: public catalog and packages.',
  'manager.activities.publicCatalogLink': 'Public site catalog',
  'manager.activities.bundlesLink': 'Package (bundle) management',
  'manager.food.publicForfaitsLink': 'Packages on the public site',
  'manager.activities.addActivity': 'Add Activity',
  'manager.activities.totalActivities': 'Total Activities',
  'manager.activities.available': 'Available',
  'manager.activities.unavailable': 'Unavailable',
  'manager.activities.totalCapacity': 'Total Capacity',
  'manager.activities.averagePrice': 'Average Price',
  'manager.activities.averagePriceBeforeTax': 'Average price (before tax)',
  'manager.activities.pricingTaxFootnote':
    'The listed price is before tax. GST 5% and QST 9.975% each apply to that price; QST is not calculated on GST. No lodging tax on activities.',
  'manager.activities.priceBeforeTaxLabel': 'Price (before tax) *',
  'manager.activities.name': 'Name',
  'manager.activities.type': 'Type',
  'manager.activities.duration': 'Duration',
  'manager.activities.capacity': 'Capacity',
  'manager.activities.price': 'Price',
  'manager.activities.availability': 'Availability',
  'manager.activities.status': 'Status',
  'manager.activities.openingPeriods': 'Opening Periods',
  'manager.activities.sales': 'Sales',
  'manager.activities.marketingLabels': 'Marketing Labels',
  'manager.activities.archivedOpeningPeriodsTitle': 'Archived — opening periods (activities)',
  'manager.activities.archivedOpeningPeriodsDesc':
    'Activity opening periods are edited here, outside the main table (same idea as stays).',
  'manager.activities.editInDetails': 'Edit In Details',
  'manager.activities.confirmDelete': 'Are you sure you want to delete this activity?',
  'manager.activities.clickToEdit': 'Click to edit',
  'manager.activities.seasons': 'seasons',
  'manager.activities.noPeriods': 'No periods',
  'manager.activities.noLabels': 'No labels',
  'manager.activities.seasonName': 'Season name',
  'manager.activities.addPeriod': 'Add period',
  'manager.activities.predefinedLabels': 'Predefined Labels',
  'manager.activities.customLabels': 'Custom Labels',
  'manager.activities.addCustomLabel': 'Add custom label',
  'manager.activities.marketingLabel.couple': 'Couple',
  'manager.activities.marketingLabel.family': 'Family',
  'manager.activities.marketingLabel.corporate': 'Corporate',
  'manager.activities.basicInformation': 'Basic Information',
  'manager.activities.descriptionSection': 'Description',
  'manager.activities.pageDescription': 'Page Description',
  'manager.activities.pageDescriptionPlaceholder': 'Detailed description to display on the activity page',
  'manager.activities.zoneInMap': 'Zone in Map',
  'manager.activities.zoneInMapLabel': 'Zone in Map',
  'manager.activities.zoneInMapPlaceholder': 'Enter the zone on the map',
  'manager.activities.equipment': 'Equipment',
  'manager.activities.addEquipment': 'Add equipment',
  'manager.activities.indoorChecklist': 'Indoor Checklist',
  'manager.activities.kitchenEquipments': 'Kitchen Equipments',
  'manager.activities.bathroomSetup': 'Bathroom Setup',
  'manager.activities.beds': 'Beds',
  'manager.activities.bedType': 'Bed type',
  'manager.activities.bedCount': 'Count',
  'manager.activities.petFriendly': 'Pet Friendly',
  'manager.activities.outdoorChecklist': 'Outdoor Checklist',
  'manager.activities.bbq': 'BBQ',
  'manager.activities.gardenTable': 'Garden Table',
  'manager.activities.numberOfChairs': 'Number of Chairs',
  'manager.activities.privateDockForBoat': 'Private Dock for Boat',
  'manager.activities.addBathroomItem': 'Add item',
  'manager.activities.typeSummer': 'Summer',
  'manager.activities.typeWinter': 'Winter',
  'manager.activities.typeFall': 'Fall',
  'manager.activities.typeYearRound': 'Year Round',
  'manager.activities.durationPlaceholder': 'Ex: 4 hours, full day',
  'manager.activities.seasonTabs.all': 'Entire Year',
  'manager.activities.seasonTabs.summer': 'Summer',
  'manager.activities.seasonTabs.winter': 'Winter',
  'manager.activities.seasonSettings': 'Season Settings',
  'manager.activities.seasonStartDate': 'Start Date',
  'manager.activities.seasonEndDate': 'End Date',
  'manager.activities.winterCanSpanYears': 'Winter can span across two years',
  'manager.activities.seasonFilter.all': 'All Seasons',
  'manager.activities.seasonFilter.summer': 'Summer',
  'manager.activities.seasonFilter.winter': 'Winter',
  'manager.activities.copyPeriod': 'Copy Period',
  'manager.activities.pastePeriod': 'Paste Period',
  'manager.activities.removePeriod': 'Remove Period',
  'manager.activities.autoDetected': 'Auto-detected',
  'manager.activities.noPeriodCopied': 'No period copied',
  'manager.activities.pricingRules': 'Pricing Rules',
  'manager.activities.freeAgeGroups': 'Free Age Groups',
  'manager.activities.discountAgeGroups': 'Discount Age Groups',
  'manager.activities.minAge': 'Min Age',
  'manager.activities.maxAge': 'Max Age',
  'manager.activities.yearsOld': 'years old',
  'manager.activities.discount': 'Discount',
  'manager.activities.descriptionOptional': 'Description (optional)',
  'manager.activities.addFreeGroup': 'Add Free Group',
  'manager.activities.addDiscountGroup': 'Add Discount Group',
  'manager.activities.includedServices': 'Included Services',
  'manager.activities.nonIncludedServices': 'Non-Included Services',
  'manager.activities.optionalPaidServices': 'Optional Paid Services',
  'manager.activities.clientTypes': 'Opening to which type of Clients',
  'manager.activities.lodging': 'Lodging',
  'manager.activities.nonLodging': 'Non Lodging',
  'manager.activities.addIncludedService': 'Add Included Service',
  'manager.activities.addNonIncludedService': 'Add Non-Included Service',
  'manager.activities.addOptionalPaidService': 'Add Optional Paid Service',
  'manager.food.title': 'Food Management',
  'manager.food.navLabel': 'Food',
  'manager.food.subtitle': 'Manage your menus and food items',
  'manager.food.devBannerTitle': 'In development — demo',
  'manager.food.devBannerBody':
    'Centralized food management is not activated yet. The table below previews meal products pulled from packages; actions stay disabled. Configure meals via bundle management.',
  'manager.food.devActionDisabled': 'Unavailable until this feature is activated',
  'manager.food.devMockDataNote': 'Indicative preview from packages — not finalized.',
  'manager.food.addItem': 'Add Item',
  'manager.food.totalItems': 'Total Items',
  'manager.food.available': 'Available',
  'manager.food.totalStock': 'Total Stock',
  'manager.food.averagePrice': 'Average Price',
  'manager.food.averagePriceBeforeTax': 'Average price (before tax)',
  'manager.food.pricingTaxFootnote':
    'The listed price is before tax. GST 5% and QST 9.975% each apply to that price; QST is not calculated on GST. Lodging tax does not apply to food items.',
  'manager.food.name': 'Name',
  'manager.food.category': 'Category',
  'manager.food.price': 'Price',
  'manager.food.stock': 'Stock',
  'manager.food.availability': 'Availability',
  'manager.food.loading': 'Loading…',
  'manager.food.dataSourceTitle': 'Synced with packages (bundles)',
  'manager.food.dataSourceBody':
    'Food line items come from meal-type products defined in your packages. Add or edit them in bundle management.',
  'manager.food.openBundles': 'Open bundle management',
  'manager.food.editInBundles': 'Edit in bundles',
  'manager.food.empty': 'No food products in packages yet.',
  'manager.bundles.title': 'Bundle Management',
  'manager.bundles.navLabel': 'Bundles',
  'manager.bundles.subtitle': 'Manage your packages and promotions',
  'manager.bundles.addBundle': 'Add Bundle',
  'manager.bundles.totalBundles': 'Total Bundles',
  'manager.bundles.popular': 'Popular',
  'manager.bundles.averagePrice': 'Average Price',
  'manager.bundles.totalCapacity': 'Total Capacity',
  'manager.bundles.name': 'Name',
  'manager.bundles.description': 'Description',
  'manager.bundles.price': 'Price',
  'manager.bundles.maxGuests': 'Max Guests',
  'manager.bundles.editBundle': 'Edit Bundle',
  'manager.bundles.basicInformation': 'Basic Information',
  'manager.bundles.duration': 'Duration',
  'manager.bundles.days': 'days',
  'manager.bundles.available': 'Available',
  'manager.bundles.products': 'Products',
  'manager.bundles.productType': 'Product Type',
  'manager.bundles.stays': 'Stays',
  'manager.bundles.activities': 'Activities',
  'manager.bundles.food': 'Food',
  'manager.bundles.selectProduct': 'Select Product',
  'manager.bundles.pricingType': 'Pricing Type',
  'manager.bundles.free': 'Free',
  'manager.bundles.discount': 'Discount',
  'manager.bundles.discountAmount': 'Discount Amount',
  'manager.bundles.customPrice': 'Custom Price',
  'manager.bundles.discountPercentage': 'Discount Percentage',
  'manager.bundles.addProduct': 'Add Product',
  'manager.bundles.productAlreadyAdded': 'This product has already been added',
  'manager.bundles.noProducts': 'No products added',
  'manager.bundles.confirmDelete': 'Are you sure you want to delete this bundle?',
  'manager.bundles.addNewProduct': 'Add New Product',
  'manager.bundles.addNew': 'New',
  'manager.bundles.addNewStay': 'Add New Stay',
  'manager.bundles.addNewActivity': 'Add New Activity',
  'manager.bundles.addNewFood': 'Add New Food',
  'manager.bundles.createAndSelect': 'Create & Select',
  'manager.bundles.stayNamePlaceholder': 'Stay name',
  'manager.bundles.activityNamePlaceholder': 'Activity name',
  'manager.bundles.foodNamePlaceholder': 'Food name',
  'manager.bundles.openingPeriods': 'Opening Periods',
  'manager.bundles.openingPeriodsDescription': 'Define the periods when this bundle is available',
  'manager.bundles.periodOfActivation': 'Period of Activation',
  'manager.bundles.periodOfActivationDescription': 'Define the valid range for this created bundle',
  'manager.bundles.setActivationPeriod': 'Set Activation Period',
  'manager.bundles.autoCalculated': 'Auto-calculated',
  'manager.bundles.priceCalculationNote': 'Price is automatically calculated based on added products and their pricing types',
  'manager.bundles.durationCalculationNote': 'Duration is automatically calculated based on the defined opening periods',
  'manager.bundles.originalPrice': 'Original Price',
  'manager.bundles.youSave': 'You Save',
  'manager.bundles.savingsPercentage': 'Savings of {{percentage}}%',
  'manager.bundles.numberOfPasses': 'Number of Passes',
  'manager.bundles.numberOfConsumers': 'Number of Consumers',
  'manager.bundles.passes': 'passes',
  'manager.bundles.consumers': 'consumers',
  'manager.bundles.matchClientGroupSize': 'Match client group size',
  'manager.bundles.minimumClients': 'Minimum clients',
  'manager.bundles.minimumClientsPlaceholder': 'e.g., 2',
  'manager.bundles.discountTiers': 'Discount Tiers',
  'manager.bundles.addDiscountTier': 'Add Discount Tier',
  'manager.bundles.minClients': 'Min',
  'manager.bundles.maxClients': 'Max',
  'manager.bundles.clients': 'clients',
  'manager.bundles.percentage': 'Percentage',
  'manager.bundles.amount': 'Amount',
  'manager.bundles.matchesClientGroup': 'Matches group',
  'manager.bundles.optional': 'Optional',
  'manager.bundles.packages': 'Packages',
  'manager.bundles.calendar': 'Campaign Calendar',
  'manager.bundle.calendar': 'Bundle Package Calendar',
  'manager.bundle.description': 'Plan and manage your bundle package campaigns',
  'manager.bundle.createNew': 'Create Bundle',
  'manager.bundle.editBundle': 'Edit Bundle',
  'manager.bundle.bundleName': 'Bundle Name',
  'manager.bundle.namePlaceholder': 'e.g., Summer Adventure Bundle',
  'manager.bundle.color': 'Color',
  'manager.bundle.activeBundles': 'Active Bundles',
  'manager.bundle.noBundles': 'No bundles created yet',
  'manager.bundle.fillAllFields': 'Please fill all fields',
  'manager.bundle.confirmDelete': 'Are you sure you want to delete this bundle?',
  'manager.loyalty.pageTitle': 'Loyalty program',
  'manager.loyalty.pageSubtitle':
    'Configure the points-per-dollar ratio and milestones shown to clients on their dashboard.',
  'manager.loyalty.settingsCardSubtitle': 'Points ratio and milestones shown to clients',
  'manager.loyalty.ratioSectionTitle': 'Points ratio',
  'manager.loyalty.pointsPerDollarLabel': 'Points earned per dollar spent (before tax)',
  'manager.loyalty.pointsPerDollarHint': 'e.g. 1 = 1 point per dollar, 2 = 2 points per dollar',
  'manager.loyalty.pointValueLabel': 'Dollar value of one point (shown to the client)',
  'manager.loyalty.pointValueHint': 'e.g. 0.10 = each point is worth $0.10',
  'manager.loyalty.unitPtPerDollar': 'pt / $',
  'manager.loyalty.unitCadPerPt': 'CAD / pt',
  'manager.loyalty.previewLine':
    'Preview: a $100 booking (before tax) earns {points} points, worth about {value} to the client.',
  'manager.loyalty.milestonesTitle': 'Milestones (loyalty tiers)',
  'manager.loyalty.milestonesShortTitle': 'Milestones',
  'manager.loyalty.addMilestone': 'Add milestone',
  'manager.loyalty.emptyMilestones': 'No milestones yet — click “Add milestone” to create one.',
  'manager.loyalty.emptyMilestonesSettings': 'No milestones yet — click “Add” to create one.',
  'manager.loyalty.thresholdPlaceholder': 'Points',
  'manager.loyalty.ptsArrow': 'pts →',
  'manager.loyalty.levelPlaceholder': 'Tier name (e.g. Bronze)',
  'manager.loyalty.milestonesSortHint':
    'Milestones are sorted by point threshold (ascending) when you save.',
  'manager.loyalty.saveSettings': 'Save settings',
  'manager.loyalty.savedSettings': 'Saved ✓',
  'manager.loyalty.saveError': 'Error',
  'manager.discount.title': 'Discount Management',
  'manager.discount.navLabel': 'Discounts',
  'manager.discount.archivedIntroTitle': 'Discounts (archived demo)',
  'manager.discount.archivedIntroBody':
    'Legacy module: mock codes, volume tiers, and campaign calendar. State is not saved to Convex and does not apply at checkout. Use Bundles for packages; use VUM codes for promovalidation.com flows.',
  'manager.discount.subtitle': 'Manage your discount codes and promotions',
  'manager.discount.addDiscount': 'Add Discount',
  'manager.discount.totalDiscounts': 'Total Discounts',
  'manager.discount.active': 'Active',
  'manager.discount.percentage': 'Percentage',
  'manager.discount.fixed': 'Fixed Amount',
  'manager.discount.name': 'Name',
  'manager.discount.code': 'Code',
  'manager.discount.type': 'Type',
  'manager.discount.value': 'Value',
  'manager.discount.validFrom': 'Valid From',
  'manager.discount.validTo': 'Valid To',
  'manager.discount.status': 'Status',
  'manager.discount.status.active': 'Active',
  'manager.discount.status.inactive': 'Inactive',
  'manager.discount.status.expired': 'Expired',
  'manager.discount.editDiscount': 'Edit Discount',
  'manager.discount.basicInfo': 'Basic Information',
  'manager.discount.conditions': 'Conditions',
  'manager.discount.validityPeriod': 'Validity Period',
  'manager.discount.minPurchase': 'Minimum Purchase',
  'manager.discount.maxDiscount': 'Maximum Discount',
  'manager.discount.usageLimit': 'Usage Limit',
  'manager.discount.optional': 'Optional',
  'manager.discount.confirmDelete': 'Are you sure you want to delete this discount?',
  'manager.discount.codeManagement': 'Discount Code Management',
  'manager.discount.codeManagementDescription': 'Generate and manage discount codes for your promotions',
  'manager.discount.selectDiscount': 'Select Discount',
  'manager.discount.generateCodes': 'Generate Codes',
  'manager.discount.discountName': 'Discount Name',
  'manager.discount.generatedAt': 'Generated At',
  'manager.discount.usedAt': 'Used At',
  'manager.discount.copyCode': 'Copy Code',
  'manager.discount.codeStatus.active': 'Active',
  'manager.discount.codeStatus.used': 'Used',
  'manager.discount.codeStatus.expired': 'Expired',
  'manager.discount.confirmDeleteCode': 'Are you sure you want to delete this code?',
  'manager.discount.volumeDiscount': 'Volume/Conditional Discount',
  'manager.discount.volumeDiscountDescription': 'Set automatic discounts based on purchase amount',
  'manager.discount.conditionalDiscount': 'Conditional Discount',
  'manager.discount.conditionalDiscountDescription': 'Set automatic discounts based on purchase amount',
  'manager.discount.addVolumeDiscount': 'Add Volume Discount',
  'manager.discount.generalDiscount': 'General Discount',
  'manager.discount.purchaseAmount': 'Purchase Amount',
  'manager.discount.discountType': 'Discount Type',
  'manager.discount.discountValue': 'Discount Value',
  'manager.discount.confirmDeleteVolumeDiscount': 'Are you sure you want to delete this volume discount?',
  'manager.discount.regularDiscounts': 'Regular Discounts',
  'manager.discount.seasonTabs.all': 'Entire Year',
  'manager.discount.seasonTabs.summer': 'Summer',
  'manager.discount.seasonTabs.winter': 'Winter',
  'manager.discount.seasonSettings': 'Season Settings',
  'manager.discount.effectiveProducts': 'Effective Products',
  'manager.discount.effectiveProductsDescription': 'Select the products that trigger this conditional discount',
  'manager.bookings.title': 'Bookings (Reservations)',
  'manager.bookings.navLabel': 'Bookings',
  'manager.bookings.subtitle': 'Accommodation reservations. Toggle paid status below.',
  'manager.bookings.totalBookings': 'Total bookings',
  'manager.bookings.paidBookings': 'Paid',
  'manager.bookings.confirmed': 'Confirmed',
  'manager.bookings.guest': 'Guest',
  'manager.bookings.accommodation': 'Accommodation',
  'manager.bookings.checkIn': 'Check-in',
  'manager.bookings.checkOut': 'Check-out',
  'manager.bookings.guests': 'Guests',
  'manager.bookings.total': 'Total',
  'manager.bookings.paid': 'Paid',
  'manager.bookings.status': 'Status',
  'manager.bookings.noBookings': 'No bookings yet.',
  'manager.bookings.markPaid': 'Mark as paid',
  'manager.bookings.markUnpaid': 'Mark as unpaid',
  'manager.orders.viewGuestProfile': 'Guest profile',
  'manager.orders.title': 'Orders Management',
  'manager.orders.navLabel': 'Orders',
  'manager.orders.subtitle': 'Manage customer orders, modify or cancel products',
  'manager.orders.addOrder': 'New order',
  'manager.orders.addReservation': 'New order',
  'manager.orders.backFromNewOrder': 'Back to orders',
  'manager.orders.backFromNewReservation': 'Back to orders',
  'manager.orders.newOrderPageTitle': 'New order',
  'manager.orders.newOrderPageSubtitle':
    'Build a customer order: add stays, activities, and packages, then collect payment or save without online payment.',
  'manager.orders.newReservationPageTitle': 'New order',
  'manager.orders.newReservationPageSubtitle':
    'Build a customer order: add stays, activities, and packages, then collect payment or save without online payment.',
  'manager.orders.sectionProducts': 'Products',
  'manager.orders.sectionStayDates': 'Dates and guests',
  'manager.orders.stepBasicInfo': 'Basic info',
  'manager.orders.stepProducts': 'Products',
  'manager.orders.stepPayment': 'Payment',
  'manager.orders.nextStep': 'Next',
  'manager.orders.backStep': 'Back',
  'manager.orders.productTabStay': 'Stays',
  'manager.orders.productTabActivity': 'Activities',
  'manager.orders.productTabBundle': 'Bundles',
  'manager.orders.productTabFood': 'Food',
  'manager.orders.stayCalendarHint':
    'Select a stay, then use the calendar to pick an available date. The book button adds the stay and prefills check-in.',
  'manager.orders.productType': 'Product type',
  'manager.orders.productTypeStay': 'Stay',
  'manager.orders.productTypeActivity': 'Activity',
  'manager.orders.productTypePackage': 'Package',
  'manager.orders.selectProduct': 'Select product…',
  'manager.orders.productQuantity': 'Quantity',
  'manager.orders.addProduct': 'Add to order',
  'manager.orders.removeProduct': 'Remove',
  'manager.orders.noProductsYet': 'No products yet — add items to build the order.',
  'manager.orders.beforeTaxShort': 'before tax',
  'manager.orders.newOrderCustomPreTaxHint':
    'Adjusts the order pre-tax subtotal. GST, QST, and lodging tax are recalculated using standard rules.',
  'manager.orders.newOrderErrNeedProduct': 'Add at least one product to the order.',
  'manager.orders.newOrderErrNeedStay': 'Add at least one stay — required to save the order.',
  'manager.orders.newOrderErrDuplicateStay': 'This stay is already in the order.',
  'manager.orders.newOrderBundledItems': 'Order items',
  'manager.orders.submitWithoutCardOrder': 'Create order (no online payment)',
  'manager.orders.paymentCardNeedOrderFirstTitle': 'Amount and card form not ready yet',
  'manager.orders.paymentCardNeedOrderFirstBody':
    'Add products and, when the order includes a stay, enter valid check-in and check-out dates to show the amount and payment form.',
  'manager.orders.prefilledFromDashboardCalendar':
    'Stay and dates were pre-filled from the dashboard calendar. Complete guest details, then confirm or collect payment.',
  'manager.orders.sectionGuest': 'Guest',
  'manager.orders.sectionStay': 'Stay',
  'manager.orders.sectionPayment': 'Payment',
  'manager.orders.fieldFirstName': 'First name',
  'manager.orders.fieldLastName': 'Last name',
  'manager.orders.fieldEmail': 'Email',
  'manager.orders.fieldPhone': 'Phone',
  'manager.orders.fieldAccommodation': 'Accommodation',
  'manager.orders.selectAccommodation': 'Select accommodation…',
  'manager.orders.fieldCheckIn': 'Check-in',
  'manager.orders.fieldCheckOut': 'Check-out',
  'manager.orders.fieldAdults': 'Adults',
  'manager.orders.fieldChildren': 'Children',
  'manager.orders.decrementAdults': 'Decrease adults',
  'manager.orders.incrementAdults': 'Increase adults',
  'manager.orders.decrementChildren': 'Decrease children',
  'manager.orders.incrementChildren': 'Increase children',
  'manager.orders.guestCountCapacityHint': 'Maximum accommodation capacity: {count} guests.',
  'manager.orders.customizePreTaxPrice': 'Customize pre-tax amount',
  'manager.orders.customPreTaxPriceLabel': 'Amount before tax (CAD)',
  'manager.orders.customPreTaxPriceHint':
    'Adjusts the accommodation subtotal only. GST, QST, and lodging tax are recalculated using standard rules.',
  'manager.orders.customPreTaxPriceInvalid': 'Enter a valid pre-tax amount (0 or greater).',
  'manager.orders.customPreTaxPriceApplied': 'Custom pre-tax price — taxes recalculated automatically.',
  'manager.orders.fieldSpecialRequests': 'Special requests',
  'manager.orders.summaryNights': 'Nights',
  'manager.orders.summaryTotalTTC': 'Estimated total (tax-included)',
  'manager.orders.summaryDepositNote':
    'A 30% deposit will be charged according to Clover settings; balance due at arrival.',
  'manager.orders.paymentOptionFull': 'Card — pay full amount (GST/QST/lodging tax included)',
  'manager.orders.paymentOptionLink': 'Send payment link — client pays on their device (Clover)',
  'manager.orders.paymentLinkIntro':
    'A pending reservation will be created and a secure email with a 7-day Clover payment link will be sent to the client.',
  'manager.orders.sendPaymentLink': 'Create and send payment link',
  'manager.orders.newOrderPaymentLinkSuccess':
    'Order created — payment link emailed to the client.',
  'manager.orders.paymentOptionLater': 'No online payment — pending reservation',
  'manager.orders.submitWithoutCard': 'Create reservation (no online payment)',
  'manager.orders.paymentCardNeedStayFirstTitle': 'Amount and card form not ready yet',
  'manager.orders.paymentCardNeedStayFirstBody':
    'To show the amount, card fields, and pay button, complete the Stay section first: pick an accommodation and valid check-in / check-out dates (check-out must be after check-in).',
  'manager.orders.paymentCardFormIntro':
    'Enter the card details below, then use the Pay button to save the reservation and charge.',
  'manager.orders.newReservationErrGuestName': 'Enter the guest first and last name.',
  'manager.orders.newReservationErrEmail': 'Guest email is required.',
  'manager.orders.newReservationErrStay': 'Select an accommodation.',
  'manager.orders.newReservationErrDates': 'Enter check-in and check-out dates.',
  'manager.orders.newReservationErrDatesOrder': 'Check-out must be after check-in.',
  'manager.orders.newReservationErrTotals': 'Cannot compute totals — check dates and accommodation.',
  'manager.orders.newReservationErrGuests': 'Enter at least one guest.',
  'manager.orders.newReservationErrCapacity': 'Guest count exceeds accommodation capacity.',
  'manager.orders.totalOrders': 'Total Orders',
  'manager.orders.paidOrders': 'Paid Orders',
  'manager.orders.confirmedOrders': 'Confirmed Orders',
  'manager.orders.cancelledOrders': 'Cancelled Orders',
  'manager.orders.orderNumber': 'Order Number',
  'manager.orders.customer': 'Customer',
  'manager.orders.items': 'Items',
  'manager.orders.totalAmount': 'Total Amount',
  'manager.orders.unitPriceBeforeTax': 'Unit price (before tax)',
  'manager.orders.filterDateField': 'Filter by',
  'manager.orders.filterByStayDates': 'Stay dates',
  'manager.orders.filterByCreatedAt': 'Created date',
  'manager.orders.listingViewLabel': 'Listing view',
  'manager.orders.listingViewCreatedAt': 'Reservation created',
  'manager.orders.listingViewStayDates': 'Stay / reserved dates',
  'manager.orders.listingViewCreatedAtHint':
    'Sort: newest reservations first. Date filter applies to creation time.',
  'manager.orders.listingViewStayDatesHint':
    'Sort: today → future, then past stays. Date filter applies to stay dates.',
  'manager.orders.filterDateFrom': 'From',
  'manager.orders.filterDateTo': 'To',
  'manager.orders.filterDateClear': 'Clear dates',
  'manager.orders.filterDateResultCount': '{count} order(s)',
  'manager.orders.filterByStayDatesHint':
    'Shows orders whose stay overlaps the selected period (check-in / check-out).',
  'manager.orders.filterByCreatedAtHint': 'Shows orders created within the selected period.',
  'manager.orders.pricingFootnote':
    'GST, QST, and lodging tax use values saved at checkout when they match the grand total; otherwise they are estimated from the total (same as cart: lodging tax on the accommodation base when applicable, then GST and QST each on the taxable amount; QST is not on GST) and the stay’s lodging-tax setting. Client total is the amount charged (tax-included).',
  'manager.orders.colPreTax': 'Pre-tax',
  'manager.orders.colQst': 'QST',
  'manager.orders.colGst': 'GST',
  'manager.orders.colLodging': 'Lodging',
  'manager.orders.colTotal': 'Total',
  'manager.orders.colBalance': 'Balance due',
  'manager.orders.colHearAboutUs': 'Source',
  'manager.orders.colGuest': 'Type',
  'manager.orders.colClientId': 'Client ID',
  'manager.orders.guestLabel': 'Guest',
  'manager.orders.memberLabel': 'Member',
  'manager.orders.subtotalLinesBeforeTax': 'Subtotal (before tax)',
  'manager.orders.status': 'Status',
  'manager.orders.status.pending': 'Pending',
  'manager.orders.status.paid': 'Paid',
  'manager.orders.status.confirmed': 'Confirmed',
  'manager.orders.status.cancelled': 'Cancelled',
  'manager.orders.paymentStatus': 'Payment Status',
  'manager.orders.paymentStatus.unpaid': 'Unpaid',
  'manager.orders.paymentStatus.paid': 'Paid',
  'manager.orders.paymentStatus.refunded': 'Refunded',
  'manager.orders.createdAt': 'Created At',
  'manager.orders.editOrder': 'Edit Order',
  'manager.orders.confirmOrder': 'Confirm Order',
  'manager.orders.markAsPaid': 'Mark as Paid',
  'manager.orders.notifyEmployees': 'Notify Employees',
  'manager.orders.confirmCancel': 'Are you sure you want to cancel this order?',
  'manager.orders.confirmDelete': 'Are you sure you want to delete this order? This action cannot be undone.',
  'manager.orders.delete': 'Delete',
  'manager.orders.orderItems': 'Order Items',
  'manager.orders.productName': 'Product Name',
  'manager.orders.quantity': 'Quantity',
  'manager.orders.price': 'Price',
  'manager.orders.total': 'Total',
  'manager.orders.notificationMessage': 'You are about to send a notification to employees regarding this paid and confirmed order.',
  'manager.orders.sendNotification': 'Send Notification',
  'manager.orders.notificationSent': 'Notification sent successfully to employees',
  'manager.orders.tabs.waiting': 'Waiting',
  'manager.orders.tabs.confirmed': 'Confirmed',
  'manager.orders.tabs.completed': 'Completed',
  'manager.orders.tabs.passed': 'Passed',
  'manager.orders.tabs.paid': 'Paid',
  'manager.orders.modifyDates': 'Modify Dates',
  'manager.orders.updateStatus': 'Update Status',
  'manager.orders.confirmByStaff': 'Confirm (treated by employee/admin)',
  'manager.orders.confirmStaffEmailQueued':
    'Reservation confirmed. A “booking confirmed” email will be sent to the guest shortly.',
  'manager.orders.confirmStaffNoGuestEmail':
    'Reservation confirmed, but no email is available for this guest — no automated email was sent. Add an email on the guest profile or contact them directly.',
  'manager.orders.confirmStaffNoResendKey':
    'Reservation confirmed, but RESEND_API_KEY is not set on Convex — no email was sent. Add it in your deployment environment variables.',
  'manager.orders.noCustomerEmailHint': 'No email — cannot send confirmation email',
  'manager.orders.cancel': 'Cancel',
  'manager.orders.startDate': 'Start Date',
  'manager.orders.endDate': 'End Date',
  'manager.orders.bookingDates': 'Booking Dates',
  'manager.orders.cancelOrder': 'Cancel Order',
  'manager.orders.cancelWarning': 'This action will cancel the order. Please select the refund type.',
  'manager.orders.refundType': 'Refund Type',
  'manager.orders.refund': 'Refund',
  'manager.orders.refundDescription': 'Refund the amount to the customer',
  'manager.orders.refundAsCredit': 'Refund as Credit',
  'manager.orders.refundAsCreditDescription': 'Convert the amount to credit for the customer',
  'manager.orders.cancelReason': 'Cancellation Reason',
  'manager.orders.cancelReasonPlaceholder': 'Reason for cancellation (optional)',
  'manager.orders.refundAmount': 'Refund Amount',
  'manager.orders.paymentStatus.downpayment': 'Downpayment (30%)',
  'manager.orders.paymentStatus.refundedAsCredit': 'Refunded as Credit',
  'manager.orders.status.completed': 'Completed',
  'manager.orders.status.passed': 'Passed',
  'manager.orders.downpaymentAmount': 'Downpayment Amount',
  'manager.orders.downpaymentPercentage': 'Downpayment Percentage',
  'manager.orders.remainingAmount': 'Remaining Amount',
  'manager.orders.selectInformation': 'Select Information to Include',
  'manager.orders.customMessage': 'Custom Message',
  'manager.orders.customMessagePlaceholder': 'Add a custom message for employees...',
  'manager.orders.preview': 'Preview',
  'manager.orders.message': 'Message',
  'manager.orders.customerEmail': 'Customer Email',
  'manager.orders.optional': 'Optional',
  'manager.orders.tabs.all': 'All',
  'manager.orders.tabs.emailTemplates': 'Email Templates',
  'manager.orders.emailTemplates.title': 'Email Templates',
  'manager.orders.emailTemplates.description': 'Customize the two templates sent to customers via Resend. Use variables to insert booking data.',
  'manager.orders.emailTemplates.bookingConfirmationDesc': 'Sent automatically when a customer submits a booking.',
  'manager.orders.emailTemplates.bookingConfirmedDesc': 'Sent when a staff member or admin confirms the booking.',
  'manager.orders.emailTemplates.confirmedName': 'Booking confirmed by staff',
  'manager.orders.emailTemplates.placedDesc': 'Booking received',
  'manager.orders.emailTemplates.customized': 'Customized',
  'manager.orders.emailTemplates.default': 'Default',
  'manager.orders.emailTemplates.testTemplate': 'Template to test',
  'manager.orders.emailTemplates.variables': 'Variables',
  'manager.orders.emailTemplates.editTemplate': 'Edit template',
  'manager.orders.emailTemplates.templateName': 'Template name',
  'manager.orders.emailTemplates.subject': 'Subject',
  'manager.orders.emailTemplates.htmlBody': 'HTML body',
  'manager.orders.emailTemplates.textBody': 'Text body',
  'manager.orders.emailTemplates.sendTest': 'Send test',
  'manager.orders.emailTemplates.testTitle': 'Send test email',
  'manager.orders.emailTemplates.testDescription': 'Sends an email with sample data to the address below (via Resend). Save the template first.',
  'manager.orders.emailTemplates.testTo': 'Send to',
  'manager.orders.emailTemplates.sending': 'Sending…',
  'manager.orders.emailTemplates.testSent': 'Test email sent. Check your inbox.',
  'manager.orders.emailTemplates.saveFirst': 'Save the template (Edit then Save) before sending a test.',
  'manager.orders.notifyClient': 'Notify Client',
  'manager.orders.clientNotificationSent': 'Notification sent to client successfully',
  'manager.orders.communicationTemplates': 'Communication Templates',
  'manager.orders.communicationTemplatesDescription': 'Create and manage message templates for client communication',
  'manager.orders.createTemplate': 'Create Template',
  'manager.orders.editTemplate': 'Edit Template',
  'manager.orders.templateName': 'Template Name',
  'manager.orders.communicationMethod': 'Communication Method',
  'manager.orders.method.email': 'Email',
  'manager.orders.method.sms': 'SMS',
  'manager.orders.method.both': 'Email & SMS',
  'manager.orders.trigger': 'Trigger',
  'manager.orders.trigger.onConfirmation': 'On Confirmation',
  'manager.orders.trigger.onPayment': 'On Payment',
  'manager.orders.trigger.onReminder': 'On Reminder',
  'manager.orders.trigger.custom': 'Custom',
  'manager.orders.subject': 'Subject',
  'manager.orders.subjectPlaceholder': 'Message subject',
  'manager.orders.content': 'Content',
  'manager.orders.contentPlaceholder': 'Message content...',
  'manager.orders.contentVariables': 'Available variables',
  'manager.orders.recentCommunications': 'Recent Communications',
  'manager.orders.sendMessage': 'Send Message',
  'manager.orders.selectTemplate': 'Select Template',
  'manager.orders.noTemplate': 'No Template',
  'manager.orders.messagePlaceholder': 'Your message...',
  'manager.orders.messagePreview': 'Message preview will appear here',
  'manager.orders.sendAsReminder': 'Send as Reminder',
  'manager.orders.to': 'To',
  'manager.orders.templates.orderConfirmation': 'Order Confirmation',
  'manager.orders.templates.confirmationSubject': 'Confirmation of your order {orderNumber}',
  'manager.orders.templates.confirmationContent': 'Hello {customerName},\\n\\nWe confirm your order {orderNumber} for the amount of {totalAmount}.\\n\\nThank you for your trust!',
  'manager.orders.templates.paymentReminder': 'Payment Reminder',
  'manager.orders.templates.reminderSubject': 'Reminder: Payment for order {orderNumber}',
  'manager.orders.templates.reminderContent': 'Hello {customerName},\\n\\nThis is a reminder regarding the payment of your order {orderNumber} for the amount of {totalAmount}.\\n\\nPlease complete your payment.',
  'manager.orders.templates.bookingReminder': 'Booking Reminder',
  'manager.orders.templates.bookingReminderSubject': 'Reminder: Your booking is approaching',
  'manager.orders.templates.bookingReminderContent': 'Hello {customerName},\\n\\nWe remind you of your booking for order {orderNumber}.\\n\\nWe look forward to welcoming you!',
  'manager.orders.templates.newTemplate': 'New Template',
  'manager.clients.navLabel': 'Clients',
  'manager.clients.title': 'Client Management',
  'manager.clients.subtitle': 'Manage your guest and registered member clients',
  'manager.clients.guest': 'Guest',
  'manager.clients.member': 'Member',
  'manager.clients.totalGuests': 'Total Guests',
  'manager.clients.totalMembers': 'Total Members',
  'manager.clients.totalPurchases': 'Total Purchases',
  'manager.clients.totalRevenue': 'Total Revenue',
  'manager.clients.vipMembers': 'VIP Members',
  'manager.clients.name': 'Name',
  'manager.clients.contact': 'Contact',
  'manager.clients.purchases': 'Purchases',
  'manager.clients.totalSpent': 'Total Spent',
  'manager.clients.lastPurchase': 'Last Purchase',
  'manager.clients.email': 'Email',
  'manager.clients.phone': 'Phone',
  'manager.clients.registeredAt': 'Registered At',
  'manager.clients.lastLogin': 'Last Login',
  'manager.clients.totalBookings': 'Total Bookings',
  'manager.clients.status': 'Status',
  'manager.clients.status.active': 'Active',
  'manager.clients.status.inactive': 'Inactive',
  'manager.clients.type.new': 'New',
  'manager.clients.type.returning': 'Returning',
  'manager.clients.type.vip': 'VIP',
  'manager.clients.purchaseStatus.completed': 'Completed',
  'manager.clients.purchaseStatus.pending': 'Pending',
  'manager.clients.purchaseStatus.cancelled': 'Cancelled',
  'manager.clients.noContact': 'No Contact',
  'manager.clients.search': 'Search...',
  'manager.clients.guestList': 'Guest List',
  'manager.clients.memberList': 'Member List',
  'manager.clients.addGuest': 'Add Guest',
  'manager.employees.title': 'Employee Management',
  'manager.employees.navLabel': 'Employees',
  'manager.employees.subtitle': 'Manage your team and their information',
  'manager.employees.addEmployee': 'Add Employee',
  'manager.employees.totalEmployees': 'Total Employees',
  'manager.employees.active': 'Active',
  'manager.employees.inactive': 'Inactive',
  'manager.employees.departments': 'Departments',
  'manager.employees.name': 'Name',
  'manager.employees.email': 'Email',
  'manager.employees.phone': 'Phone',
  'manager.employees.role': 'Role',
  'manager.employees.department': 'Department',
  'manager.employees.status': 'Status',
  'manager.financial.title': 'Financial Management',
  'manager.financial.navLabel': 'Financial',
  'manager.financial.subtitle': 'Track your income and expenses',
  'manager.financial.addTransaction': 'Add Transaction',
  'manager.financial.export': 'Export',
  'manager.financial.totalIncome': 'Total Income',
  'manager.financial.totalExpenses': 'Total Expenses',
  'manager.financial.netProfit': 'Net Profit',
  'manager.financial.pendingTransactions': 'Pending Transactions',
  'manager.financial.date': 'Date',
  'manager.financial.type': 'Type',
  'manager.financial.category': 'Category',
  'manager.financial.description': 'Description',
  'manager.financial.amount': 'Amount',
  'manager.financial.status': 'Status',
  'manager.financial.income': 'Income',
  'manager.financial.expense': 'Expense',
  'manager.financial.completed': 'Completed',
  'manager.financial.pending': 'Pending',
  'manager.financial.viewDetails': 'View Details',
  'manager.financial.download': 'Download',
  'manager.financial.category.reservations': 'Reservations',
  'manager.financial.category.maintenance': 'Maintenance',
  'manager.financial.category.activities': 'Activities',
  'manager.financial.category.supplies': 'Supplies',
  'manager.reports.navLabel': 'Reports',
  'manager.reports.pageTitle': 'Reports & analytics',
  'manager.reports.pageSubtitle': 'Track your outfitter performance',
  'manager.reports.devBannerTitle': 'In development — not activated',
  'manager.reports.devBannerBody':
    'Reports and exports are not activated yet. What you see below is a preview with mock data; buttons and actions are not connected to production.',
  'manager.reports.devActionDisabled': 'Unavailable until this feature is activated',
  'manager.reports.devMockDataNote': 'Preview data only.',
  'manager.reports.export': 'Export',
  'manager.reports.refresh': 'Refresh',
  'manager.reports.periodLabel': 'Period:',
  'manager.reports.reportLabel': 'Report:',
  'manager.reports.period.week': 'This week',
  'manager.reports.period.month': 'This month',
  'manager.reports.period.quarter': 'This quarter',
  'manager.reports.period.year': 'This year',
  'manager.reports.type.revenue': 'Revenue',
  'manager.reports.type.occupancy': 'Occupancy',
  'manager.reports.type.reservations': 'Reservations',
  'manager.reports.type.performance': 'Performance',
  'manager.reports.metric.revenue': 'Revenue',
  'manager.reports.metric.occupancyRate': 'Occupancy rate',
  'manager.reports.metric.reservations': 'Reservations',
  'manager.reports.metric.averageRate': 'Average rate',
  'manager.reports.vsLastMonth': 'vs last month',
  'manager.reports.section.revenueTrend': 'Revenue trend',
  'manager.reports.legend.revenue': 'Revenue',
  'manager.reports.section.occupancyChart': 'Occupancy rate',
  'manager.reports.legend.occupancy': 'Occupancy',
  'manager.reports.section.perAccommodation': 'Performance by accommodation',
  'manager.reports.viewAll': 'View all',
  'manager.reports.col.accommodation': 'Accommodation',
  'manager.reports.col.revenue': 'Revenue',
  'manager.reports.col.occupancy': 'Occupancy',
  'manager.reports.col.nights': 'Nights',
  'manager.reports.col.performance': 'Performance',
  'manager.reports.performance.excellent': 'Excellent',
  'manager.reports.performance.good': 'Good',
  'manager.reports.performance.needsImprovement': 'Needs improvement',
  'manager.reports.exportTitle': 'Export your reports',
  'manager.reports.exportDesc': 'Download your data as Excel or PDF for detailed tracking',
  'manager.reports.exportExcel': 'Export to Excel',
  'manager.reports.exportPdf': 'Export to PDF',
  'manager.reports.demoMonth.jan': 'Jan',
  'manager.reports.demoMonth.feb': 'Feb',
  'manager.reports.demoMonth.mar': 'Mar',
  'manager.reports.demoMonth.apr': 'Apr',
  'manager.reports.demoMonth.may': 'May',
  'manager.reports.demoMonth.jun': 'Jun',
  'manager.reminders.title': 'Reminder Management',
  'manager.reminders.navLabel': 'Reminders',
  'manager.reminders.subtitle': 'Manage your reminders and tasks',
  'manager.reminders.devBannerTitle': 'In development — not activated',
  'manager.reminders.devBannerBody':
    'Reminder automations are not activated yet. What you see below is a preview with mock data; buttons and actions are not connected to production.',
  'manager.reminders.devActionDisabled': 'Unavailable until this feature is activated',
  'manager.reminders.devMockDataNote': 'Preview data only.',
  'manager.reminders.addReminder': 'Add Reminder',
  'manager.reminders.totalReminders': 'Total Reminders',
  'manager.reminders.pending': 'Pending',
  'manager.reminders.completed': 'Completed',
  'manager.reminders.highPriority': 'High Priority',
  'manager.reminders.type': 'Type',
  'manager.reminders.dueDate': 'Due Date',
  'manager.reminders.priority': 'Priority',
  'manager.reminders.status': 'Status',
  'manager.reminders.assignedTo': 'Assigned To',
  'manager.reminders.type.maintenance': 'Maintenance',
  'manager.reminders.type.payment': 'Payment',
  'manager.reminders.type.reservation': 'Reservation',
  'manager.reminders.type.other': 'Other',
  'manager.reminders.priority.high': 'High',
  'manager.reminders.priority.medium': 'Medium',
  'manager.reminders.priority.low': 'Low',
  'manager.marketing.navLabel': 'Marketing',
  'manager.web.title': 'Web Management',
  'manager.web.navLabel': 'Web',
  'manager.web.subtitle': 'Manage your website content',
  'manager.web.bookingEmailsHint':
    'Automated booking emails (confirmation, reminders) are configured under Orders → Email templates.',
  'manager.web.landingPage': 'Landing Page',
  'manager.web.landingPageDesc': 'Manage landing page content',
  'manager.web.content': 'Content',
  'manager.web.contentDesc': 'Manage texts and descriptions',
  'manager.web.media': 'Media',
  'manager.web.mediaDesc': 'Manage images and videos',
  'manager.web.settings': 'Settings',
  'manager.web.settingsDesc': 'Configure website settings',
  'manager.media.navLabel': 'Photos',
  'manager.media.title': 'Photos',
  'manager.media.subtitle':
    'Upload compressed photos to the public gallery, a stay, or an activity.',
  'manager.media.uploadSection': 'Upload',
  'manager.media.placement': 'Attach to',
  'manager.media.placementGallery': 'Website gallery',
  'manager.media.placementStay': 'Stay',
  'manager.media.placementActivity': 'Activity',
  'manager.media.optionalTitle': 'Title (optional)',
  'manager.media.titlePlaceholder': 'e.g. Sunset over the lake',
  'manager.media.compressLabel': 'Compress before upload',
  'manager.media.compressHint':
    'Recommended for phone photos (often 10–15 MB). Reduces size for the website while keeping good quality.',
  'manager.media.quality': 'Quality',
  'manager.media.maxEdge': 'Max size (px)',
  'manager.media.recommended': 'recommended',
  'manager.media.dropHint': 'Drop photos here or click to browse',
  'manager.media.formats': 'JPEG, PNG, WebP (HEIC if the browser supports it)',
  'manager.media.uploading': 'Compressing & uploading…',
  'manager.media.statusCompressing': 'compressing',
  'manager.media.statusUploading': 'uploading',
  'manager.media.statusDone': 'done',
  'manager.media.statusError': 'error',
  'manager.media.library': 'Library',
  'manager.media.empty': 'No photos yet.',
  'manager.media.untitled': 'Untitled',
  'manager.media.changePlacement': 'Change attachment',
  'manager.media.confirmDelete': 'Delete this photo?',
  'manager.media.selectStay': 'Select a stay first.',
  'manager.media.selectActivity': 'Select an activity first.',
  'manager.media.imagesOnly': 'Please choose image files.',
  'manager.media.readyToUpload': 'Ready to upload',
  'manager.media.confirmUpload': 'Confirm upload',
  'manager.media.clearSelection': 'Clear selection',
  'manager.settings.title': 'Settings',
  'manager.settings.navLabel': 'Settings',
  'manager.settings.subtitle': 'Configure system settings',
  'manager.settings.general': 'General',
  'manager.settings.generalDesc': 'General application settings',
  'manager.settings.notifications': 'Notifications',
  'manager.settings.notificationsDesc': 'Configure notifications',
  'manager.settings.security': 'Security',
  'manager.settings.securityDesc': 'Security and access settings',
  'manager.settings.localization': 'Localization',
  'manager.settings.localizationDesc': 'Languages and formats',
  'manager.settings.payment': 'Payment',
  'manager.settings.paymentDesc': 'Payment configuration',
  'manager.settings.users': 'Users',
  'manager.settings.usersDesc': 'User and permission management',
  'manager.settings.backup': 'Backup',
  'manager.settings.backupDesc': 'Backups and restoration'
},
  zh: {
  'manager.dashboard.welcome': '您好，{name}！',
  'manager.dashboard.subtitle': '这是今天小屋活动的概览',
  'manager.dashboard.totalReservations': '总预订数',
  'manager.dashboard.occupancyRate': '入住率',
  'manager.dashboard.monthlyRevenue': '本月收入',
  'manager.dashboard.upcomingArrivals': '即将到达',
  'manager.dashboard.recentReservations': '最近预订',
  'manager.dashboard.viewAll': '查看全部',
  'manager.dashboard.maintenanceAlerts': '维护警报',
  'manager.dashboard.quickActions': '快速操作',
  'manager.dashboard.newReservation': '新预订',
  'manager.dashboard.manageAccommodations': '管理住宿',
  'manager.dashboard.viewReports': '查看报告',
  'manager.dashboard.occupancyOverview': '入住概览',
  'manager.dashboard.noReservationsYet': '暂无预订',
  'manager.dashboard.noPendingReservations': '暂无待处理预订',
  'manager.dashboard.noAccommodationsConfigured': '尚未配置住宿',
  'manager.dashboard.confirmed': '已确认',
  'manager.dashboard.pending': '待处理',
  'manager.dashboard.pendingSidebarTitle': '待处理',
  'manager.dashboard.cancelled': '已取消',
  'manager.dashboard.urgent': '紧急',
  'manager.dashboard.medium': '中等',
  'manager.dashboard.low': '低',
  'manager.dashboard.available': '可用',
  'manager.dashboard.occupied': '已占用',
  'manager.dashboard.selectStayProduct': '住宿',
  'manager.dashboard.calendarViewAllTypes': '全部类型',
  'manager.dashboard.calendarViewSingleStay': '按住宿',
  'manager.dashboard.filterStayType': '住宿类型',
  'manager.dashboard.filterAllTypes': '全部类型',
  'manager.dashboard.filterProduct': '产品',
  'manager.dashboard.filterAllProducts': '全部产品',
  'manager.dashboard.filterProductHint': '选择类型后显示住宿产品。',
  'manager.dashboard.calendarCreateOrderHint': '点击日期查看可用住宿，再使用「新建订单」预订。',
  'manager.dashboard.calendarExpandHint': '点击日期可展开查看全部可用住宿，再次点击收起。',
  'manager.dashboard.calendarClickToSeeAll': '点击查看全部',
  'manager.dashboard.calendarProductFlowHint':
    '1）点击日期展开 · 2）悬停住宿查看详情 · 3）点击住宿创建订单。',
  'manager.dashboard.calendarTypeFlowHint':
    '1）点击日期展开 · 2）悬停类型 · 3）点击类型进入该类型日历。',
  'manager.dashboard.calendarTypeClickHint': '点击查看此类型',
  'manager.dashboard.calendarCollapseHint': '点击收起',
  'manager.dashboard.calendarMoreProducts': '更多',
  'manager.dashboard.calendarProductClickHint': '点击创建订单',
  'manager.dashboard.calendarConfirmNewOrderTitle': '创建新订单？',
  'manager.dashboard.calendarConfirmNewOrderBody': '为「{name}」在 {date} 打开新订单？',
  'manager.dashboard.calendarConfirmYes': '是',
  'manager.dashboard.calendarConfirmNo': '否',
  'manager.dashboard.calendarNewOrder': '新建订单',
  'manager.dashboard.calendarLegendAvailable': '可预订',
  'manager.dashboard.calendarLegendBooked': '已预订',
  'manager.dashboard.calendarLegendLocked': '临时锁定',
  'manager.dashboard.calendarSameAsWebsite': '与公开网站相同的日历（stays.availability）。',
  'manager.dashboard.manageSelectedStay': '管理此住宿',
  'manager.dashboard.bookForClient': '为客户预订',
  'manager.dashboard.bookForClientSuccess': '预订已保存。',
  'manager.dashboard.bookForClientPaymentLinkSuccess': '预订已创建 — 付款链接已通过邮件发送给客户。',
  'manager.accommodations.title': '住宿管理',
  'manager.accommodations.subtitle': '管理所有住宿及其可用性',
  'manager.accommodations.addNew': '添加住宿',
  'manager.accommodations.totalAccommodations': '总住宿数',
  'manager.accommodations.averagePrice': '平均价格',
  'manager.accommodations.edit': '编辑',
  'manager.accommodations.delete': '删除',
  'manager.accommodations.viewCalendar': '查看日历',
  'manager.accommodations.status': '状态',
  'manager.accommodations.price': '价格',
  'manager.accommodations.capacity': '容量',
  'manager.accommodations.location': '位置',
  'manager.accommodations.amenities': '设施',
  'manager.accommodations.actions': '操作',
  'manager.accommodations.search': '搜索住宿...',
  'manager.accommodations.filterByType': '按类型筛选',
  'manager.accommodations.filterByStatus': '按状态筛选',
  'manager.accommodations.allTypes': '所有类型',
  'manager.accommodations.allStatus': '所有状态',
  'manager.accommodations.chalet': '小屋',
  'manager.accommodations.yourte': '蒙古包',
  'manager.accommodations.cabane': '小屋',
  'manager.accommodations.tente': '帐篷',
  'manager.accommodations.available': '可用',
  'manager.accommodations.occupied': '已占用',
  'manager.accommodations.maintenance': '维护',
  'manager.accommodations.units': '排屋单位',
  'manager.accommodations.pricing': '定价',
  'manager.accommodations.basePrice': '基础价格',
  'manager.accommodations.basePriceDesc': '如果未设置工作日/周末价格，则使用默认价格',
  'manager.accommodations.weekdayPrice': '工作日价格',
  'manager.accommodations.weekdayPriceDesc': '工作日价格（周一至周五）',
  'manager.accommodations.weekendPrice': '周末价格',
  'manager.accommodations.weekendPriceDesc': '周末价格（周六至周日）',
  'manager.accommodations.weekday': '工作日',
  'manager.accommodations.weekend': '周末',
  'manager.accommodations.amenitiesDesc': '选择此住宿可用的设施（例如：壁炉、码头、厨房等）',
  'manager.accommodations.images': '图片',
  'manager.accommodations.imagesDesc': '为客户上传住宿照片',
  'manager.accommodations.uploadImages': '上传图片',
  'manager.accommodations.noAccommodations': '未找到住宿',
  'manager.accommodations.customizeColumns': '列',
  'manager.accommodations.customizeColumnsDesc': '选择要显示的列及其顺序',
  'manager.accommodations.dragToReorder': '拖动以重新排列列',
  'manager.accommodations.toggleVisibility': '点击眼睛图标以显示/隐藏',
  'manager.accommodations.showColumn': '显示列',
  'manager.accommodations.hideColumn': '隐藏列',
  'manager.accommodations.resetToDefault': '重置为默认',
  'manager.reservations.title': '预订管理',
  'manager.reservations.subtitle': '管理所有预订并跟踪其状态',
  'manager.reservations.totalReservations': '总预订数',
  'manager.reservations.confirmed': '已确认',
  'manager.reservations.pending': '待处理',
  'manager.reservations.cancelled': '已取消',
  'manager.reservations.completed': '已完成',
  'manager.reservations.totalRevenue': '总收入',
  'manager.reservations.search': '搜索预订...',
  'manager.reservations.filterByStatus': '按状态筛选',
  'manager.reservations.filterByDate': '按日期筛选',
  'manager.reservations.allStatus': '所有状态',
  'manager.reservations.guestName': '客户姓名',
  'manager.reservations.accommodation': '住宿',
  'manager.reservations.checkIn': '入住',
  'manager.reservations.checkOut': '退房',
  'manager.reservations.dates': '日期',
  'manager.reservations.guests': '人数',
  'manager.reservations.payment': '付款',
  'manager.reservations.totalPrice': '总价',
  'manager.reservations.status': '状态',
  'manager.reservations.actions': '操作',
  'manager.reservations.confirm': '确认',
  'manager.reservations.cancel': '取消',
  'manager.reservations.viewDetails': '查看详情',
  'manager.reservations.editReservation': '编辑预订',
  'manager.reports.title': '报告和分析',
  'manager.reports.subtitle': '分析性能并生成报告',
  'manager.reports.occupancyReport': '入住率报告',
  'manager.reports.revenueReport': '收入报告',
  'manager.reports.guestReport': '客户报告',
  'manager.reports.monthlyReport': '月度报告',
  'manager.reports.yearlyReport': '年度报告',
  'manager.reports.exportData': '导出数据',
  'manager.reports.generateReport': '生成报告',
  'manager.reports.selectPeriod': '选择期间',
  'manager.reports.fromDate': '开始日期',
  'manager.reports.toDate': '结束日期',
  'manager.reports.reportType': '报告类型',
  'manager.reports.occupancy': '入住率',
  'manager.reports.revenue': '收入',
  'manager.reports.guests': '客户',
  'manager.reports.activities': '活动',
  'manager.crm.title': '客户管理',
  'manager.crm.subtitle': '管理您的客户数据库及其偏好',
  'manager.crm.totalClients': '总客户数',
  'manager.crm.newClients': '新客户',
  'manager.crm.returningClients': '回头客',
  'manager.crm.vipClients': 'VIP客户',
  'manager.crm.search': '搜索客户...',
  'manager.crm.filterByType': '按类型筛选',
  'manager.crm.allTypes': '所有类型',
  'manager.crm.new': '新',
  'manager.crm.returning': '回头客',
  'manager.crm.vip': 'VIP',
  'manager.crm.clientName': '客户姓名',
  'manager.crm.email': '邮箱',
  'manager.crm.phone': '电话',
  'manager.crm.lastVisit': '上次访问',
  'manager.crm.totalBookings': '总预订数',
  'manager.crm.totalSpent': '总消费',
  'manager.crm.status': '状态',
  'manager.crm.actions': '操作',
  'manager.crm.viewProfile': '查看档案',
  'manager.crm.editClient': '编辑客户',
  'manager.crm.sendEmail': '发送邮件',
  'manager.crm.addNote': '添加备注',
  'manager.crm.clientDetails': '客户详情',
  'manager.crm.bookingHistory': '预订历史',
  'manager.crm.preferences': '偏好',
  'manager.crm.notes': '备注',
  'manager.marketing.title': '营销和促销',
  'manager.marketing.subtitle': '管理您的营销活动和促销',
  'manager.marketing.maintenanceTitle': '页面更新中',
  'manager.marketing.maintenanceBody':
    '营销模块正在改版，旧的演示界面（活动/促销）已归档，不再在此显示。',
  'manager.marketing.maintenanceBundlesHint':
    '如需管理套餐及目录（含餐饮等与套餐关联的产品），请前往「套餐」管理。',
  'manager.marketing.maintenanceBundlesLink': '打开套餐管理',
  'manager.marketing.legacyIntroTitle': '营销 — 演示（非 VUM）',
  'manager.marketing.legacyIntroBody':
    '下方为旧版演示界面（活动与虚构优惠码，与 promovalidation.com 无关）。套餐与目录请用「套餐」；站点折扣码请用「折扣」。VUM 代码请在「运营 → VUM 代码」管理。',
  'manager.marketing.search': '搜索…',
  'manager.marketing.allTypes': '全部类型',
  'manager.marketing.activeCampaigns': '活跃活动',
  'manager.marketing.totalCampaigns': '总活动数',
  'manager.marketing.emailCampaigns': '邮件活动',
  'manager.marketing.socialMedia': '社交媒体',
  'manager.marketing.promotions': '促销',
  'manager.marketing.createCampaign': '创建活动',
  'manager.marketing.createPromotion': '创建促销',
  'manager.marketing.campaignName': '活动名称',
  'manager.marketing.campaignType': '活动类型',
  'manager.marketing.startDate': '开始日期',
  'manager.marketing.endDate': '结束日期',
  'manager.marketing.status': '状态',
  'manager.marketing.actions': '操作',
  'manager.marketing.email': '邮件',
  'manager.marketing.social': '社交',
  'manager.marketing.discount': '折扣',
  'manager.marketing.specialOffer': '特别优惠',
  'manager.marketing.active': '活跃',
  'manager.marketing.paused': '暂停',
  'manager.marketing.completed': '完成',
  'manager.marketing.editCampaign': '编辑活动',
  'manager.marketing.deleteCampaign': '删除活动',
  'manager.marketing.viewStats': '查看统计',
  'manager.marketing.promotionCode': '促销代码',
  'manager.marketing.discountPercentage': '折扣百分比',
  'manager.marketing.minimumStay': '最少住宿',
  'manager.marketing.validFrom': '有效期从',
  'manager.marketing.validTo': '有效期至',
  'manager.marketing.usageLimit': '使用限制',
  'manager.marketing.usedCount': '已使用',
  'manager.marketing.remainingUses': '剩余',
  'manager.sections.operations': '运营管理',
  'manager.sections.people': '人员管理',
  'manager.sections.financial': '财务',
  'manager.sections.system': '系统管理',
  'manager.sections.archived': '已归档（稍后）',
  'manager.operations.vumCodesNav': 'VUM 代码',
  'manager.stays.title': '住宿管理',
  'manager.stays.navLabel': '住宿',
  'manager.stays.subtitle': '管理所有住宿及其可用性',
  'manager.stays.listLoading': '正在加载住宿…',
  'manager.stays.loadedFromConvex': '当前 Convex 数据库中的住宿数：{count}',
  'manager.stays.convexDeploymentProd': 'Convex 生产环境：{url}',
  'manager.stays.seasonFilterNotice': '季节筛选：显示 {shown} / {total} 个住宿。切换到「全年」可查看全部。',
  'manager.stays.addStay': '添加住宿',
  'manager.stays.totalStays': '总住宿数',
  'manager.stays.available': '可用',
  'manager.stays.unavailable': '不可用',
  'manager.stays.averagePrice': '平均价格',
  'manager.stays.name': '名称',
  'manager.stays.type': '类型',
  'manager.stays.location': '位置',
  'manager.stays.capacity': '容量',
  'manager.stays.price': '价格',
  'manager.stays.priceBeforeTax': '价格（税前）',
  'manager.stays.tpsColumn': '联邦 GST（5%）',
  'manager.stays.tvqColumn': '魁省 QST（9.975%）',
  'manager.stays.taxeHebergementColumn': '住宿税（3.50 加元/晚）',
  'manager.stays.pricingTaxSection': '定价与税费',
  'manager.stays.taxeHebergementToggle': '收取住宿税（每晚固定 3.50 加元）',
  'manager.stays.taxeHebergementHint': '勾选后，每晚加收 3.50 加元（与房价无关）；GST 与 QST 各自以（房价 + 住宿税）为基数，QST 不计入 GST。',
  'manager.stays.clientTotalColumn': '客户含税总价',
  'manager.stays.cadBeforeTax': '加元（税前）',
  'manager.stays.cadSuffix': '加元',
  'manager.stays.pricingTaxFootnote':
    '金额为示意：若启用住宿税，每晚固定 3.50 加元；GST 5% 与 QST 9.975% 各自以（房价 + 住宿税）计征，QST 不计入 GST。每步四舍五入到分。',
  'manager.stays.pricePerNight': '每晚每人价格',
  'manager.stays.pricePerNightHint': '税前价格，按每人每晚计算。仅在启用在线预订时向客人显示。',
  'manager.stays.allowReservation': '允许在线预订',
  'manager.stays.allowReservationHint': '勾选后，客人可以看到价格并预订此住宿。未勾选时仅展示住宿信息。',
  'manager.stays.allowReservationColumn': '在线预订',
  'manager.stays.availability': '可用性',
  'manager.stays.closingDates': '关闭日期',
  'manager.stays.closingDatesDesc': '设置此住宿关闭（不可预订）的日期范围。未设置的日期默认可用。',
  'manager.stays.stored': '已存储',
  'manager.stays.status': '状态',
  'manager.stays.openingPeriods': '开放期',
  'manager.stays.sales': '销售',
  'manager.stays.marketingLabels': '营销标签',
  'manager.stays.editInDetails': '详细编辑',
  'manager.stays.clickToEdit': '点击编辑',
  'manager.stays.confirmDelete': '您确定要删除此住宿吗？',
  'manager.stays.seasons': '季节',
  'manager.stays.noPeriods': '无期间',
  'manager.stays.fullYearAvailable': '全年可用',
  'manager.stays.noLabels': '无标签',
  'manager.stays.seasonName': '季节名称',
  'manager.stays.addPeriod': '添加期间',
  'manager.stays.marketingLabel.couple': '情侣',
  'manager.stays.marketingLabel.family': '家庭',
  'manager.stays.marketingLabel.corporate': '企业',
  'manager.stays.predefinedLabels': '预定义标签',
  'manager.stays.customLabels': '自定义标签',
  'manager.stays.addCustomLabel': '添加自定义标签',
  'manager.stays.basicInformation': '基本信息',
  'manager.stays.descriptionSection': '描述',
  'manager.stays.pageDescription': '页面描述',
  'manager.stays.pageDescriptionPlaceholder': '在公共页面上显示的详细描述',
  'manager.stays.zoneInMap': '地图区域',
  'manager.stays.zoneInMapLabel': '区域',
  'manager.stays.zoneInMapPlaceholder': '例如：A区、北区等',
  'manager.stays.zoneNumberLabel': '区域编号',
  'manager.stays.zoneNumberPlaceholder': '例如：12、A-3 等',
  'manager.stays.indoorChecklist': '室内清单',
  'manager.stays.outdoorChecklist': '室外清单',
  'manager.stays.kitchenEquipments': '厨房设备',
  'manager.stays.addEquipment': '添加设备',
  'manager.stays.bathroomSetup': '浴室设置',
  'manager.stays.addBathroomItem': '添加项目',
  'manager.stays.beds': '床铺',
  'manager.stays.bedType': '床型（例如：大床、双人床）',
  'manager.stays.bedCount': '数量',
  'manager.stays.petFriendly': '允许宠物',
  'manager.stays.bbq': '烧烤架',
  'manager.stays.gardenTable': '花园桌',
  'manager.stays.numberOfChairs': '椅子数量',
  'manager.stays.privateDockForBoat': '私人船坞',
  'manager.stays.images': '图片',
  'manager.stays.addImageUrl': '输入图片URL...',
  'manager.stays.image': '图片',
  'manager.stays.noImages': '未添加图片',
  'manager.stays.uploadFile': '上传文件',
  'manager.stays.enterUrl': '输入URL',
  'manager.stays.clickToUpload': '点击上传',
  'manager.stays.orDragDrop': '或拖放',
  'manager.stays.urlHint': '提示：Google Drive链接会自动转换为直接图片URL',
  'manager.stays.seasonTabs.all': '全年',
  'manager.stays.seasonTabs.summer': '夏季',
  'manager.stays.seasonTabs.winter': '冬季',
  'manager.stays.seasonSettings': '季节设置',
  'manager.stays.maintenancePeriods': '维护期间',
  'manager.stays.maintenancePeriodsDesc': '在这些期间，企业关闭，没有任何可用',
  'manager.stays.maintenanceStartDate': '开始日期',
  'manager.stays.maintenanceEndDate': '结束日期',
  'manager.stays.maintenanceDescription': '描述',
  'manager.stays.maintenanceDescriptionPlaceholder': '例如：年度关闭、翻新等',
  'manager.stays.addMaintenancePeriod': '添加维护期间',
  'manager.stays.seasonStartDate': '开始日期',
  'manager.stays.seasonEndDate': '结束日期',
  'manager.stays.winterCanSpanYears': '冬季可以跨越两年',
  'manager.stays.seasonFilter.all': '所有季节',
  'manager.stays.seasonFilter.summer': '夏季',
  'manager.stays.seasonFilter.winter': '冬季',
  'manager.stays.copyPeriod': '复制期间',
  'manager.stays.pastePeriod': '粘贴期间',
  'manager.stays.removePeriod': '删除期间',
  'manager.stays.autoDetected': '自动检测',
  'manager.stays.noPeriodCopied': '未复制期间',
  'manager.stays.unavailableDatesDesc': '设置此住宿不可预订的日期范围。未设置的日期默认可用。',
  'manager.stays.addUnavailableRange': '添加不可用范围',
  'manager.stays.allDaysAvailable': '全部日期可用',
  'manager.stays.scheduleMoreCount': '另 {{count}} 条',
  'manager.stays.archivedOpeningPeriodsTitle': '归档 — 开放期',
  'manager.stays.archivedOpeningPeriodsDesc': '开放期在此区域管理（主表之外），与侧栏中的归档项类似。',
  'manager.stays.scheduleSaveFailed': '无法保存。请检查日期后重试。若仍失败，请打开浏览器控制台（F12）查看详情。',
  'manager.activities.title': '活动管理',
  'manager.activities.navLabel': '活动',
  'manager.activities.subtitle': '管理所有活动及其可用性',
  'manager.activities.crossLinksHint': '快速链接：网站目录与套餐。',
  'manager.activities.publicCatalogLink': '网站活动目录',
  'manager.activities.bundlesLink': '套餐管理',
  'manager.food.publicForfaitsLink': '网站上的套餐',
  'manager.activities.addActivity': '添加活动',
  'manager.activities.totalActivities': '总活动数',
  'manager.activities.available': '可用',
  'manager.activities.unavailable': '不可用',
  'manager.activities.totalCapacity': '总容量',
  'manager.activities.averagePrice': '平均价格',
  'manager.activities.averagePriceBeforeTax': '平均价格（税前）',
  'manager.activities.pricingTaxFootnote':
    '标价为税前金额；GST 5% 与 QST 9.975% 各自按该价格计征，QST 不计入 GST。活动不适用住宿税。',
  'manager.activities.priceBeforeTaxLabel': '价格（税前）*',
  'manager.activities.name': '名称',
  'manager.activities.type': '类型',
  'manager.activities.duration': '持续时间',
  'manager.activities.capacity': '容量',
  'manager.activities.price': '价格',
  'manager.activities.availability': '可用性',
  'manager.activities.status': '状态',
  'manager.activities.openingPeriods': '开放期间',
  'manager.activities.sales': '销售',
  'manager.activities.marketingLabels': '营销标签',
  'manager.activities.archivedOpeningPeriodsTitle': '归档 — 活动开放期',
  'manager.activities.archivedOpeningPeriodsDesc': '活动开放期在此区域编辑，不在主表中（与住宿管理一致）。',
  'manager.activities.editInDetails': '详细编辑',
  'manager.activities.confirmDelete': '您确定要删除此活动吗？',
  'manager.activities.clickToEdit': '点击编辑',
  'manager.activities.seasons': '季节',
  'manager.activities.noPeriods': '无期间',
  'manager.activities.noLabels': '无标签',
  'manager.activities.seasonName': '季节名称',
  'manager.activities.addPeriod': '添加期间',
  'manager.activities.predefinedLabels': '预定义标签',
  'manager.activities.customLabels': '自定义标签',
  'manager.activities.addCustomLabel': '添加自定义标签',
  'manager.activities.marketingLabel.couple': '情侣',
  'manager.activities.marketingLabel.family': '家庭',
  'manager.activities.marketingLabel.corporate': '企业',
  'manager.activities.basicInformation': '基本信息',
  'manager.activities.descriptionSection': '描述',
  'manager.activities.pageDescription': '页面描述',
  'manager.activities.pageDescriptionPlaceholder': '在活动页面上显示的详细描述',
  'manager.activities.zoneInMap': '地图区域',
  'manager.activities.zoneInMapLabel': '地图区域',
  'manager.activities.zoneInMapPlaceholder': '输入地图上的区域',
  'manager.activities.equipment': '设备',
  'manager.activities.addEquipment': '添加设备',
  'manager.activities.indoorChecklist': '室内检查清单',
  'manager.activities.kitchenEquipments': '厨房设备',
  'manager.activities.bathroomSetup': '浴室设置',
  'manager.activities.beds': '床铺',
  'manager.activities.bedType': '床型',
  'manager.activities.bedCount': '数量',
  'manager.activities.petFriendly': '允许宠物',
  'manager.activities.outdoorChecklist': '室外检查清单',
  'manager.activities.bbq': '烧烤',
  'manager.activities.gardenTable': '花园桌',
  'manager.activities.numberOfChairs': '椅子数量',
  'manager.activities.privateDockForBoat': '私人船坞',
  'manager.activities.addBathroomItem': '添加项目',
  'manager.activities.typeSummer': '夏季',
  'manager.activities.typeWinter': '冬季',
  'manager.activities.typeFall': '秋季',
  'manager.activities.typeYearRound': '全年',
  'manager.activities.durationPlaceholder': '例如：4小时，全天',
  'manager.activities.seasonTabs.all': '全年',
  'manager.activities.seasonTabs.summer': '夏季',
  'manager.activities.seasonTabs.winter': '冬季',
  'manager.activities.seasonSettings': '季节设置',
  'manager.activities.seasonStartDate': '开始日期',
  'manager.activities.seasonEndDate': '结束日期',
  'manager.activities.winterCanSpanYears': '冬季可以跨越两年',
  'manager.activities.seasonFilter.all': '所有季节',
  'manager.activities.seasonFilter.summer': '夏季',
  'manager.activities.seasonFilter.winter': '冬季',
  'manager.activities.copyPeriod': '复制期间',
  'manager.activities.pastePeriod': '粘贴期间',
  'manager.activities.removePeriod': '删除期间',
  'manager.activities.autoDetected': '自动检测',
  'manager.activities.noPeriodCopied': '未复制期间',
  'manager.activities.pricingRules': '定价规则',
  'manager.activities.freeAgeGroups': '免费年龄组',
  'manager.activities.discountAgeGroups': '折扣年龄组',
  'manager.activities.minAge': '最小年龄',
  'manager.activities.maxAge': '最大年龄',
  'manager.activities.yearsOld': '岁',
  'manager.activities.discount': '折扣',
  'manager.activities.descriptionOptional': '描述（可选）',
  'manager.activities.addFreeGroup': '添加免费组',
  'manager.activities.addDiscountGroup': '添加折扣组',
  'manager.activities.includedServices': '包含的服务',
  'manager.activities.nonIncludedServices': '不包含的服务',
  'manager.activities.optionalPaidServices': '可选付费服务',
  'manager.activities.clientTypes': '客户类型',
  'manager.activities.lodging': '住宿客户',
  'manager.activities.nonLodging': '非住宿客户',
  'manager.activities.addIncludedService': '添加包含的服务',
  'manager.activities.addNonIncludedService': '添加不包含的服务',
  'manager.activities.addOptionalPaidService': '添加可选付费服务',
  'manager.food.title': '餐饮管理',
  'manager.food.navLabel': '餐饮',
  'manager.food.subtitle': '管理您的菜单和食品项目',
  'manager.food.devBannerTitle': '开发中 — 演示',
  'manager.food.devBannerBody':
    '集中餐饮管理尚未启用。下表为从套餐汇总的餐食类商品预览，操作按钮已禁用。配置餐食请使用套餐管理。',
  'manager.food.devActionDisabled': '功能启用前不可用',
  'manager.food.devMockDataNote': '来自套餐的示意预览，非最终数据。',
  'manager.food.addItem': '添加项目',
  'manager.food.totalItems': '总项目数',
  'manager.food.available': '可用',
  'manager.food.totalStock': '总库存',
  'manager.food.averagePrice': '平均价格',
  'manager.food.averagePriceBeforeTax': '平均价格（税前）',
  'manager.food.pricingTaxFootnote':
    '标价为税前金额；GST 5% 与 QST 9.975% 各自按该价格计征，QST 不计入 GST。餐饮商品不适用住宿税。',
  'manager.food.name': '名称',
  'manager.food.category': '类别',
  'manager.food.price': '价格',
  'manager.food.stock': '库存',
  'manager.food.availability': '可用性',
  'manager.food.loading': '加载中…',
  'manager.food.dataSourceTitle': '与套餐（捆绑包）同步的数据',
  'manager.food.dataSourceBody': '餐饮条目来自套餐中配置的餐食类商品。请在套餐管理中新增或修改。',
  'manager.food.openBundles': '打开套餐管理',
  'manager.food.editInBundles': '在套餐中编辑',
  'manager.food.empty': '套餐中尚无餐饮类商品。',
  'manager.bundles.title': '套餐管理',
  'manager.bundles.navLabel': '套餐',
  'manager.bundles.subtitle': '管理您的套餐和促销',
  'manager.bundles.addBundle': '添加套餐',
  'manager.bundles.totalBundles': '总套餐数',
  'manager.bundles.popular': '热门',
  'manager.bundles.averagePrice': '平均价格',
  'manager.bundles.totalCapacity': '总容量',
  'manager.bundles.name': '名称',
  'manager.bundles.description': '描述',
  'manager.bundles.price': '价格',
  'manager.bundles.maxGuests': '最大客人',
  'manager.bundles.editBundle': '编辑套餐',
  'manager.bundles.basicInformation': '基本信息',
  'manager.bundles.duration': '持续时间',
  'manager.bundles.days': '天',
  'manager.bundles.available': '可用',
  'manager.bundles.products': '产品',
  'manager.bundles.productType': '产品类型',
  'manager.bundles.stays': '住宿',
  'manager.bundles.activities': '活动',
  'manager.bundles.food': '食物',
  'manager.bundles.selectProduct': '选择产品',
  'manager.bundles.pricingType': '定价类型',
  'manager.bundles.free': '免费',
  'manager.bundles.discount': '折扣',
  'manager.bundles.discountAmount': '折扣金额',
  'manager.bundles.customPrice': '自定义价格',
  'manager.bundles.discountPercentage': '折扣百分比',
  'manager.bundles.addProduct': '添加产品',
  'manager.bundles.productAlreadyAdded': '此产品已添加',
  'manager.bundles.noProducts': '未添加产品',
  'manager.bundles.confirmDelete': '您确定要删除此套餐吗？',
  'manager.bundles.addNewProduct': '添加新产品',
  'manager.bundles.addNew': '新建',
  'manager.bundles.addNewStay': '添加新住宿',
  'manager.bundles.addNewActivity': '添加新活动',
  'manager.bundles.addNewFood': '添加新食物',
  'manager.bundles.createAndSelect': '创建并选择',
  'manager.bundles.stayNamePlaceholder': '住宿名称',
  'manager.bundles.activityNamePlaceholder': '活动名称',
  'manager.bundles.foodNamePlaceholder': '食物名称',
  'manager.bundles.openingPeriods': '开放期',
  'manager.bundles.openingPeriodsDescription': '定义此套餐可用的时间段',
  'manager.bundles.periodOfActivation': '激活期',
  'manager.bundles.periodOfActivationDescription': '定义此创建的套餐的有效范围',
  'manager.bundles.setActivationPeriod': '设置激活期',
  'manager.bundles.autoCalculated': '自动计算',
  'manager.bundles.priceCalculationNote': '价格根据添加的产品及其定价类型自动计算',
  'manager.bundles.durationCalculationNote': '持续时间根据定义的开放期自动计算',
  'manager.bundles.originalPrice': '原价',
  'manager.bundles.youSave': '您节省',
  'manager.bundles.savingsPercentage': '节省 {{percentage}}%',
  'manager.bundles.numberOfPasses': '通行证数量',
  'manager.bundles.numberOfConsumers': '消费者数量',
  'manager.bundles.matchClientGroupSize': '匹配客户组大小',
  'manager.bundles.minimumClients': '最少客户数',
  'manager.bundles.minimumClientsPlaceholder': '例如：2',
  'manager.bundles.discountTiers': '折扣层级',
  'manager.bundles.addDiscountTier': '添加折扣层级',
  'manager.bundles.minClients': '最少',
  'manager.bundles.maxClients': '最多',
  'manager.bundles.clients': '客户',
  'manager.bundles.percentage': '百分比',
  'manager.bundles.amount': '金额',
  'manager.bundles.matchesClientGroup': '匹配组',
  'manager.bundles.optional': '可选',
  'manager.bundles.packages': '套餐列表',
  'manager.bundles.calendar': '活动日历',
  'manager.bundle.calendar': '套餐日历',
  'manager.bundle.description': '计划和管理您的套餐活动',
  'manager.bundle.createNew': '创建套餐',
  'manager.bundle.editBundle': '编辑套餐',
  'manager.bundle.bundleName': '套餐名称',
  'manager.bundle.namePlaceholder': '例如：夏季冒险套餐',
  'manager.bundle.color': '颜色',
  'manager.bundle.activeBundles': '活跃套餐',
  'manager.bundle.noBundles': '暂无套餐',
  'manager.bundle.fillAllFields': '请填写所有字段',
  'manager.bundle.confirmDelete': '确定要删除此套餐吗？',
  'manager.loyalty.pageTitle': '忠诚度计划',
  'manager.loyalty.pageSubtitle': '配置积分比例及在客户仪表板上展示的等级里程碑。',
  'manager.loyalty.settingsCardSubtitle': '向客户展示的积分比例与里程碑',
  'manager.loyalty.ratioSectionTitle': '积分比例',
  'manager.loyalty.pointsPerDollarLabel': '每消费一加元可获积分（税前金额）',
  'manager.loyalty.pointsPerDollarHint': '例：1 = 每加元 1 分，2 = 每加元 2 分',
  'manager.loyalty.pointValueLabel': '每分对应的加元价值（向客户展示）',
  'manager.loyalty.pointValueHint': '例：0.10 表示每分价值 0.10 加元',
  'manager.loyalty.unitPtPerDollar': '分 / $',
  'manager.loyalty.unitCadPerPt': '加元 / 分',
  'manager.loyalty.previewLine':
    '预览：一笔 100 加元（税前）的预订可获得 {points} 分，对客户约等于 {value} 加元。',
  'manager.loyalty.milestonesTitle': '里程碑（忠诚度等级）',
  'manager.loyalty.milestonesShortTitle': '里程碑',
  'manager.loyalty.addMilestone': '添加里程碑',
  'manager.loyalty.emptyMilestones': '暂无里程碑 — 请点击「添加里程碑」创建。',
  'manager.loyalty.emptyMilestonesSettings': '暂无里程碑 — 请点击「添加」创建。',
  'manager.loyalty.thresholdPlaceholder': '积分',
  'manager.loyalty.ptsArrow': '分 →',
  'manager.loyalty.levelPlaceholder': '等级名称（如：青铜）',
  'manager.loyalty.milestonesSortHint': '保存时将按积分门槛从低到高自动排序。',
  'manager.loyalty.saveSettings': '保存设置',
  'manager.loyalty.savedSettings': '已保存 ✓',
  'manager.loyalty.saveError': '错误',
  'manager.bundles.passes': '通行证',
  'manager.bundles.consumers': '消费者',
  'manager.discount.title': '折扣管理',
  'manager.discount.navLabel': '折扣',
  'manager.discount.archivedIntroTitle': '折扣（已归档演示）',
  'manager.discount.archivedIntroBody':
    '旧版模块：虚构优惠码、满额阶梯与活动日历。数据不会写入 Convex，结账不生效。套餐与目录请用「套餐」；VUM 请用「VUM 代码」。',
  'manager.discount.subtitle': '管理您的折扣代码和促销',
  'manager.discount.addDiscount': '添加折扣',
  'manager.discount.totalDiscounts': '总折扣数',
  'manager.discount.active': '活跃',
  'manager.discount.percentage': '百分比',
  'manager.discount.fixed': '固定金额',
  'manager.discount.name': '名称',
  'manager.discount.code': '代码',
  'manager.discount.type': '类型',
  'manager.discount.value': '价值',
  'manager.discount.validFrom': '有效期从',
  'manager.discount.validTo': '有效期至',
  'manager.discount.status': '状态',
  'manager.discount.status.active': '活跃',
  'manager.discount.status.inactive': '非活跃',
  'manager.discount.status.expired': '已过期',
  'manager.discount.editDiscount': '编辑折扣',
  'manager.discount.basicInfo': '基本信息',
  'manager.discount.conditions': '条件',
  'manager.discount.validityPeriod': '有效期',
  'manager.discount.minPurchase': '最低购买额',
  'manager.discount.maxDiscount': '最大折扣',
  'manager.discount.usageLimit': '使用限制',
  'manager.discount.optional': '可选',
  'manager.discount.confirmDelete': '您确定要删除此折扣吗？',
  'manager.discount.codeManagement': '折扣代码管理',
  'manager.discount.codeManagementDescription': '为您的促销活动生成和管理折扣代码',
  'manager.discount.selectDiscount': '选择折扣',
  'manager.discount.generateCodes': '生成代码',
  'manager.discount.discountName': '折扣名称',
  'manager.discount.generatedAt': '生成时间',
  'manager.discount.usedAt': '使用时间',
  'manager.discount.copyCode': '复制代码',
  'manager.discount.codeStatus.active': '活跃',
  'manager.discount.codeStatus.used': '已使用',
  'manager.discount.codeStatus.expired': '已过期',
  'manager.discount.confirmDeleteCode': '您确定要删除此代码吗？',
  'manager.discount.volumeDiscount': '批量/条件折扣',
  'manager.discount.volumeDiscountDescription': '根据购买金额设置自动折扣',
  'manager.discount.conditionalDiscount': '条件折扣',
  'manager.discount.conditionalDiscountDescription': '根据购买金额设置自动折扣',
  'manager.discount.addVolumeDiscount': '添加批量折扣',
  'manager.discount.generalDiscount': '一般折扣',
  'manager.discount.purchaseAmount': '购买金额',
  'manager.discount.discountType': '折扣类型',
  'manager.discount.discountValue': '折扣价值',
  'manager.discount.confirmDeleteVolumeDiscount': '您确定要删除此批量折扣吗？',
  'manager.discount.regularDiscounts': '常规折扣',
  'manager.discount.seasonTabs.all': '全年',
  'manager.discount.seasonTabs.summer': '夏季',
  'manager.discount.seasonTabs.winter': '冬季',
  'manager.discount.seasonSettings': '季节设置',
  'manager.discount.effectiveProducts': '适用产品',
  'manager.discount.effectiveProductsDescription': '选择触发此条件折扣的产品',
  'manager.bookings.title': '预订（订单）',
  'manager.bookings.navLabel': '预订',
  'manager.bookings.subtitle': '住宿预订。可在下方修改付款状态。',
  'manager.bookings.totalBookings': '总预订数',
  'manager.bookings.paidBookings': '已付款',
  'manager.bookings.confirmed': '已确认',
  'manager.bookings.guest': '客户',
  'manager.bookings.accommodation': '住宿',
  'manager.bookings.checkIn': '入住',
  'manager.bookings.checkOut': '退房',
  'manager.bookings.guests': '人数',
  'manager.bookings.total': '总计',
  'manager.bookings.paid': '付款',
  'manager.bookings.status': '状态',
  'manager.bookings.noBookings': '暂无预订。',
  'manager.bookings.markPaid': '标记为已付',
  'manager.bookings.markUnpaid': '标记未付',
  'manager.orders.viewGuestProfile': '客户档案',
  'manager.orders.title': '订单管理',
  'manager.orders.navLabel': '订单',
  'manager.orders.subtitle': '管理客户订单，修改或取消产品',
  'manager.orders.addOrder': '新建订单',
  'manager.orders.addReservation': '新建订单',
  'manager.orders.backFromNewOrder': '返回订单',
  'manager.orders.backFromNewReservation': '返回订单',
  'manager.orders.newOrderPageTitle': '新建订单',
  'manager.orders.newOrderPageSubtitle':
    '为客户组合订单：添加住宿、活动与套餐，然后收款或创建无需在线支付的订单。',
  'manager.orders.newReservationPageTitle': '新建订单',
  'manager.orders.newReservationPageSubtitle':
    '为客户组合订单：添加住宿、活动与套餐，然后收款或创建无需在线支付的订单。',
  'manager.orders.sectionProducts': '产品',
  'manager.orders.sectionStayDates': '日期与人数',
  'manager.orders.stepBasicInfo': '基本信息',
  'manager.orders.stepProducts': '产品',
  'manager.orders.stepPayment': '付款',
  'manager.orders.nextStep': '下一步',
  'manager.orders.backStep': '返回',
  'manager.orders.productTabStay': '住宿',
  'manager.orders.productTabActivity': '活动',
  'manager.orders.productTabBundle': '套餐',
  'manager.orders.productTabFood': '餐饮',
  'manager.orders.stayCalendarHint':
    '先选择住宿，再用日历挑选可用日期。预订按钮会加入订单并预填入住日期。',
  'manager.orders.productType': '产品类型',
  'manager.orders.productTypeStay': '住宿',
  'manager.orders.productTypeActivity': '活动',
  'manager.orders.productTypePackage': '套餐',
  'manager.orders.selectProduct': '选择产品…',
  'manager.orders.productQuantity': '数量',
  'manager.orders.addProduct': '加入订单',
  'manager.orders.removeProduct': '移除',
  'manager.orders.noProductsYet': '尚无产品 — 请添加商品以组合订单。',
  'manager.orders.beforeTaxShort': '税前',
  'manager.orders.newOrderCustomPreTaxHint':
    '调整订单税前小计。GST、QST 及住宿税将按标准规则自动重新计算。',
  'manager.orders.newOrderErrNeedProduct': '请至少添加一件产品。',
  'manager.orders.newOrderErrNeedStay': '请至少添加一项住宿 — 保存订单所必需。',
  'manager.orders.newOrderErrDuplicateStay': '该住宿已在订单中。',
  'manager.orders.newOrderBundledItems': '订单商品',
  'manager.orders.submitWithoutCardOrder': '创建订单（不在线收款）',
  'manager.orders.paymentCardNeedOrderFirstTitle': '暂时无法显示金额与刷卡表单',
  'manager.orders.paymentCardNeedOrderFirstBody':
    '请添加产品；若订单包含住宿，请填写有效的入住与退房日期，以显示应付金额与付款表单。',
  'manager.orders.prefilledFromDashboardCalendar':
    '住宿与日期已从仪表板日历预填。请补充客户信息，然后确认或收款。',
  'manager.orders.sectionGuest': '客户',
  'manager.orders.sectionStay': '入住',
  'manager.orders.sectionPayment': '付款',
  'manager.orders.fieldFirstName': '名',
  'manager.orders.fieldLastName': '姓',
  'manager.orders.fieldEmail': '电子邮箱',
  'manager.orders.fieldPhone': '电话',
  'manager.orders.fieldAccommodation': '住宿',
  'manager.orders.selectAccommodation': '选择住宿…',
  'manager.orders.fieldCheckIn': '入住日期',
  'manager.orders.fieldCheckOut': '退房日期',
  'manager.orders.fieldAdults': '成人',
  'manager.orders.fieldChildren': '儿童',
  'manager.orders.decrementAdults': '减少成人数',
  'manager.orders.incrementAdults': '增加成人数',
  'manager.orders.decrementChildren': '减少儿童数',
  'manager.orders.incrementChildren': '增加儿童数',
  'manager.orders.guestCountCapacityHint': '该住宿最多可容纳 {count} 人。',
  'manager.orders.customizePreTaxPrice': '自定义税前金额',
  'manager.orders.customPreTaxPriceLabel': '税前金额（CAD）',
  'manager.orders.customPreTaxPriceHint': '仅调整住宿小计。GST、QST 及住宿税将按标准规则自动重新计算。',
  'manager.orders.customPreTaxPriceInvalid': '请输入有效的税前金额（0 或以上）。',
  'manager.orders.customPreTaxPriceApplied': '已应用自定义税前价格 — 税费已自动重算。',
  'manager.orders.fieldSpecialRequests': '特殊需求',
  'manager.orders.summaryNights': '晚数',
  'manager.orders.summaryTotalTTC': '含税预估总额',
  'manager.orders.summaryDepositNote': '根据 Clover 设置收取 30% 定金；余额到店支付。',
  'manager.orders.paymentOptionFull': '银行卡 — 支付全额（含 GST/QST/住宿税）',
  'manager.orders.paymentOptionLink': '发送付款链接 — 客户在其设备上通过 Clover 支付',
  'manager.orders.paymentLinkIntro':
    '将创建待确认预订，并向客户发送含 7 天有效 Clover 付款链接的安全邮件。',
  'manager.orders.sendPaymentLink': '创建并发送付款链接',
  'manager.orders.newOrderPaymentLinkSuccess': '订单已创建 — 付款链接已通过邮件发送给客户。',
  'manager.orders.paymentOptionLater': '不在线收款 — 待确认预订',
  'manager.orders.submitWithoutCard': '创建预订（不在线收款）',
  'manager.orders.paymentCardNeedStayFirstTitle': '暂时无法显示金额与刷卡表单',
  'manager.orders.paymentCardNeedStayFirstBody':
    '请先完成上方「入住」板块：选择住宿与有效的入住、退房日期（退房须晚于入住），随后会显示应付金额、银行卡字段与付款按钮。',
  'manager.orders.paymentCardFormIntro': '填写银行卡信息后，点击下方的「支付 …」按钮以保存预订并完成扣款。',
  'manager.orders.newReservationErrGuestName': '请填写客户姓名。',
  'manager.orders.newReservationErrEmail': '需要填写客户邮箱。',
  'manager.orders.newReservationErrStay': '请选择住宿。',
  'manager.orders.newReservationErrDates': '请选择入住与退房日期。',
  'manager.orders.newReservationErrDatesOrder': '退房日期必须晚于入住日期。',
  'manager.orders.newReservationErrTotals': '无法计算金额 — 请检查日期与住宿。',
  'manager.orders.newReservationErrGuests': '至少填写一位入住人。',
  'manager.orders.newReservationErrCapacity': '人数超过该住宿可容纳人数。',
  'manager.orders.totalOrders': '总订单数',
  'manager.orders.paidOrders': '已付款订单',
  'manager.orders.confirmedOrders': '已确认订单',
  'manager.orders.cancelledOrders': '已取消订单',
  'manager.orders.orderNumber': '订单号',
  'manager.orders.customer': '客户',
  'manager.orders.items': '商品',
  'manager.orders.totalAmount': '总金额',
  'manager.orders.unitPriceBeforeTax': '单价（税前）',
  'manager.orders.filterDateField': '筛选方式',
  'manager.orders.filterByStayDates': '入住日期',
  'manager.orders.filterByCreatedAt': '创建日期',
  'manager.orders.listingViewLabel': '列表视图',
  'manager.orders.listingViewCreatedAt': '预订创建时间',
  'manager.orders.listingViewStayDates': '入住/预订日期',
  'manager.orders.listingViewCreatedAtHint': '排序：最新预订优先。日期筛选按创建时间。',
  'manager.orders.listingViewStayDatesHint': '排序：今天 → 未来，然后是过去。日期筛选按入住日期。',
  'manager.orders.filterDateFrom': '从',
  'manager.orders.filterDateTo': '至',
  'manager.orders.filterDateClear': '清除日期',
  'manager.orders.filterDateResultCount': '{count} 个订单',
  'manager.orders.filterByStayDatesHint': '显示入住期间与所选日期重叠的订单（入住/退房）。',
  'manager.orders.filterByCreatedAtHint': '显示在所选期间内创建的订单。',
  'manager.orders.pricingFootnote':
    'GST、QST 与住宿税：若与订单总额一致则显示预订中已保存的金额；否则按与购物车相同的规则估算（住宿税适用时先计住宿税，再在同一应税金额上分别计 GST 与 QST；QST 不计入 GST）。客户总额为含税实收金额。',
  'manager.orders.colPreTax': '税前价',
  'manager.orders.colQst': 'QST',
  'manager.orders.colGst': 'GST',
  'manager.orders.colLodging': '住宿税',
  'manager.orders.colTotal': '含税合计',
  'manager.orders.colBalance': '待付余额',
  'manager.orders.colHearAboutUs': '来源',
  'manager.orders.colGuest': '类型',
  'manager.orders.colClientId': '客户 ID',
  'manager.orders.guestLabel': '访客',
  'manager.orders.memberLabel': '会员',
  'manager.orders.subtotalLinesBeforeTax': '小计（税前）',
  'manager.orders.status': '状态',
  'manager.orders.status.pending': '待处理',
  'manager.orders.status.paid': '已付款',
  'manager.orders.status.confirmed': '已确认',
  'manager.orders.status.cancelled': '已取消',
  'manager.orders.paymentStatus': '付款状态',
  'manager.orders.paymentStatus.unpaid': '未付款',
  'manager.orders.paymentStatus.paid': '已付款',
  'manager.orders.paymentStatus.refunded': '已退款',
  'manager.orders.createdAt': '创建时间',
  'manager.orders.editOrder': '编辑订单',
  'manager.orders.confirmOrder': '确认订单',
  'manager.orders.markAsPaid': '标记为已付款',
  'manager.orders.notifyEmployees': '通知员工',
  'manager.orders.confirmCancel': '您确定要取消此订单吗？',
  'manager.orders.orderItems': '订单商品',
  'manager.orders.productName': '产品名称',
  'manager.orders.quantity': '数量',
  'manager.orders.price': '价格',
  'manager.orders.total': '总计',
  'manager.orders.notificationMessage': '您即将向员工发送有关此已付款和已确认订单的通知。',
  'manager.orders.sendNotification': '发送通知',
  'manager.orders.notificationSent': '通知已成功发送给员工',
  'manager.orders.tabs.waiting': '等待中',
  'manager.orders.tabs.confirmed': '已确认',
  'manager.orders.tabs.completed': '已完成',
  'manager.orders.tabs.passed': '已过期',
  'manager.orders.tabs.paid': '已付款',
  'manager.orders.modifyDates': '修改日期',
  'manager.orders.updateStatus': '更新状态',
  'manager.orders.confirmByStaff': '确认（员工/管理员已处理）',
  'manager.orders.confirmStaffEmailQueued': '预订已确认，将向客人发送「预订已确认」邮件。',
  'manager.orders.confirmStaffNoGuestEmail':
    '预订已确认，但该客人没有可用邮箱 — 未发送自动邮件。请在客户档案中添加邮箱或直接联系客人。',
  'manager.orders.confirmStaffNoResendKey':
    '预订已确认，但 Convex 未配置 RESEND_API_KEY — 未发送邮件。请在部署环境变量中配置。',
  'manager.orders.noCustomerEmailHint': '无邮箱 — 无法发送确认邮件',
  'manager.orders.cancel': '取消',
  'manager.orders.startDate': '开始日期',
  'manager.orders.endDate': '结束日期',
    'manager.orders.bookingDates': '预订日期',
    'manager.orders.cancelOrder': '取消订单',
    'manager.orders.duration': '持续时间',
    'manager.orders.groups': '团体',
    'manager.orders.group': '组',
  'manager.orders.cancelWarning': '此操作将取消订单。请选择退款类型。',
  'manager.orders.refundType': '退款类型',
  'manager.orders.refund': '退款',
  'manager.orders.refundDescription': '将金额退还给客户',
  'manager.orders.refundAsCredit': '退款为积分',
  'manager.orders.refundAsCreditDescription': '将金额转换为客户积分',
  'manager.orders.cancelReason': '取消原因',
  'manager.orders.cancelReasonPlaceholder': '取消原因（可选）',
  'manager.orders.refundAmount': '退款金额',
  'manager.orders.paymentStatus.downpayment': '首付（30%）',
  'manager.orders.paymentStatus.refundedAsCredit': '已退款为积分',
  'manager.orders.status.completed': '已完成',
  'manager.orders.status.passed': '已过期',
  'manager.orders.downpaymentAmount': '首付金额',
  'manager.orders.downpaymentPercentage': '首付百分比',
  'manager.orders.remainingAmount': '剩余金额',
  'manager.orders.selectInformation': '选择要包含的信息',
  'manager.orders.customMessage': '自定义消息',
  'manager.orders.customMessagePlaceholder': '为员工添加自定义消息...',
  'manager.orders.preview': '预览',
  'manager.orders.message': '消息',
  'manager.orders.customerEmail': '客户邮箱',
  'manager.orders.optional': '可选',
  'manager.orders.tabs.all': '全部',
  'manager.orders.tabs.emailTemplates': '邮件模板',
  'manager.orders.emailTemplates.title': '邮件模板',
  'manager.orders.emailTemplates.description': '自定义通过 Resend 发送的邮件模板（如预订确认）。使用以下变量。',
  'manager.orders.emailTemplates.bookingConfirmationDesc': '新预订后自动发送。',
  'manager.orders.emailTemplates.variables': '变量',
  'manager.orders.emailTemplates.editTemplate': '编辑模板',
  'manager.orders.emailTemplates.templateName': '模板名称',
  'manager.orders.emailTemplates.subject': '主题',
  'manager.orders.emailTemplates.htmlBody': 'HTML 正文',
  'manager.orders.emailTemplates.textBody': '纯文本正文',
  'manager.orders.emailTemplates.sendTest': '发送测试',
  'manager.orders.emailTemplates.testTitle': '发送测试邮件',
  'manager.orders.emailTemplates.testDescription': '向下方地址发送包含示例数据的邮件（通过 Resend）。请先保存模板。',
  'manager.orders.emailTemplates.testTo': '发送至',
  'manager.orders.emailTemplates.sending': '发送中…',
  'manager.orders.emailTemplates.testSent': '测试邮件已发送，请查收。',
  'manager.orders.emailTemplates.saveFirst': '请先保存模板（编辑后保存）再发送测试。',
  'manager.orders.notifyClient': '通知客户',
  'manager.orders.clientNotificationSent': '通知已成功发送给客户',
  'manager.orders.communicationTemplates': '沟通模板',
  'manager.orders.communicationTemplatesDescription': '创建和管理用于客户沟通的消息模板',
  'manager.orders.createTemplate': '创建模板',
  'manager.orders.editTemplate': '编辑模板',
  'manager.orders.templateName': '模板名称',
  'manager.orders.communicationMethod': '沟通方式',
  'manager.orders.method.email': '邮件',
  'manager.orders.method.sms': '短信',
  'manager.orders.method.both': '邮件和短信',
  'manager.orders.trigger': '触发条件',
  'manager.orders.trigger.onConfirmation': '确认时',
  'manager.orders.trigger.onPayment': '付款时',
  'manager.orders.trigger.onReminder': '提醒时',
  'manager.orders.trigger.custom': '自定义',
  'manager.orders.subject': '主题',
  'manager.orders.subjectPlaceholder': '消息主题',
  'manager.orders.content': '内容',
  'manager.orders.contentPlaceholder': '消息内容...',
  'manager.orders.contentVariables': '可用变量',
  'manager.orders.recentCommunications': '最近沟通',
  'manager.orders.sendMessage': '发送消息',
  'manager.orders.selectTemplate': '选择模板',
  'manager.orders.noTemplate': '无模板',
  'manager.orders.messagePlaceholder': '您的消息...',
  'manager.orders.messagePreview': '消息预览将显示在这里',
  'manager.orders.sendAsReminder': '作为提醒发送',
  'manager.orders.to': '发送至',
  'manager.orders.templates.orderConfirmation': '订单确认',
  'manager.orders.templates.confirmationSubject': '您的订单 {orderNumber} 确认',
  'manager.orders.templates.confirmationContent': '您好 {customerName}，\\n\\n我们确认您的订单 {orderNumber}，金额为 {totalAmount}。\\n\\n感谢您的信任！',
  'manager.orders.templates.paymentReminder': '付款提醒',
  'manager.orders.templates.reminderSubject': '提醒：订单 {orderNumber} 的付款',
  'manager.orders.templates.reminderContent': '您好 {customerName}，\\n\\n这是关于您的订单 {orderNumber}（金额 {totalAmount}）的付款提醒。\\n\\n请完成您的付款。',
  'manager.orders.templates.bookingReminder': '预订提醒',
  'manager.orders.templates.bookingReminderSubject': '提醒：您的预订即将到来',
  'manager.orders.templates.bookingReminderContent': '您好 {customerName}，\\n\\n我们提醒您关于订单 {orderNumber} 的预订。\\n\\n我们期待您的到来！',
  'manager.orders.templates.newTemplate': '新模板',
  'manager.clients.navLabel': '客户',
  'manager.clients.title': '客户管理',
  'manager.clients.subtitle': '管理您的访客和注册会员客户',
  'manager.clients.guest': '访客',
  'manager.clients.member': '会员',
  'manager.clients.totalGuests': '访客总数',
  'manager.clients.totalMembers': '会员总数',
  'manager.clients.totalPurchases': '总购买数',
  'manager.clients.totalRevenue': '总收入',
  'manager.clients.vipMembers': 'VIP会员',
  'manager.clients.name': '姓名',
  'manager.clients.contact': '联系方式',
  'manager.clients.purchases': '购买记录',
  'manager.clients.totalSpent': '总支出',
  'manager.clients.lastPurchase': '最后购买',
  'manager.clients.email': '邮箱',
  'manager.clients.phone': '电话',
  'manager.clients.registeredAt': '注册时间',
  'manager.clients.lastLogin': '最后登录',
  'manager.clients.totalBookings': '总预订数',
  'manager.clients.status': '状态',
  'manager.clients.status.active': '活跃',
  'manager.clients.status.inactive': '非活跃',
  'manager.clients.type.new': '新用户',
  'manager.clients.type.returning': '回头客',
  'manager.clients.type.vip': 'VIP',
  'manager.clients.purchaseStatus.completed': '已完成',
  'manager.clients.purchaseStatus.pending': '待处理',
  'manager.clients.purchaseStatus.cancelled': '已取消',
  'manager.clients.noContact': '无联系方式',
  'manager.clients.search': '搜索...',
  'manager.clients.guestList': '访客列表',
  'manager.clients.memberList': '会员列表',
  'manager.clients.addGuest': '添加访客',
  'manager.employees.title': '员工管理',
  'manager.employees.navLabel': '员工',
  'manager.employees.subtitle': '管理您的团队及其信息',
  'manager.employees.addEmployee': '添加员工',
  'manager.employees.totalEmployees': '总员工数',
  'manager.employees.active': '活跃',
  'manager.employees.inactive': '非活跃',
  'manager.employees.departments': '部门',
  'manager.employees.name': '名称',
  'manager.employees.email': '电子邮件',
  'manager.employees.phone': '电话',
  'manager.employees.role': '角色',
  'manager.employees.department': '部门',
  'manager.employees.status': '状态',
  'manager.financial.title': '财务管理',
  'manager.financial.navLabel': '财务',
  'manager.financial.subtitle': '跟踪您的收入和支出',
  'manager.financial.addTransaction': '添加交易',
  'manager.financial.export': '导出',
  'manager.financial.totalIncome': '总收入',
  'manager.financial.totalExpenses': '总支出',
  'manager.financial.netProfit': '净利润',
  'manager.financial.pendingTransactions': '待处理交易',
  'manager.financial.date': '日期',
  'manager.financial.type': '类型',
  'manager.financial.category': '类别',
  'manager.financial.description': '描述',
  'manager.financial.amount': '金额',
  'manager.financial.status': '状态',
  'manager.financial.income': '收入',
  'manager.financial.expense': '支出',
  'manager.financial.completed': '已完成',
  'manager.financial.pending': '待处理',
  'manager.financial.viewDetails': '查看详情',
  'manager.financial.download': '下载',
  'manager.financial.category.reservations': '预订',
  'manager.financial.category.maintenance': '维护',
  'manager.financial.category.activities': '活动',
  'manager.financial.category.supplies': '用品',
  'manager.reports.navLabel': '报告',
  'manager.reports.pageTitle': '报告与分析',
  'manager.reports.pageSubtitle': '跟踪度假营地经营表现',
  'manager.reports.devBannerTitle': '开发中 — 尚未启用',
  'manager.reports.devBannerBody':
    '报告与导出功能尚未启用。下方为演示与模拟数据；按钮与操作不会连接正式环境。',
  'manager.reports.devActionDisabled': '功能启用前不可用',
  'manager.reports.devMockDataNote': '仅为演示数据。',
  'manager.reports.export': '导出',
  'manager.reports.refresh': '刷新',
  'manager.reports.periodLabel': '周期：',
  'manager.reports.reportLabel': '报告：',
  'manager.reports.period.week': '本周',
  'manager.reports.period.month': '本月',
  'manager.reports.period.quarter': '本季度',
  'manager.reports.period.year': '本年',
  'manager.reports.type.revenue': '收入',
  'manager.reports.type.occupancy': '入住率',
  'manager.reports.type.reservations': '预订',
  'manager.reports.type.performance': '表现',
  'manager.reports.metric.revenue': '收入',
  'manager.reports.metric.occupancyRate': '入住率',
  'manager.reports.metric.reservations': '预订数',
  'manager.reports.metric.averageRate': '平均房价',
  'manager.reports.vsLastMonth': '对比上月',
  'manager.reports.section.revenueTrend': '收入走势',
  'manager.reports.legend.revenue': '收入',
  'manager.reports.section.occupancyChart': '入住率',
  'manager.reports.legend.occupancy': '入住率',
  'manager.reports.section.perAccommodation': '各住宿表现',
  'manager.reports.viewAll': '查看全部',
  'manager.reports.col.accommodation': '住宿',
  'manager.reports.col.revenue': '收入',
  'manager.reports.col.occupancy': '入住率',
  'manager.reports.col.nights': '间夜',
  'manager.reports.col.performance': '表现',
  'manager.reports.performance.excellent': '优秀',
  'manager.reports.performance.good': '良好',
  'manager.reports.performance.needsImprovement': '待提升',
  'manager.reports.exportTitle': '导出报告',
  'manager.reports.exportDesc': '以 Excel 或 PDF 下载数据，便于详细跟进',
  'manager.reports.exportExcel': '导出为 Excel',
  'manager.reports.exportPdf': '导出为 PDF',
  'manager.reports.demoMonth.jan': '1月',
  'manager.reports.demoMonth.feb': '2月',
  'manager.reports.demoMonth.mar': '3月',
  'manager.reports.demoMonth.apr': '4月',
  'manager.reports.demoMonth.may': '5月',
  'manager.reports.demoMonth.jun': '6月',
  'manager.reminders.title': '提醒管理',
  'manager.reminders.navLabel': '提醒',
  'manager.reminders.subtitle': '管理您的提醒和任务',
  'manager.reminders.devBannerTitle': '开发中 — 尚未启用',
  'manager.reminders.devBannerBody':
    '提醒自动化功能尚未启用。下方为演示与模拟数据；按钮与操作不会连接正式环境。',
  'manager.reminders.devActionDisabled': '功能启用前不可用',
  'manager.reminders.devMockDataNote': '仅为演示数据。',
  'manager.reminders.addReminder': '添加提醒',
  'manager.reminders.totalReminders': '总提醒数',
  'manager.reminders.pending': '待处理',
  'manager.reminders.completed': '已完成',
  'manager.reminders.highPriority': '高优先级',
  'manager.reminders.type': '类型',
  'manager.reminders.dueDate': '到期日期',
  'manager.reminders.priority': '优先级',
  'manager.reminders.status': '状态',
  'manager.reminders.assignedTo': '分配给',
  'manager.reminders.type.maintenance': '维护',
  'manager.reminders.type.payment': '付款',
  'manager.reminders.type.reservation': '预订',
  'manager.reminders.type.other': '其他',
  'manager.reminders.priority.high': '高',
  'manager.reminders.priority.medium': '中',
  'manager.reminders.priority.low': '低',
  'manager.marketing.navLabel': '营销',
  'manager.web.title': '网站管理',
  'manager.web.navLabel': '网站',
  'manager.web.subtitle': '管理您的网站内容',
  'manager.web.bookingEmailsHint': '预订确认与提醒等自动邮件在「订单 → 邮件模板」中配置。',
  'manager.web.landingPage': '首页',
  'manager.web.landingPageDesc': '管理首页内容',
  'manager.web.content': '内容',
  'manager.web.contentDesc': '管理文本和描述',
  'manager.web.media': '媒体',
  'manager.web.mediaDesc': '管理图片和视频',
  'manager.web.settings': '设置',
  'manager.web.settingsDesc': '配置网站设置',
  'manager.media.navLabel': '照片',
  'manager.media.title': '照片',
  'manager.media.subtitle': '上传压缩后的照片到网站相册、住宿或活动。',
  'manager.media.uploadSection': '上传',
  'manager.media.placement': '关联到',
  'manager.media.placementGallery': '网站相册',
  'manager.media.placementStay': '住宿',
  'manager.media.placementActivity': '活动',
  'manager.media.optionalTitle': '标题（可选）',
  'manager.media.titlePlaceholder': '例如：湖上日落',
  'manager.media.compressLabel': '上传前压缩',
  'manager.media.compressHint': '建议用于手机大图（常达 10–15 MB）。减小体积并尽量保持画质。',
  'manager.media.quality': '质量',
  'manager.media.maxEdge': '最长边（像素）',
  'manager.media.recommended': '推荐',
  'manager.media.dropHint': '拖放照片到此处或点击选择',
  'manager.media.formats': 'JPEG、PNG、WebP（浏览器支持时也可 HEIC）',
  'manager.media.uploading': '正在压缩并上传…',
  'manager.media.statusCompressing': '压缩中',
  'manager.media.statusUploading': '上传中',
  'manager.media.statusDone': '完成',
  'manager.media.statusError': '错误',
  'manager.media.library': '图库',
  'manager.media.empty': '暂无照片。',
  'manager.media.untitled': '未命名',
  'manager.media.changePlacement': '更改关联',
  'manager.media.confirmDelete': '删除这张照片？',
  'manager.media.selectStay': '请先选择住宿。',
  'manager.media.selectActivity': '请先选择活动。',
  'manager.media.imagesOnly': '请选择图片文件。',
  'manager.media.readyToUpload': '准备上传',
  'manager.media.confirmUpload': '确认上传',
  'manager.media.clearSelection': '清除选择',
  'manager.settings.title': '设置',
  'manager.settings.navLabel': '设置',
  'manager.settings.subtitle': '配置系统设置',
  'manager.settings.general': '常规',
  'manager.settings.generalDesc': '常规应用程序设置',
  'manager.settings.notifications': '通知',
  'manager.settings.notificationsDesc': '配置通知',
  'manager.settings.security': '安全',
  'manager.settings.securityDesc': '安全和访问设置',
  'manager.settings.localization': '本地化',
  'manager.settings.localizationDesc': '语言和格式',
  'manager.settings.payment': '支付',
  'manager.settings.paymentDesc': '支付配置',
  'manager.settings.users': '用户',
  'manager.settings.usersDesc': '用户和权限管理',
  'manager.settings.backup': '备份',
  'manager.settings.backupDesc': '备份和恢复'
},
};
